// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,json_types=true"
// @generated from file identities/v1/identities.proto (package identities.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_common_v1_annotations } from "../../common/v1/annotations_pb";
import { file_common_v1_events } from "../../common/v1/events_pb";
import type { PaginationArguments, PaginationArgumentsJson, PaginationPageInfo, PaginationPageInfoJson } from "../../common/v1/pagination_pb";
import { file_common_v1_pagination } from "../../common/v1/pagination_pb";
import { file_google_api_annotations } from "../../google/api/annotations_pb";
import type { FieldMask, FieldMaskJson, StructJson, Timestamp, TimestampJson, Value, ValueJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { AuthData, AuthDataJson, Context, ContextJson, ErrMsg, ErrMsgJson, FronteggUser, FronteggUserJson, InviteCreatedPrehookRequestSchema, InviteCreatedPrehookResponseSchema, PrehookInvitationContext, PrehookInvitationContextJson, SamlResponse, SamlResponseJson, SCIMHookRequestSchema, SCIMHookResponseSchema } from "./frontegg_pb";
import { file_identities_v1_frontegg } from "./frontegg_pb";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file identities/v1/identities.proto.
 */
export const file_identities_v1_identities: GenFile =
	/*@__PURE__*/
	fileDesc(
		"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",
		[file_common_v1_annotations, file_common_v1_events, file_common_v1_pagination, file_google_api_annotations, file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_protobuf_timestamp, file_identities_v1_frontegg],
	);

/**
 * User represents the User or tier ex: Free Pro Enterprise
 *
 * @generated from message identities.v1.User
 */
export type User = Message<"identities.v1.User"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name: string;

	/**
	 * @generated from field: string first_name = 3;
	 */
	firstName: string;

	/**
	 * @generated from field: string last_name = 4;
	 */
	lastName: string;

	/**
	 * @generated from field: string email = 5;
	 */
	email: string;

	/**
	 * @generated from field: string external_auth_id = 6;
	 */
	externalAuthId: string;

	/**
	 * @generated from field: string phone_number = 7;
	 */
	phoneNumber: string;

	/**
	 * @generated from field: string referral_short_url = 8;
	 */
	referralShortUrl: string;

	/**
	 * @generated from field: string photo_url = 9;
	 */
	photoUrl: string;

	/**
	 * @generated from field: string timezone = 15;
	 */
	timezone: string;

	/**
	 * @generated from field: repeated identities.v1.Member members = 10;
	 */
	members: Member[];

	/**
	 * @generated from field: google.protobuf.Timestamp last_login_time = 11;
	 */
	lastLoginTime?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 12;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 13;
	 */
	updatedAt?: Timestamp | undefined;

	/**
	 * @generated from field: optional google.protobuf.Timestamp deleted_at = 14;
	 */
	deletedAt?: Timestamp | undefined;
};

/**
 * User represents the User or tier ex: Free Pro Enterprise
 *
 * @generated from message identities.v1.User
 */
export type UserJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name?: string;

	/**
	 * @generated from field: string first_name = 3;
	 */
	firstName?: string;

	/**
	 * @generated from field: string last_name = 4;
	 */
	lastName?: string;

	/**
	 * @generated from field: string email = 5;
	 */
	email?: string;

	/**
	 * @generated from field: string external_auth_id = 6;
	 */
	externalAuthId?: string;

	/**
	 * @generated from field: string phone_number = 7;
	 */
	phoneNumber?: string;

	/**
	 * @generated from field: string referral_short_url = 8;
	 */
	referralShortUrl?: string;

	/**
	 * @generated from field: string photo_url = 9;
	 */
	photoUrl?: string;

	/**
	 * @generated from field: string timezone = 15;
	 */
	timezone?: string;

	/**
	 * @generated from field: repeated identities.v1.Member members = 10;
	 */
	members?: MemberJson[];

	/**
	 * @generated from field: google.protobuf.Timestamp last_login_time = 11;
	 */
	lastLoginTime?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 12;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 13;
	 */
	updatedAt?: TimestampJson;

	/**
	 * @generated from field: optional google.protobuf.Timestamp deleted_at = 14;
	 */
	deletedAt?: TimestampJson;
};

/**
 * Describes the message identities.v1.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User, { jsonType: UserJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 0);

/**
 * @generated from message identities.v1.UserFilter
 */
export type UserFilter = Message<"identities.v1.UserFilter"> & {
	/**
	 * @generated from field: optional string first_name = 1;
	 */
	firstName?: string | undefined;

	/**
	 * @generated from field: optional string last_name = 2;
	 */
	lastName?: string | undefined;

	/**
	 * @generated from field: optional string email = 3;
	 */
	email?: string | undefined;

	/**
	 * @generated from field: optional identities.v1.MemberType memberable_type = 4;
	 */
	memberableType?: MemberType | undefined;

	/**
	 * @generated from field: optional string memberable_id = 5;
	 */
	memberableId?: string | undefined;

	/**
	 * @generated from field: optional string name = 6;
	 */
	name?: string | undefined;

	/**
	 * @generated from field: optional identities.v1.InvitationStatus status = 7;
	 */
	status?: InvitationStatus | undefined;

	/**
	 * @generated from field: optional string exact_email = 8;
	 */
	exactEmail?: string | undefined;
};

/**
 * @generated from message identities.v1.UserFilter
 */
export type UserFilterJson = {
	/**
	 * @generated from field: optional string first_name = 1;
	 */
	firstName?: string;

	/**
	 * @generated from field: optional string last_name = 2;
	 */
	lastName?: string;

	/**
	 * @generated from field: optional string email = 3;
	 */
	email?: string;

	/**
	 * @generated from field: optional identities.v1.MemberType memberable_type = 4;
	 */
	memberableType?: MemberTypeJson;

	/**
	 * @generated from field: optional string memberable_id = 5;
	 */
	memberableId?: string;

	/**
	 * @generated from field: optional string name = 6;
	 */
	name?: string;

	/**
	 * @generated from field: optional identities.v1.InvitationStatus status = 7;
	 */
	status?: InvitationStatusJson;

	/**
	 * @generated from field: optional string exact_email = 8;
	 */
	exactEmail?: string;
};

/**
 * Describes the message identities.v1.UserFilter.
 * Use `create(UserFilterSchema)` to create a new message.
 */
export const UserFilterSchema: GenMessage<UserFilter, { jsonType: UserFilterJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 1);

/**
 * GetUserRequest is the request object to get a user by id
 *
 * @generated from message identities.v1.GetUserRequest
 */
export type GetUserRequest = Message<"identities.v1.GetUserRequest"> & {
	/**
	 * @generated from field: string user_id = 1;
	 */
	userId: string;
};

/**
 * GetUserRequest is the request object to get a user by id
 *
 * @generated from message identities.v1.GetUserRequest
 */
export type GetUserRequestJson = {
	/**
	 * @generated from field: string user_id = 1;
	 */
	userId?: string;
};

/**
 * Describes the message identities.v1.GetUserRequest.
 * Use `create(GetUserRequestSchema)` to create a new message.
 */
export const GetUserRequestSchema: GenMessage<GetUserRequest, { jsonType: GetUserRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 2);

/**
 * GetUserResponse
 *
 * @generated from message identities.v1.GetUserResponse
 */
export type GetUserResponse = Message<"identities.v1.GetUserResponse"> & {
	/**
	 * @generated from field: identities.v1.User user = 1;
	 */
	user?: User | undefined;
};

/**
 * GetUserResponse
 *
 * @generated from message identities.v1.GetUserResponse
 */
export type GetUserResponseJson = {
	/**
	 * @generated from field: identities.v1.User user = 1;
	 */
	user?: UserJson;
};

/**
 * Describes the message identities.v1.GetUserResponse.
 * Use `create(GetUserResponseSchema)` to create a new message.
 */
export const GetUserResponseSchema: GenMessage<GetUserResponse, { jsonType: GetUserResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 3);

/**
 * GetUsersByIds is the request object to get a group of users by ids
 *
 * @generated from message identities.v1.GetUsersByIdsRequest
 */
export type GetUsersByIdsRequest = Message<"identities.v1.GetUsersByIdsRequest"> & {
	/**
	 * @generated from field: repeated string ids = 1;
	 */
	ids: string[];
};

/**
 * GetUsersByIds is the request object to get a group of users by ids
 *
 * @generated from message identities.v1.GetUsersByIdsRequest
 */
export type GetUsersByIdsRequestJson = {
	/**
	 * @generated from field: repeated string ids = 1;
	 */
	ids?: string[];
};

/**
 * Describes the message identities.v1.GetUsersByIdsRequest.
 * Use `create(GetUsersByIdsRequestSchema)` to create a new message.
 */
export const GetUsersByIdsRequestSchema: GenMessage<GetUsersByIdsRequest, { jsonType: GetUsersByIdsRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 4);

/**
 * @generated from message identities.v1.GetUsersByIdsResponse
 */
export type GetUsersByIdsResponse = Message<"identities.v1.GetUsersByIdsResponse"> & {
	/**
	 * @generated from field: repeated identities.v1.User items = 1;
	 */
	items: User[];
};

/**
 * @generated from message identities.v1.GetUsersByIdsResponse
 */
export type GetUsersByIdsResponseJson = {
	/**
	 * @generated from field: repeated identities.v1.User items = 1;
	 */
	items?: UserJson[];
};

/**
 * Describes the message identities.v1.GetUsersByIdsResponse.
 * Use `create(GetUsersByIdsResponseSchema)` to create a new message.
 */
export const GetUsersByIdsResponseSchema: GenMessage<GetUsersByIdsResponse, { jsonType: GetUsersByIdsResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 5);

/**
 * ListUsersRequest is an empty object, later we can fill it with filtering options
 *
 * @generated from message identities.v1.ListUsersRequest
 */
export type ListUsersRequest = Message<"identities.v1.ListUsersRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from oneof identities.v1.ListUsersRequest.optional_id
	 */
	optionalId:
		| {
				/**
				 * @generated from field: string workspace_id = 2;
				 */
				value: string;
				case: "workspaceId";
		  }
		| {
				/**
				 * @generated from field: string team_id = 3;
				 */
				value: string;
				case: "teamId";
		  }
		| { case: undefined; value?: undefined };

	/**
	 * @generated from field: identities.v1.UserFilter filter = 4;
	 */
	filter?: UserFilter | undefined;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 5;
	 */
	paginate?: PaginationArguments | undefined;
};

/**
 * ListUsersRequest is an empty object, later we can fill it with filtering options
 *
 * @generated from message identities.v1.ListUsersRequest
 */
export type ListUsersRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string team_id = 3;
	 */
	teamId?: string;

	/**
	 * @generated from field: identities.v1.UserFilter filter = 4;
	 */
	filter?: UserFilterJson;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 5;
	 */
	paginate?: PaginationArgumentsJson;
};

/**
 * Describes the message identities.v1.ListUsersRequest.
 * Use `create(ListUsersRequestSchema)` to create a new message.
 */
export const ListUsersRequestSchema: GenMessage<ListUsersRequest, { jsonType: ListUsersRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 6);

/**
 * @generated from message identities.v1.GetUserExistsRequest
 */
export type GetUserExistsRequest = Message<"identities.v1.GetUserExistsRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message identities.v1.GetUserExistsRequest
 */
export type GetUserExistsRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message identities.v1.GetUserExistsRequest.
 * Use `create(GetUserExistsRequestSchema)` to create a new message.
 */
export const GetUserExistsRequestSchema: GenMessage<GetUserExistsRequest, { jsonType: GetUserExistsRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 7);

/**
 * @generated from message identities.v1.GetUserExistsResponse
 */
export type GetUserExistsResponse = Message<"identities.v1.GetUserExistsResponse"> & {
	/**
	 * @generated from field: bool exists = 1;
	 */
	exists: boolean;
};

/**
 * @generated from message identities.v1.GetUserExistsResponse
 */
export type GetUserExistsResponseJson = {
	/**
	 * @generated from field: bool exists = 1;
	 */
	exists?: boolean;
};

/**
 * Describes the message identities.v1.GetUserExistsResponse.
 * Use `create(GetUserExistsResponseSchema)` to create a new message.
 */
export const GetUserExistsResponseSchema: GenMessage<GetUserExistsResponse, { jsonType: GetUserExistsResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 8);

/**
 * ListUsersResponse returns an array of users
 *
 * @generated from message identities.v1.ListUsersResponse
 */
export type ListUsersResponse = Message<"identities.v1.ListUsersResponse"> & {
	/**
	 * @generated from field: repeated identities.v1.User items = 1;
	 */
	items: User[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * ListUsersResponse returns an array of users
 *
 * @generated from message identities.v1.ListUsersResponse
 */
export type ListUsersResponseJson = {
	/**
	 * @generated from field: repeated identities.v1.User items = 1;
	 */
	items?: UserJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message identities.v1.ListUsersResponse.
 * Use `create(ListUsersResponseSchema)` to create a new message.
 */
export const ListUsersResponseSchema: GenMessage<ListUsersResponse, { jsonType: ListUsersResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 9);

/**
 * ListAdminUsersRequest is an empty object, later we can fill it with filtering options
 *
 * @generated from message identities.v1.ListAdminUsersRequest
 */
export type ListAdminUsersRequest = Message<"identities.v1.ListAdminUsersRequest"> & {
	/**
	 * @generated from field: identities.v1.UserFilter filter = 4;
	 */
	filter?: UserFilter | undefined;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 5;
	 */
	paginate?: PaginationArguments | undefined;
};

/**
 * ListAdminUsersRequest is an empty object, later we can fill it with filtering options
 *
 * @generated from message identities.v1.ListAdminUsersRequest
 */
export type ListAdminUsersRequestJson = {
	/**
	 * @generated from field: identities.v1.UserFilter filter = 4;
	 */
	filter?: UserFilterJson;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 5;
	 */
	paginate?: PaginationArgumentsJson;
};

/**
 * Describes the message identities.v1.ListAdminUsersRequest.
 * Use `create(ListAdminUsersRequestSchema)` to create a new message.
 */
export const ListAdminUsersRequestSchema: GenMessage<ListAdminUsersRequest, { jsonType: ListAdminUsersRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 10);

/**
 * ListAdminUsersResponse returns an array of users
 *
 * @generated from message identities.v1.ListAdminUsersResponse
 */
export type ListAdminUsersResponse = Message<"identities.v1.ListAdminUsersResponse"> & {
	/**
	 * @generated from field: repeated identities.v1.User items = 1;
	 */
	items: User[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * ListAdminUsersResponse returns an array of users
 *
 * @generated from message identities.v1.ListAdminUsersResponse
 */
export type ListAdminUsersResponseJson = {
	/**
	 * @generated from field: repeated identities.v1.User items = 1;
	 */
	items?: UserJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message identities.v1.ListAdminUsersResponse.
 * Use `create(ListAdminUsersResponseSchema)` to create a new message.
 */
export const ListAdminUsersResponseSchema: GenMessage<ListAdminUsersResponse, { jsonType: ListAdminUsersResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 11);

/**
 * ListUserCandidatesRequest is an empty object, later we can fill it with filtering options
 *
 * @generated from message identities.v1.ListUserCandidatesRequest
 */
export type ListUserCandidatesRequest = Message<"identities.v1.ListUserCandidatesRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from oneof identities.v1.ListUserCandidatesRequest.optional_id
	 */
	optionalId:
		| {
				/**
				 * @generated from field: string workspace_id = 2;
				 */
				value: string;
				case: "workspaceId";
		  }
		| {
				/**
				 * @generated from field: string team_id = 3;
				 */
				value: string;
				case: "teamId";
		  }
		| { case: undefined; value?: undefined };

	/**
	 * @generated from field: identities.v1.UserFilter filter = 4;
	 */
	filter?: UserFilter | undefined;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 5;
	 */
	paginate?: PaginationArguments | undefined;
};

/**
 * ListUserCandidatesRequest is an empty object, later we can fill it with filtering options
 *
 * @generated from message identities.v1.ListUserCandidatesRequest
 */
export type ListUserCandidatesRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string team_id = 3;
	 */
	teamId?: string;

	/**
	 * @generated from field: identities.v1.UserFilter filter = 4;
	 */
	filter?: UserFilterJson;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 5;
	 */
	paginate?: PaginationArgumentsJson;
};

/**
 * Describes the message identities.v1.ListUserCandidatesRequest.
 * Use `create(ListUserCandidatesRequestSchema)` to create a new message.
 */
export const ListUserCandidatesRequestSchema: GenMessage<ListUserCandidatesRequest, { jsonType: ListUserCandidatesRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 12);

/**
 * ListUserCandidatesResponse returns an array of users
 *
 * @generated from message identities.v1.ListUserCandidatesResponse
 */
export type ListUserCandidatesResponse = Message<"identities.v1.ListUserCandidatesResponse"> & {
	/**
	 * @generated from field: repeated identities.v1.User items = 1;
	 */
	items: User[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * ListUserCandidatesResponse returns an array of users
 *
 * @generated from message identities.v1.ListUserCandidatesResponse
 */
export type ListUserCandidatesResponseJson = {
	/**
	 * @generated from field: repeated identities.v1.User items = 1;
	 */
	items?: UserJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message identities.v1.ListUserCandidatesResponse.
 * Use `create(ListUserCandidatesResponseSchema)` to create a new message.
 */
export const ListUserCandidatesResponseSchema: GenMessage<ListUserCandidatesResponse, { jsonType: ListUserCandidatesResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 13);

/**
 * ListUsersWithAccessRequest
 *
 * @generated from message identities.v1.ListUsersWithAccessRequest
 */
export type ListUsersWithAccessRequest = Message<"identities.v1.ListUsersWithAccessRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: identities.v1.UserFilter filter = 3;
	 */
	filter?: UserFilter | undefined;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 4;
	 */
	paginate?: PaginationArguments | undefined;
};

/**
 * ListUsersWithAccessRequest
 *
 * @generated from message identities.v1.ListUsersWithAccessRequest
 */
export type ListUsersWithAccessRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: identities.v1.UserFilter filter = 3;
	 */
	filter?: UserFilterJson;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 4;
	 */
	paginate?: PaginationArgumentsJson;
};

/**
 * Describes the message identities.v1.ListUsersWithAccessRequest.
 * Use `create(ListUsersWithAccessRequestSchema)` to create a new message.
 */
export const ListUsersWithAccessRequestSchema: GenMessage<ListUsersWithAccessRequest, { jsonType: ListUsersWithAccessRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 14);

/**
 * ListUsersWithAccessResponse returns an array of users
 *
 * @generated from message identities.v1.ListUsersWithAccessResponse
 */
export type ListUsersWithAccessResponse = Message<"identities.v1.ListUsersWithAccessResponse"> & {
	/**
	 * @generated from field: repeated identities.v1.User items = 1;
	 */
	items: User[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * ListUsersWithAccessResponse returns an array of users
 *
 * @generated from message identities.v1.ListUsersWithAccessResponse
 */
export type ListUsersWithAccessResponseJson = {
	/**
	 * @generated from field: repeated identities.v1.User items = 1;
	 */
	items?: UserJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message identities.v1.ListUsersWithAccessResponse.
 * Use `create(ListUsersWithAccessResponseSchema)` to create a new message.
 */
export const ListUsersWithAccessResponseSchema: GenMessage<ListUsersWithAccessResponse, { jsonType: ListUsersWithAccessResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 15);

/**
 * @generated from message identities.v1.ListPendingOrProvisioningInvitationsRequest
 */
export type ListPendingOrProvisioningInvitationsRequest = Message<"identities.v1.ListPendingOrProvisioningInvitationsRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: identities.v1.InvitationFilter filter = 2;
	 */
	filter?: InvitationFilter | undefined;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 3;
	 */
	paginate?: PaginationArguments | undefined;
};

/**
 * @generated from message identities.v1.ListPendingOrProvisioningInvitationsRequest
 */
export type ListPendingOrProvisioningInvitationsRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: identities.v1.InvitationFilter filter = 2;
	 */
	filter?: InvitationFilterJson;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 3;
	 */
	paginate?: PaginationArgumentsJson;
};

/**
 * Describes the message identities.v1.ListPendingOrProvisioningInvitationsRequest.
 * Use `create(ListPendingOrProvisioningInvitationsRequestSchema)` to create a new message.
 */
export const ListPendingOrProvisioningInvitationsRequestSchema: GenMessage<ListPendingOrProvisioningInvitationsRequest, { jsonType: ListPendingOrProvisioningInvitationsRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 16);

/**
 * @generated from message identities.v1.InvitationFilter
 */
export type InvitationFilter = Message<"identities.v1.InvitationFilter"> & {
	/**
	 * @generated from field: optional string email = 1;
	 */
	email?: string | undefined;
};

/**
 * @generated from message identities.v1.InvitationFilter
 */
export type InvitationFilterJson = {
	/**
	 * @generated from field: optional string email = 1;
	 */
	email?: string;
};

/**
 * Describes the message identities.v1.InvitationFilter.
 * Use `create(InvitationFilterSchema)` to create a new message.
 */
export const InvitationFilterSchema: GenMessage<InvitationFilter, { jsonType: InvitationFilterJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 17);

/**
 * @generated from message identities.v1.ListPendingOrProvisioningInvitationsResponse
 */
export type ListPendingOrProvisioningInvitationsResponse = Message<"identities.v1.ListPendingOrProvisioningInvitationsResponse"> & {
	/**
	 * @generated from field: repeated identities.v1.Invitation items = 1;
	 */
	items: Invitation[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message identities.v1.ListPendingOrProvisioningInvitationsResponse
 */
export type ListPendingOrProvisioningInvitationsResponseJson = {
	/**
	 * @generated from field: repeated identities.v1.Invitation items = 1;
	 */
	items?: InvitationJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message identities.v1.ListPendingOrProvisioningInvitationsResponse.
 * Use `create(ListPendingOrProvisioningInvitationsResponseSchema)` to create a new message.
 */
export const ListPendingOrProvisioningInvitationsResponseSchema: GenMessage<ListPendingOrProvisioningInvitationsResponse, { jsonType: ListPendingOrProvisioningInvitationsResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 18);

/**
 * AddTeamMemberRequest adds a member to specified org
 *
 * @generated from message identities.v1.AddTeamMemberDetails
 */
export type AddTeamMemberDetails = Message<"identities.v1.AddTeamMemberDetails"> & {
	/**
	 * @generated from field: string user_id = 1;
	 */
	userId: string;

	/**
	 * @generated from field: string email = 2;
	 */
	email: string;

	/**
	 * @generated from field: identities.v1.MemberStatus status = 3;
	 */
	status: MemberStatus;
};

/**
 * AddTeamMemberRequest adds a member to specified org
 *
 * @generated from message identities.v1.AddTeamMemberDetails
 */
export type AddTeamMemberDetailsJson = {
	/**
	 * @generated from field: string user_id = 1;
	 */
	userId?: string;

	/**
	 * @generated from field: string email = 2;
	 */
	email?: string;

	/**
	 * @generated from field: identities.v1.MemberStatus status = 3;
	 */
	status?: MemberStatusJson;
};

/**
 * Describes the message identities.v1.AddTeamMemberDetails.
 * Use `create(AddTeamMemberDetailsSchema)` to create a new message.
 */
export const AddTeamMemberDetailsSchema: GenMessage<AddTeamMemberDetails, { jsonType: AddTeamMemberDetailsJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 19);

/**
 * AddTeamMemberRequest adds a member to specified org
 *
 * @generated from message identities.v1.AddTeamMemberRequest
 */
export type AddTeamMemberRequest = Message<"identities.v1.AddTeamMemberRequest"> & {
	/**
	 * @generated from field: string team_id = 1;
	 */
	teamId: string;

	/**
	 * @generated from field: repeated identities.v1.AddTeamMemberDetails members = 2;
	 */
	members: AddTeamMemberDetails[];
};

/**
 * AddTeamMemberRequest adds a member to specified org
 *
 * @generated from message identities.v1.AddTeamMemberRequest
 */
export type AddTeamMemberRequestJson = {
	/**
	 * @generated from field: string team_id = 1;
	 */
	teamId?: string;

	/**
	 * @generated from field: repeated identities.v1.AddTeamMemberDetails members = 2;
	 */
	members?: AddTeamMemberDetailsJson[];
};

/**
 * Describes the message identities.v1.AddTeamMemberRequest.
 * Use `create(AddTeamMemberRequestSchema)` to create a new message.
 */
export const AddTeamMemberRequestSchema: GenMessage<AddTeamMemberRequest, { jsonType: AddTeamMemberRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 20);

/**
 * @generated from message identities.v1.TeamFilter
 */
export type TeamFilter = Message<"identities.v1.TeamFilter"> & {
	/**
	 * @generated from field: optional string name = 1;
	 */
	name?: string | undefined;

	/**
	 * @generated from field: optional string org_id = 2;
	 */
	orgId?: string | undefined;

	/**
	 * @generated from field: optional string user_id = 3;
	 */
	userId?: string | undefined;

	/**
	 * @generated from field: optional string memberable_id = 4;
	 */
	memberableId?: string | undefined;
};

/**
 * @generated from message identities.v1.TeamFilter
 */
export type TeamFilterJson = {
	/**
	 * @generated from field: optional string name = 1;
	 */
	name?: string;

	/**
	 * @generated from field: optional string org_id = 2;
	 */
	orgId?: string;

	/**
	 * @generated from field: optional string user_id = 3;
	 */
	userId?: string;

	/**
	 * @generated from field: optional string memberable_id = 4;
	 */
	memberableId?: string;
};

/**
 * Describes the message identities.v1.TeamFilter.
 * Use `create(TeamFilterSchema)` to create a new message.
 */
export const TeamFilterSchema: GenMessage<TeamFilter, { jsonType: TeamFilterJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 21);

/**
 * @generated from message identities.v1.ListTeamsRequest
 */
export type ListTeamsRequest = Message<"identities.v1.ListTeamsRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: optional string user_id = 2;
	 */
	userId?: string | undefined;

	/**
	 * @generated from field: identities.v1.TeamFilter filter = 3;
	 */
	filter?: TeamFilter | undefined;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 4;
	 */
	paginate?: PaginationArguments | undefined;
};

/**
 * @generated from message identities.v1.ListTeamsRequest
 */
export type ListTeamsRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: optional string user_id = 2;
	 */
	userId?: string;

	/**
	 * @generated from field: identities.v1.TeamFilter filter = 3;
	 */
	filter?: TeamFilterJson;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 4;
	 */
	paginate?: PaginationArgumentsJson;
};

/**
 * Describes the message identities.v1.ListTeamsRequest.
 * Use `create(ListTeamsRequestSchema)` to create a new message.
 */
export const ListTeamsRequestSchema: GenMessage<ListTeamsRequest, { jsonType: ListTeamsRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 22);

/**
 * AddTeamMemberResponse
 *
 * @generated from message identities.v1.AddTeamMemberResponse
 */
export type AddTeamMemberResponse = Message<"identities.v1.AddTeamMemberResponse"> & {
	/**
	 * @generated from field: identities.v1.Member member = 1;
	 */
	member?: Member | undefined;
};

/**
 * AddTeamMemberResponse
 *
 * @generated from message identities.v1.AddTeamMemberResponse
 */
export type AddTeamMemberResponseJson = {
	/**
	 * @generated from field: identities.v1.Member member = 1;
	 */
	member?: MemberJson;
};

/**
 * Describes the message identities.v1.AddTeamMemberResponse.
 * Use `create(AddTeamMemberResponseSchema)` to create a new message.
 */
export const AddTeamMemberResponseSchema: GenMessage<AddTeamMemberResponse, { jsonType: AddTeamMemberResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 23);

/**
 * @generated from message identities.v1.ListTeamsResponse
 */
export type ListTeamsResponse = Message<"identities.v1.ListTeamsResponse"> & {
	/**
	 * @generated from field: repeated identities.v1.Team items = 1;
	 */
	items: Team[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message identities.v1.ListTeamsResponse
 */
export type ListTeamsResponseJson = {
	/**
	 * @generated from field: repeated identities.v1.Team items = 1;
	 */
	items?: TeamJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message identities.v1.ListTeamsResponse.
 * Use `create(ListTeamsResponseSchema)` to create a new message.
 */
export const ListTeamsResponseSchema: GenMessage<ListTeamsResponse, { jsonType: ListTeamsResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 24);

/**
 * @generated from message identities.v1.GetTeamRequest
 */
export type GetTeamRequest = Message<"identities.v1.GetTeamRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string team_id = 2;
	 */
	teamId: string;
};

/**
 * @generated from message identities.v1.GetTeamRequest
 */
export type GetTeamRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string team_id = 2;
	 */
	teamId?: string;
};

/**
 * Describes the message identities.v1.GetTeamRequest.
 * Use `create(GetTeamRequestSchema)` to create a new message.
 */
export const GetTeamRequestSchema: GenMessage<GetTeamRequest, { jsonType: GetTeamRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 25);

/**
 * @generated from message identities.v1.GetTeamResponse
 */
export type GetTeamResponse = Message<"identities.v1.GetTeamResponse"> & {
	/**
	 * @generated from field: identities.v1.Team team = 1;
	 */
	team?: Team | undefined;
};

/**
 * @generated from message identities.v1.GetTeamResponse
 */
export type GetTeamResponseJson = {
	/**
	 * @generated from field: identities.v1.Team team = 1;
	 */
	team?: TeamJson;
};

/**
 * Describes the message identities.v1.GetTeamResponse.
 * Use `create(GetTeamResponseSchema)` to create a new message.
 */
export const GetTeamResponseSchema: GenMessage<GetTeamResponse, { jsonType: GetTeamResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 26);

/**
 * ListTeamCandidatesRequest is an empty object, later we can fill it with filtering options
 *
 * @generated from message identities.v1.ListTeamCandidatesRequest
 */
export type ListTeamCandidatesRequest = Message<"identities.v1.ListTeamCandidatesRequest"> & {
	/**
	 * @generated from field: string workspace_id = 1;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;

	/**
	 * @generated from field: identities.v1.TeamFilter filter = 3;
	 */
	filter?: TeamFilter | undefined;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 4;
	 */
	paginate?: PaginationArguments | undefined;
};

/**
 * ListTeamCandidatesRequest is an empty object, later we can fill it with filtering options
 *
 * @generated from message identities.v1.ListTeamCandidatesRequest
 */
export type ListTeamCandidatesRequestJson = {
	/**
	 * @generated from field: string workspace_id = 1;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;

	/**
	 * @generated from field: identities.v1.TeamFilter filter = 3;
	 */
	filter?: TeamFilterJson;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 4;
	 */
	paginate?: PaginationArgumentsJson;
};

/**
 * Describes the message identities.v1.ListTeamCandidatesRequest.
 * Use `create(ListTeamCandidatesRequestSchema)` to create a new message.
 */
export const ListTeamCandidatesRequestSchema: GenMessage<ListTeamCandidatesRequest, { jsonType: ListTeamCandidatesRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 27);

/**
 * ListTeamCandidatesResponse returns an array of users
 *
 * @generated from message identities.v1.ListTeamCandidatesResponse
 */
export type ListTeamCandidatesResponse = Message<"identities.v1.ListTeamCandidatesResponse"> & {
	/**
	 * @generated from field: repeated identities.v1.Team items = 1;
	 */
	items: Team[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * ListTeamCandidatesResponse returns an array of users
 *
 * @generated from message identities.v1.ListTeamCandidatesResponse
 */
export type ListTeamCandidatesResponseJson = {
	/**
	 * @generated from field: repeated identities.v1.Team items = 1;
	 */
	items?: TeamJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message identities.v1.ListTeamCandidatesResponse.
 * Use `create(ListTeamCandidatesResponseSchema)` to create a new message.
 */
export const ListTeamCandidatesResponseSchema: GenMessage<ListTeamCandidatesResponse, { jsonType: ListTeamCandidatesResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 28);

/**
 * CreateUserResponse is the object holding a user that is to be created
 *
 * @generated from message identities.v1.CreateUserRequest
 */
export type CreateUserRequest = Message<"identities.v1.CreateUserRequest"> & {
	/**
	 * @generated from field: string first_name = 1;
	 */
	firstName: string;

	/**
	 * @generated from field: string last_name = 2;
	 */
	lastName: string;

	/**
	 * @generated from field: string email = 3;
	 */
	email: string;

	/**
	 * @generated from field: string external_auth_id = 4;
	 */
	externalAuthId: string;

	/**
	 * @generated from field: string phone_number = 5;
	 */
	phoneNumber: string;

	/**
	 * @generated from field: string referral_short_url = 6;
	 */
	referralShortUrl: string;

	/**
	 * @generated from field: optional string company_name = 7;
	 */
	companyName?: string | undefined;
};

/**
 * CreateUserResponse is the object holding a user that is to be created
 *
 * @generated from message identities.v1.CreateUserRequest
 */
export type CreateUserRequestJson = {
	/**
	 * @generated from field: string first_name = 1;
	 */
	firstName?: string;

	/**
	 * @generated from field: string last_name = 2;
	 */
	lastName?: string;

	/**
	 * @generated from field: string email = 3;
	 */
	email?: string;

	/**
	 * @generated from field: string external_auth_id = 4;
	 */
	externalAuthId?: string;

	/**
	 * @generated from field: string phone_number = 5;
	 */
	phoneNumber?: string;

	/**
	 * @generated from field: string referral_short_url = 6;
	 */
	referralShortUrl?: string;

	/**
	 * @generated from field: optional string company_name = 7;
	 */
	companyName?: string;
};

/**
 * Describes the message identities.v1.CreateUserRequest.
 * Use `create(CreateUserRequestSchema)` to create a new message.
 */
export const CreateUserRequestSchema: GenMessage<CreateUserRequest, { jsonType: CreateUserRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 29);

/**
 * CreateUserResponse is the response to the create user request sending back the id of the created
 *
 * @generated from message identities.v1.CreateUserResponse
 */
export type CreateUserResponse = Message<"identities.v1.CreateUserResponse"> & {
	/**
	 * @generated from field: identities.v1.User user = 1;
	 */
	user?: User | undefined;
};

/**
 * CreateUserResponse is the response to the create user request sending back the id of the created
 *
 * @generated from message identities.v1.CreateUserResponse
 */
export type CreateUserResponseJson = {
	/**
	 * @generated from field: identities.v1.User user = 1;
	 */
	user?: UserJson;
};

/**
 * Describes the message identities.v1.CreateUserResponse.
 * Use `create(CreateUserResponseSchema)` to create a new message.
 */
export const CreateUserResponseSchema: GenMessage<CreateUserResponse, { jsonType: CreateUserResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 30);

/**
 * CreateOrUpdateUserRequest is the object holding a user that is to be created
 *
 * @generated from message identities.v1.CreateOrUpdateUserRequest
 */
export type CreateOrUpdateUserRequest = Message<"identities.v1.CreateOrUpdateUserRequest"> & {
	/**
	 * @generated from field: optional identities.v1.RoleType role = 1;
	 */
	role?: RoleType | undefined;
};

/**
 * CreateOrUpdateUserRequest is the object holding a user that is to be created
 *
 * @generated from message identities.v1.CreateOrUpdateUserRequest
 */
export type CreateOrUpdateUserRequestJson = {
	/**
	 * @generated from field: optional identities.v1.RoleType role = 1;
	 */
	role?: RoleTypeJson;
};

/**
 * Describes the message identities.v1.CreateOrUpdateUserRequest.
 * Use `create(CreateOrUpdateUserRequestSchema)` to create a new message.
 */
export const CreateOrUpdateUserRequestSchema: GenMessage<CreateOrUpdateUserRequest, { jsonType: CreateOrUpdateUserRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 31);

/**
 * @generated from message identities.v1.CreateOrUpdateUserResponse
 */
export type CreateOrUpdateUserResponse = Message<"identities.v1.CreateOrUpdateUserResponse"> & {
	/**
	 * @generated from field: identities.v1.User user = 1;
	 */
	user?: User | undefined;

	/**
	 * @generated from field: bool is_new = 2;
	 */
	isNew: boolean;
};

/**
 * @generated from message identities.v1.CreateOrUpdateUserResponse
 */
export type CreateOrUpdateUserResponseJson = {
	/**
	 * @generated from field: identities.v1.User user = 1;
	 */
	user?: UserJson;

	/**
	 * @generated from field: bool is_new = 2;
	 */
	isNew?: boolean;
};

/**
 * Describes the message identities.v1.CreateOrUpdateUserResponse.
 * Use `create(CreateOrUpdateUserResponseSchema)` to create a new message.
 */
export const CreateOrUpdateUserResponseSchema: GenMessage<CreateOrUpdateUserResponse, { jsonType: CreateOrUpdateUserResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 32);

/**
 * DeleteUserRequest holds an id which is then deleted from the database
 *
 * @generated from message identities.v1.DeleteUserRequest
 */
export type DeleteUserRequest = Message<"identities.v1.DeleteUserRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * DeleteUserRequest holds an id which is then deleted from the database
 *
 * @generated from message identities.v1.DeleteUserRequest
 */
export type DeleteUserRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message identities.v1.DeleteUserRequest.
 * Use `create(DeleteUserRequestSchema)` to create a new message.
 */
export const DeleteUserRequestSchema: GenMessage<DeleteUserRequest, { jsonType: DeleteUserRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 33);

/**
 * DeleteUserResponse <haven't figured out what to put here yet>
 *
 * @generated from message identities.v1.DeleteUserResponse
 */
export type DeleteUserResponse = Message<"identities.v1.DeleteUserResponse"> & {};

/**
 * DeleteUserResponse <haven't figured out what to put here yet>
 *
 * @generated from message identities.v1.DeleteUserResponse
 */
export type DeleteUserResponseJson = {};

/**
 * Describes the message identities.v1.DeleteUserResponse.
 * Use `create(DeleteUserResponseSchema)` to create a new message.
 */
export const DeleteUserResponseSchema: GenMessage<DeleteUserResponse, { jsonType: DeleteUserResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 34);

/**
 * UpdateUserRequest  update attributes on a user
 *
 * @generated from message identities.v1.UpdateUserRequest
 */
export type UpdateUserRequest = Message<"identities.v1.UpdateUserRequest"> & {
	/**
	 * @generated from field: identities.v1.User user = 1;
	 */
	user?: User | undefined;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMask | undefined;
};

/**
 * UpdateUserRequest  update attributes on a user
 *
 * @generated from message identities.v1.UpdateUserRequest
 */
export type UpdateUserRequestJson = {
	/**
	 * @generated from field: identities.v1.User user = 1;
	 */
	user?: UserJson;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMaskJson;
};

/**
 * Describes the message identities.v1.UpdateUserRequest.
 * Use `create(UpdateUserRequestSchema)` to create a new message.
 */
export const UpdateUserRequestSchema: GenMessage<UpdateUserRequest, { jsonType: UpdateUserRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 35);

/**
 * UpdateUserReesponse
 *
 * @generated from message identities.v1.UpdateUserResponse
 */
export type UpdateUserResponse = Message<"identities.v1.UpdateUserResponse"> & {
	/**
	 * @generated from field: identities.v1.User user = 1;
	 */
	user?: User | undefined;
};

/**
 * UpdateUserReesponse
 *
 * @generated from message identities.v1.UpdateUserResponse
 */
export type UpdateUserResponseJson = {
	/**
	 * @generated from field: identities.v1.User user = 1;
	 */
	user?: UserJson;
};

/**
 * Describes the message identities.v1.UpdateUserResponse.
 * Use `create(UpdateUserResponseSchema)` to create a new message.
 */
export const UpdateUserResponseSchema: GenMessage<UpdateUserResponse, { jsonType: UpdateUserResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 36);

/**
 * UserCreated is the event message published when a user is created
 *
 * @generated from message identities.v1.UserCreated
 */
export type UserCreated = Message<"identities.v1.UserCreated"> & {
	/**
	 * @generated from field: identities.v1.User user = 1;
	 */
	user?: User | undefined;
};

/**
 * UserCreated is the event message published when a user is created
 *
 * @generated from message identities.v1.UserCreated
 */
export type UserCreatedJson = {
	/**
	 * @generated from field: identities.v1.User user = 1;
	 */
	user?: UserJson;
};

/**
 * Describes the message identities.v1.UserCreated.
 * Use `create(UserCreatedSchema)` to create a new message.
 */
export const UserCreatedSchema: GenMessage<UserCreated, { jsonType: UserCreatedJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 37);

/**
 * UserDeleted is the event message published when a user is deleted
 *
 * @generated from message identities.v1.UserDeleted
 */
export type UserDeleted = Message<"identities.v1.UserDeleted"> & {
	/**
	 * @generated from field: identities.v1.User user = 1;
	 */
	user?: User | undefined;
};

/**
 * UserDeleted is the event message published when a user is deleted
 *
 * @generated from message identities.v1.UserDeleted
 */
export type UserDeletedJson = {
	/**
	 * @generated from field: identities.v1.User user = 1;
	 */
	user?: UserJson;
};

/**
 * Describes the message identities.v1.UserDeleted.
 * Use `create(UserDeletedSchema)` to create a new message.
 */
export const UserDeletedSchema: GenMessage<UserDeleted, { jsonType: UserDeletedJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 38);

/**
 * UserUpdated is the event message published when a user is updated
 *
 * @generated from message identities.v1.UserUpdated
 */
export type UserUpdated = Message<"identities.v1.UserUpdated"> & {
	/**
	 * @generated from field: identities.v1.User user = 1;
	 */
	user?: User | undefined;
};

/**
 * UserUpdated is the event message published when a user is updated
 *
 * @generated from message identities.v1.UserUpdated
 */
export type UserUpdatedJson = {
	/**
	 * @generated from field: identities.v1.User user = 1;
	 */
	user?: UserJson;
};

/**
 * Describes the message identities.v1.UserUpdated.
 * Use `create(UserUpdatedSchema)` to create a new message.
 */
export const UserUpdatedSchema: GenMessage<UserUpdated, { jsonType: UserUpdatedJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 39);

/**
 * @generated from message identities.v1.OrgFilter
 */
export type OrgFilter = Message<"identities.v1.OrgFilter"> & {
	/**
	 * @generated from field: optional string name = 1;
	 */
	name?: string | undefined;

	/**
	 * @generated from field: optional bool admin = 2;
	 */
	admin?: boolean | undefined;

	/**
	 * @generated from field: optional string corp_id = 3;
	 */
	corpId?: string | undefined;

	/**
	 * @generated from field: optional string id = 4;
	 */
	id?: string | undefined;
};

/**
 * @generated from message identities.v1.OrgFilter
 */
export type OrgFilterJson = {
	/**
	 * @generated from field: optional string name = 1;
	 */
	name?: string;

	/**
	 * @generated from field: optional bool admin = 2;
	 */
	admin?: boolean;

	/**
	 * @generated from field: optional string corp_id = 3;
	 */
	corpId?: string;

	/**
	 * @generated from field: optional string id = 4;
	 */
	id?: string;
};

/**
 * Describes the message identities.v1.OrgFilter.
 * Use `create(OrgFilterSchema)` to create a new message.
 */
export const OrgFilterSchema: GenMessage<OrgFilter, { jsonType: OrgFilterJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 40);

/**
 * @generated from message identities.v1.Org
 */
export type Org = Message<"identities.v1.Org"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name: string;

	/**
	 * @generated from field: string description = 3;
	 */
	description: string;

	/**
	 * @generated from field: identities.v1.OrgStatus status = 4;
	 */
	status: OrgStatus;

	/**
	 * @generated from field: string path_name = 5;
	 */
	pathName: string;

	/**
	 * @generated from field: int64 hubspot_company_id = 6;
	 */
	hubspotCompanyId: bigint;

	/**
	 * @generated from field: int64 member_count = 8;
	 */
	memberCount: bigint;

	/**
	 * @generated from field: int64 team_count = 9;
	 */
	teamCount: bigint;

	/**
	 * @generated from field: int64 workspace_count = 10;
	 */
	workspaceCount: bigint;

	/**
	 * @generated from field: string photo_url = 11;
	 */
	photoUrl: string;

	/**
	 * @generated from field: string churn_reason = 12;
	 */
	churnReason: string;

	/**
	 * @generated from field: bool sso_enabled = 19;
	 */
	ssoEnabled: boolean;

	/**
	 * @generated from field: bool sso_roles = 21;
	 */
	ssoRoles: boolean;

	/**
	 * @generated from field: string zuora_id = 23;
	 */
	zuoraId: string;

	/**
	 * @generated from field: string industry_vertical_id = 25;
	 */
	industryVerticalId: string;

	/**
	 * @generated from field: identities.v1.SsoConfiguration sso_configuration = 22;
	 */
	ssoConfiguration?: SsoConfiguration | undefined;

	/**
	 * @generated from field: repeated string sso_domains = 20;
	 */
	ssoDomains: string[];

	/**
	 * @generated from field: repeated identities.v1.Member members = 13;
	 */
	members: Member[];

	/**
	 * @generated from field: repeated identities.v1.Team teams = 14;
	 */
	teams: Team[];

	/**
	 * @generated from field: identities.v1.IndustryVertical industry_vertical = 26;
	 */
	industryVertical?: IndustryVertical | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp trial_end_at = 15;
	 */
	trialEndAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 16;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 17;
	 */
	updatedAt?: Timestamp | undefined;

	/**
	 * @generated from field: optional google.protobuf.Timestamp deleted_at = 18;
	 */
	deletedAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp live_at = 24;
	 */
	liveAt?: Timestamp | undefined;

	/**
	 * @generated from field: string corp_id = 27;
	 */
	corpId: string;

	/**
	 * @generated from field: bool has_dpa = 28;
	 */
	hasDpa: boolean;

	/**
	 * @generated from field: optional identities.v1.OrgInviteStatus invite_status = 29;
	 */
	inviteStatus?: OrgInviteStatus | undefined;

	/**
	 * @generated from field: identities.v1.OrgSetupStatus setup_status = 30;
	 */
	setupStatus: OrgSetupStatus;

	/**
	 * @generated from field: bool enable_personal_workspaces = 31;
	 */
	enablePersonalWorkspaces: boolean;
};

/**
 * @generated from message identities.v1.Org
 */
export type OrgJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name?: string;

	/**
	 * @generated from field: string description = 3;
	 */
	description?: string;

	/**
	 * @generated from field: identities.v1.OrgStatus status = 4;
	 */
	status?: OrgStatusJson;

	/**
	 * @generated from field: string path_name = 5;
	 */
	pathName?: string;

	/**
	 * @generated from field: int64 hubspot_company_id = 6;
	 */
	hubspotCompanyId?: string;

	/**
	 * @generated from field: int64 member_count = 8;
	 */
	memberCount?: string;

	/**
	 * @generated from field: int64 team_count = 9;
	 */
	teamCount?: string;

	/**
	 * @generated from field: int64 workspace_count = 10;
	 */
	workspaceCount?: string;

	/**
	 * @generated from field: string photo_url = 11;
	 */
	photoUrl?: string;

	/**
	 * @generated from field: string churn_reason = 12;
	 */
	churnReason?: string;

	/**
	 * @generated from field: bool sso_enabled = 19;
	 */
	ssoEnabled?: boolean;

	/**
	 * @generated from field: bool sso_roles = 21;
	 */
	ssoRoles?: boolean;

	/**
	 * @generated from field: string zuora_id = 23;
	 */
	zuoraId?: string;

	/**
	 * @generated from field: string industry_vertical_id = 25;
	 */
	industryVerticalId?: string;

	/**
	 * @generated from field: identities.v1.SsoConfiguration sso_configuration = 22;
	 */
	ssoConfiguration?: SsoConfigurationJson;

	/**
	 * @generated from field: repeated string sso_domains = 20;
	 */
	ssoDomains?: string[];

	/**
	 * @generated from field: repeated identities.v1.Member members = 13;
	 */
	members?: MemberJson[];

	/**
	 * @generated from field: repeated identities.v1.Team teams = 14;
	 */
	teams?: TeamJson[];

	/**
	 * @generated from field: identities.v1.IndustryVertical industry_vertical = 26;
	 */
	industryVertical?: IndustryVerticalJson;

	/**
	 * @generated from field: google.protobuf.Timestamp trial_end_at = 15;
	 */
	trialEndAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 16;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 17;
	 */
	updatedAt?: TimestampJson;

	/**
	 * @generated from field: optional google.protobuf.Timestamp deleted_at = 18;
	 */
	deletedAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp live_at = 24;
	 */
	liveAt?: TimestampJson;

	/**
	 * @generated from field: string corp_id = 27;
	 */
	corpId?: string;

	/**
	 * @generated from field: bool has_dpa = 28;
	 */
	hasDpa?: boolean;

	/**
	 * @generated from field: optional identities.v1.OrgInviteStatus invite_status = 29;
	 */
	inviteStatus?: OrgInviteStatusJson;

	/**
	 * @generated from field: identities.v1.OrgSetupStatus setup_status = 30;
	 */
	setupStatus?: OrgSetupStatusJson;

	/**
	 * @generated from field: bool enable_personal_workspaces = 31;
	 */
	enablePersonalWorkspaces?: boolean;
};

/**
 * Describes the message identities.v1.Org.
 * Use `create(OrgSchema)` to create a new message.
 */
export const OrgSchema: GenMessage<Org, { jsonType: OrgJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 41);

/**
 * OrgPublicInfo is the public info of an org
 *
 * @generated from message identities.v1.OrgPublicInfo
 */
export type OrgPublicInfo = Message<"identities.v1.OrgPublicInfo"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name: string;

	/**
	 * @generated from field: string description = 3;
	 */
	description: string;

	/**
	 * @generated from field: string photo_url = 4;
	 */
	photoUrl: string;
};

/**
 * OrgPublicInfo is the public info of an org
 *
 * @generated from message identities.v1.OrgPublicInfo
 */
export type OrgPublicInfoJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name?: string;

	/**
	 * @generated from field: string description = 3;
	 */
	description?: string;

	/**
	 * @generated from field: string photo_url = 4;
	 */
	photoUrl?: string;
};

/**
 * Describes the message identities.v1.OrgPublicInfo.
 * Use `create(OrgPublicInfoSchema)` to create a new message.
 */
export const OrgPublicInfoSchema: GenMessage<OrgPublicInfo, { jsonType: OrgPublicInfoJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 42);

/**
 * GetOrgRequest is the request object to get a user by id
 *
 * @generated from message identities.v1.GetOrgRequest
 */
export type GetOrgRequest = Message<"identities.v1.GetOrgRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: optional string user_id = 2;
	 */
	userId?: string | undefined;
};

/**
 * GetOrgRequest is the request object to get a user by id
 *
 * @generated from message identities.v1.GetOrgRequest
 */
export type GetOrgRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: optional string user_id = 2;
	 */
	userId?: string;
};

/**
 * Describes the message identities.v1.GetOrgRequest.
 * Use `create(GetOrgRequestSchema)` to create a new message.
 */
export const GetOrgRequestSchema: GenMessage<GetOrgRequest, { jsonType: GetOrgRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 43);

/**
 * GetOrgResponse returned by the get request for the org returning the org
 *
 * @generated from message identities.v1.GetOrgResponse
 */
export type GetOrgResponse = Message<"identities.v1.GetOrgResponse"> & {
	/**
	 * @generated from field: identities.v1.Org org = 1;
	 */
	org?: Org | undefined;
};

/**
 * GetOrgResponse returned by the get request for the org returning the org
 *
 * @generated from message identities.v1.GetOrgResponse
 */
export type GetOrgResponseJson = {
	/**
	 * @generated from field: identities.v1.Org org = 1;
	 */
	org?: OrgJson;
};

/**
 * Describes the message identities.v1.GetOrgResponse.
 * Use `create(GetOrgResponseSchema)` to create a new message.
 */
export const GetOrgResponseSchema: GenMessage<GetOrgResponse, { jsonType: GetOrgResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 44);

/**
 * GetOrgRequest is the request object to get a user by id
 *
 * @generated from message identities.v1.GetAdminOrgRequest
 */
export type GetAdminOrgRequest = Message<"identities.v1.GetAdminOrgRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: optional string user_id = 2;
	 */
	userId?: string | undefined;
};

/**
 * GetOrgRequest is the request object to get a user by id
 *
 * @generated from message identities.v1.GetAdminOrgRequest
 */
export type GetAdminOrgRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: optional string user_id = 2;
	 */
	userId?: string;
};

/**
 * Describes the message identities.v1.GetAdminOrgRequest.
 * Use `create(GetAdminOrgRequestSchema)` to create a new message.
 */
export const GetAdminOrgRequestSchema: GenMessage<GetAdminOrgRequest, { jsonType: GetAdminOrgRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 45);

/**
 * GetOrgResponse returned by the get request for the org returning the org
 *
 * @generated from message identities.v1.GetAdminOrgResponse
 */
export type GetAdminOrgResponse = Message<"identities.v1.GetAdminOrgResponse"> & {
	/**
	 * @generated from field: identities.v1.Org org = 1;
	 */
	org?: Org | undefined;
};

/**
 * GetOrgResponse returned by the get request for the org returning the org
 *
 * @generated from message identities.v1.GetAdminOrgResponse
 */
export type GetAdminOrgResponseJson = {
	/**
	 * @generated from field: identities.v1.Org org = 1;
	 */
	org?: OrgJson;
};

/**
 * Describes the message identities.v1.GetAdminOrgResponse.
 * Use `create(GetAdminOrgResponseSchema)` to create a new message.
 */
export const GetAdminOrgResponseSchema: GenMessage<GetAdminOrgResponse, { jsonType: GetAdminOrgResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 46);

/**
 * CreateOrgRequest is the object holding a user that is to be created
 *
 * @generated from message identities.v1.CreateOrgRequest
 */
export type CreateOrgRequest = Message<"identities.v1.CreateOrgRequest"> & {
	/**
	 * @generated from field: string id = 13;
	 */
	id: string;

	/**
	 * @generated from field: string name = 1;
	 */
	name: string;

	/**
	 * @generated from field: string description = 2;
	 */
	description: string;

	/**
	 * @generated from field: identities.v1.OrgStatus status = 3;
	 */
	status: OrgStatus;

	/**
	 * @generated from field: string path_name = 4;
	 */
	pathName: string;

	/**
	 * @generated from field: string zuora_id = 11;
	 */
	zuoraId: string;

	/**
	 * @generated from field: int64 hubspot_company_id = 5;
	 */
	hubspotCompanyId: bigint;

	/**
	 * @generated from field: string photo_url = 7;
	 */
	photoUrl: string;

	/**
	 * @generated from field: string churn_reason = 8;
	 */
	churnReason: string;

	/**
	 * @generated from field: string industry_vertical_id = 14;
	 */
	industryVerticalId: string;

	/**
	 * @generated from field: google.protobuf.Timestamp trial_end_at = 9;
	 */
	trialEndAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp live_at = 12;
	 */
	liveAt?: Timestamp | undefined;

	/**
	 * @generated from field: repeated identities.v1.Member members = 10;
	 */
	members: Member[];

	/**
	 * @generated from field: bool has_dpa = 15;
	 */
	hasDpa: boolean;

	/**
	 * @generated from field: identities.v1.OrgSetupStatus setup_status = 16;
	 */
	setupStatus: OrgSetupStatus;
};

/**
 * CreateOrgRequest is the object holding a user that is to be created
 *
 * @generated from message identities.v1.CreateOrgRequest
 */
export type CreateOrgRequestJson = {
	/**
	 * @generated from field: string id = 13;
	 */
	id?: string;

	/**
	 * @generated from field: string name = 1;
	 */
	name?: string;

	/**
	 * @generated from field: string description = 2;
	 */
	description?: string;

	/**
	 * @generated from field: identities.v1.OrgStatus status = 3;
	 */
	status?: OrgStatusJson;

	/**
	 * @generated from field: string path_name = 4;
	 */
	pathName?: string;

	/**
	 * @generated from field: string zuora_id = 11;
	 */
	zuoraId?: string;

	/**
	 * @generated from field: int64 hubspot_company_id = 5;
	 */
	hubspotCompanyId?: string;

	/**
	 * @generated from field: string photo_url = 7;
	 */
	photoUrl?: string;

	/**
	 * @generated from field: string churn_reason = 8;
	 */
	churnReason?: string;

	/**
	 * @generated from field: string industry_vertical_id = 14;
	 */
	industryVerticalId?: string;

	/**
	 * @generated from field: google.protobuf.Timestamp trial_end_at = 9;
	 */
	trialEndAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp live_at = 12;
	 */
	liveAt?: TimestampJson;

	/**
	 * @generated from field: repeated identities.v1.Member members = 10;
	 */
	members?: MemberJson[];

	/**
	 * @generated from field: bool has_dpa = 15;
	 */
	hasDpa?: boolean;

	/**
	 * @generated from field: identities.v1.OrgSetupStatus setup_status = 16;
	 */
	setupStatus?: OrgSetupStatusJson;
};

/**
 * Describes the message identities.v1.CreateOrgRequest.
 * Use `create(CreateOrgRequestSchema)` to create a new message.
 */
export const CreateOrgRequestSchema: GenMessage<CreateOrgRequest, { jsonType: CreateOrgRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 47);

/**
 * CreateOrgResponse is the response to the create org request sending back the id of the created
 *
 * @generated from message identities.v1.CreateOrgResponse
 */
export type CreateOrgResponse = Message<"identities.v1.CreateOrgResponse"> & {
	/**
	 * @generated from field: identities.v1.Org org = 1;
	 */
	org?: Org | undefined;
};

/**
 * CreateOrgResponse is the response to the create org request sending back the id of the created
 *
 * @generated from message identities.v1.CreateOrgResponse
 */
export type CreateOrgResponseJson = {
	/**
	 * @generated from field: identities.v1.Org org = 1;
	 */
	org?: OrgJson;
};

/**
 * Describes the message identities.v1.CreateOrgResponse.
 * Use `create(CreateOrgResponseSchema)` to create a new message.
 */
export const CreateOrgResponseSchema: GenMessage<CreateOrgResponse, { jsonType: CreateOrgResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 48);

/**
 * ListOrgsRequest is an empty object, later we can fill it with filtering options
 *
 * @generated from message identities.v1.ListOrgsRequest
 */
export type ListOrgsRequest = Message<"identities.v1.ListOrgsRequest"> & {
	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 1;
	 */
	paginate?: PaginationArguments | undefined;

	/**
	 * @generated from field: identities.v1.OrgFilter filter = 2;
	 */
	filter?: OrgFilter | undefined;
};

/**
 * ListOrgsRequest is an empty object, later we can fill it with filtering options
 *
 * @generated from message identities.v1.ListOrgsRequest
 */
export type ListOrgsRequestJson = {
	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 1;
	 */
	paginate?: PaginationArgumentsJson;

	/**
	 * @generated from field: identities.v1.OrgFilter filter = 2;
	 */
	filter?: OrgFilterJson;
};

/**
 * Describes the message identities.v1.ListOrgsRequest.
 * Use `create(ListOrgsRequestSchema)` to create a new message.
 */
export const ListOrgsRequestSchema: GenMessage<ListOrgsRequest, { jsonType: ListOrgsRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 49);

/**
 * ListOrgsResponse returns an array of users
 *
 * @generated from message identities.v1.ListOrgsResponse
 */
export type ListOrgsResponse = Message<"identities.v1.ListOrgsResponse"> & {
	/**
	 * @generated from field: repeated identities.v1.Org items = 1;
	 */
	items: Org[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * ListOrgsResponse returns an array of users
 *
 * @generated from message identities.v1.ListOrgsResponse
 */
export type ListOrgsResponseJson = {
	/**
	 * @generated from field: repeated identities.v1.Org items = 1;
	 */
	items?: OrgJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message identities.v1.ListOrgsResponse.
 * Use `create(ListOrgsResponseSchema)` to create a new message.
 */
export const ListOrgsResponseSchema: GenMessage<ListOrgsResponse, { jsonType: ListOrgsResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 50);

/**
 * ListAdminOrgsRequest is an empty object, later we can fill it with filtering options
 *
 * @generated from message identities.v1.ListAdminOrgsRequest
 */
export type ListAdminOrgsRequest = Message<"identities.v1.ListAdminOrgsRequest"> & {
	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 1;
	 */
	paginate?: PaginationArguments | undefined;

	/**
	 * @generated from field: identities.v1.OrgFilter filter = 2;
	 */
	filter?: OrgFilter | undefined;
};

/**
 * ListAdminOrgsRequest is an empty object, later we can fill it with filtering options
 *
 * @generated from message identities.v1.ListAdminOrgsRequest
 */
export type ListAdminOrgsRequestJson = {
	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 1;
	 */
	paginate?: PaginationArgumentsJson;

	/**
	 * @generated from field: identities.v1.OrgFilter filter = 2;
	 */
	filter?: OrgFilterJson;
};

/**
 * Describes the message identities.v1.ListAdminOrgsRequest.
 * Use `create(ListAdminOrgsRequestSchema)` to create a new message.
 */
export const ListAdminOrgsRequestSchema: GenMessage<ListAdminOrgsRequest, { jsonType: ListAdminOrgsRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 51);

/**
 * ListAdminOrgsResponse returns an array of users
 *
 * @generated from message identities.v1.ListAdminOrgsResponse
 */
export type ListAdminOrgsResponse = Message<"identities.v1.ListAdminOrgsResponse"> & {
	/**
	 * @generated from field: repeated identities.v1.Org items = 1;
	 */
	items: Org[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * ListAdminOrgsResponse returns an array of users
 *
 * @generated from message identities.v1.ListAdminOrgsResponse
 */
export type ListAdminOrgsResponseJson = {
	/**
	 * @generated from field: repeated identities.v1.Org items = 1;
	 */
	items?: OrgJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message identities.v1.ListAdminOrgsResponse.
 * Use `create(ListAdminOrgsResponseSchema)` to create a new message.
 */
export const ListAdminOrgsResponseSchema: GenMessage<ListAdminOrgsResponse, { jsonType: ListAdminOrgsResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 52);

/**
 * DeleteOrgRequest holds an id which is then deleted from the database
 *
 * @generated from message identities.v1.DeleteOrgRequest
 */
export type DeleteOrgRequest = Message<"identities.v1.DeleteOrgRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * DeleteOrgRequest holds an id which is then deleted from the database
 *
 * @generated from message identities.v1.DeleteOrgRequest
 */
export type DeleteOrgRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message identities.v1.DeleteOrgRequest.
 * Use `create(DeleteOrgRequestSchema)` to create a new message.
 */
export const DeleteOrgRequestSchema: GenMessage<DeleteOrgRequest, { jsonType: DeleteOrgRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 53);

/**
 * DeleteOrgResponse <haven't figured out what to put here yet>
 *
 * @generated from message identities.v1.DeleteOrgResponse
 */
export type DeleteOrgResponse = Message<"identities.v1.DeleteOrgResponse"> & {};

/**
 * DeleteOrgResponse <haven't figured out what to put here yet>
 *
 * @generated from message identities.v1.DeleteOrgResponse
 */
export type DeleteOrgResponseJson = {};

/**
 * Describes the message identities.v1.DeleteOrgResponse.
 * Use `create(DeleteOrgResponseSchema)` to create a new message.
 */
export const DeleteOrgResponseSchema: GenMessage<DeleteOrgResponse, { jsonType: DeleteOrgResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 54);

/**
 * OrgCreated is the event message published when an org is created
 *
 * @generated from message identities.v1.OrgCreated
 */
export type OrgCreated = Message<"identities.v1.OrgCreated"> & {
	/**
	 * @generated from field: identities.v1.Org org = 1;
	 */
	org?: Org | undefined;
};

/**
 * OrgCreated is the event message published when an org is created
 *
 * @generated from message identities.v1.OrgCreated
 */
export type OrgCreatedJson = {
	/**
	 * @generated from field: identities.v1.Org org = 1;
	 */
	org?: OrgJson;
};

/**
 * Describes the message identities.v1.OrgCreated.
 * Use `create(OrgCreatedSchema)` to create a new message.
 */
export const OrgCreatedSchema: GenMessage<OrgCreated, { jsonType: OrgCreatedJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 55);

/**
 * OrgUpdated is the event message published when an org is updated
 *
 * @generated from message identities.v1.OrgUpdated
 */
export type OrgUpdated = Message<"identities.v1.OrgUpdated"> & {
	/**
	 * @generated from field: identities.v1.Org org = 1;
	 */
	org?: Org | undefined;
};

/**
 * OrgUpdated is the event message published when an org is updated
 *
 * @generated from message identities.v1.OrgUpdated
 */
export type OrgUpdatedJson = {
	/**
	 * @generated from field: identities.v1.Org org = 1;
	 */
	org?: OrgJson;
};

/**
 * Describes the message identities.v1.OrgUpdated.
 * Use `create(OrgUpdatedSchema)` to create a new message.
 */
export const OrgUpdatedSchema: GenMessage<OrgUpdated, { jsonType: OrgUpdatedJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 56);

/**
 * OrgDeleted is the event message published when an org is deleted
 *
 * @generated from message identities.v1.OrgDeleted
 */
export type OrgDeleted = Message<"identities.v1.OrgDeleted"> & {
	/**
	 * @generated from field: identities.v1.Org org = 1;
	 */
	org?: Org | undefined;
};

/**
 * OrgDeleted is the event message published when an org is deleted
 *
 * @generated from message identities.v1.OrgDeleted
 */
export type OrgDeletedJson = {
	/**
	 * @generated from field: identities.v1.Org org = 1;
	 */
	org?: OrgJson;
};

/**
 * Describes the message identities.v1.OrgDeleted.
 * Use `create(OrgDeletedSchema)` to create a new message.
 */
export const OrgDeletedSchema: GenMessage<OrgDeleted, { jsonType: OrgDeletedJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 57);

/**
 * RemoveOrgMemberRequest
 *
 * @generated from message identities.v1.RemoveOrgMemberRequest
 */
export type RemoveOrgMemberRequest = Message<"identities.v1.RemoveOrgMemberRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string user_id = 2;
	 */
	userId: string;
};

/**
 * RemoveOrgMemberRequest
 *
 * @generated from message identities.v1.RemoveOrgMemberRequest
 */
export type RemoveOrgMemberRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string user_id = 2;
	 */
	userId?: string;
};

/**
 * Describes the message identities.v1.RemoveOrgMemberRequest.
 * Use `create(RemoveOrgMemberRequestSchema)` to create a new message.
 */
export const RemoveOrgMemberRequestSchema: GenMessage<RemoveOrgMemberRequest, { jsonType: RemoveOrgMemberRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 58);

/**
 * RemoveOrgMemberResponse
 *
 * @generated from message identities.v1.RemoveOrgMemberResponse
 */
export type RemoveOrgMemberResponse = Message<"identities.v1.RemoveOrgMemberResponse"> & {};

/**
 * RemoveOrgMemberResponse
 *
 * @generated from message identities.v1.RemoveOrgMemberResponse
 */
export type RemoveOrgMemberResponseJson = {};

/**
 * Describes the message identities.v1.RemoveOrgMemberResponse.
 * Use `create(RemoveOrgMemberResponseSchema)` to create a new message.
 */
export const RemoveOrgMemberResponseSchema: GenMessage<RemoveOrgMemberResponse, { jsonType: RemoveOrgMemberResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 59);

/**
 * UpdateOrgRequest  update attributes on a user
 *
 * @generated from message identities.v1.UpdateOrgRequest
 */
export type UpdateOrgRequest = Message<"identities.v1.UpdateOrgRequest"> & {
	/**
	 * @generated from field: identities.v1.Org org = 1;
	 */
	org?: Org | undefined;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMask | undefined;
};

/**
 * UpdateOrgRequest  update attributes on a user
 *
 * @generated from message identities.v1.UpdateOrgRequest
 */
export type UpdateOrgRequestJson = {
	/**
	 * @generated from field: identities.v1.Org org = 1;
	 */
	org?: OrgJson;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMaskJson;
};

/**
 * Describes the message identities.v1.UpdateOrgRequest.
 * Use `create(UpdateOrgRequestSchema)` to create a new message.
 */
export const UpdateOrgRequestSchema: GenMessage<UpdateOrgRequest, { jsonType: UpdateOrgRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 60);

/**
 * UpdateOrgResponse
 *
 * @generated from message identities.v1.UpdateOrgResponse
 */
export type UpdateOrgResponse = Message<"identities.v1.UpdateOrgResponse"> & {
	/**
	 * @generated from field: identities.v1.Org org = 1;
	 */
	org?: Org | undefined;
};

/**
 * UpdateOrgResponse
 *
 * @generated from message identities.v1.UpdateOrgResponse
 */
export type UpdateOrgResponseJson = {
	/**
	 * @generated from field: identities.v1.Org org = 1;
	 */
	org?: OrgJson;
};

/**
 * Describes the message identities.v1.UpdateOrgResponse.
 * Use `create(UpdateOrgResponseSchema)` to create a new message.
 */
export const UpdateOrgResponseSchema: GenMessage<UpdateOrgResponse, { jsonType: UpdateOrgResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 61);

/**
 * @generated from message identities.v1.Assignment
 */
export type Assignment = Message<"identities.v1.Assignment"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string role_id = 2 [deprecated = true];
	 * @deprecated
	 */
	roleId: string;

	/**
	 * @generated from field: string team_id = 3;
	 */
	teamId: string;

	/**
	 * @generated from field: string assignable_id = 4;
	 */
	assignableId: string;

	/**
	 * @generated from field: string assignable_type = 5;
	 */
	assignableType: string;

	/**
	 * @generated from field: identities.v1.Team team = 6;
	 */
	team?: Team | undefined;

	/**
	 * @generated from field: identities.v1.Role role = 7 [deprecated = true];
	 * @deprecated
	 */
	role?: Role | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 8;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 9;
	 */
	updatedAt?: Timestamp | undefined;

	/**
	 * @generated from field: optional google.protobuf.Timestamp deleted_at = 10;
	 */
	deletedAt?: Timestamp | undefined;

	/**
	 * @generated from field: repeated identities.v1.Role roles = 11;
	 */
	roles: Role[];
};

/**
 * @generated from message identities.v1.Assignment
 */
export type AssignmentJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string role_id = 2 [deprecated = true];
	 * @deprecated
	 */
	roleId?: string;

	/**
	 * @generated from field: string team_id = 3;
	 */
	teamId?: string;

	/**
	 * @generated from field: string assignable_id = 4;
	 */
	assignableId?: string;

	/**
	 * @generated from field: string assignable_type = 5;
	 */
	assignableType?: string;

	/**
	 * @generated from field: identities.v1.Team team = 6;
	 */
	team?: TeamJson;

	/**
	 * @generated from field: identities.v1.Role role = 7 [deprecated = true];
	 * @deprecated
	 */
	role?: RoleJson;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 8;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 9;
	 */
	updatedAt?: TimestampJson;

	/**
	 * @generated from field: optional google.protobuf.Timestamp deleted_at = 10;
	 */
	deletedAt?: TimestampJson;

	/**
	 * @generated from field: repeated identities.v1.Role roles = 11;
	 */
	roles?: RoleJson[];
};

/**
 * Describes the message identities.v1.Assignment.
 * Use `create(AssignmentSchema)` to create a new message.
 */
export const AssignmentSchema: GenMessage<Assignment, { jsonType: AssignmentJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 62);

/**
 * @generated from message identities.v1.WorkspaceFilter
 */
export type WorkspaceFilter = Message<"identities.v1.WorkspaceFilter"> & {
	/**
	 * @generated from field: optional string name = 1;
	 */
	name?: string | undefined;

	/**
	 * @generated from field: optional string user_id = 2;
	 */
	userId?: string | undefined;

	/**
	 * @generated from field: optional identities.v1.MemberStatus member_status = 3;
	 */
	memberStatus?: MemberStatus | undefined;

	/**
	 * @generated from field: optional string org_id = 4;
	 */
	orgId?: string | undefined;

	/**
	 * @generated from field: optional identities.v1.WorkspaceVisibility visibility = 5;
	 */
	visibility?: WorkspaceVisibility | undefined;

	/**
	 * @generated from field: optional bool include_shared_workspaces = 6;
	 */
	includeSharedWorkspaces?: boolean | undefined;
};

/**
 * @generated from message identities.v1.WorkspaceFilter
 */
export type WorkspaceFilterJson = {
	/**
	 * @generated from field: optional string name = 1;
	 */
	name?: string;

	/**
	 * @generated from field: optional string user_id = 2;
	 */
	userId?: string;

	/**
	 * @generated from field: optional identities.v1.MemberStatus member_status = 3;
	 */
	memberStatus?: MemberStatusJson;

	/**
	 * @generated from field: optional string org_id = 4;
	 */
	orgId?: string;

	/**
	 * @generated from field: optional identities.v1.WorkspaceVisibility visibility = 5;
	 */
	visibility?: WorkspaceVisibilityJson;

	/**
	 * @generated from field: optional bool include_shared_workspaces = 6;
	 */
	includeSharedWorkspaces?: boolean;
};

/**
 * Describes the message identities.v1.WorkspaceFilter.
 * Use `create(WorkspaceFilterSchema)` to create a new message.
 */
export const WorkspaceFilterSchema: GenMessage<WorkspaceFilter, { jsonType: WorkspaceFilterJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 63);

/**
 * @generated from message identities.v1.Workspace
 */
export type Workspace = Message<"identities.v1.Workspace"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name: string;

	/**
	 * @generated from field: string description = 3;
	 */
	description: string;

	/**
	 * @generated from field: string org_id = 4;
	 */
	orgId: string;

	/**
	 * @generated from field: string org_name = 15;
	 */
	orgName: string;

	/**
	 * @generated from field: identities.v1.WorkspaceVisibility visibility = 5;
	 */
	visibility: WorkspaceVisibility;

	/**
	 * @generated from field: string photo_url = 6;
	 */
	photoUrl: string;

	/**
	 * @generated from field: string slug = 7;
	 */
	slug: string;

	/**
	 * @generated from field: int64 member_count = 8;
	 */
	memberCount: bigint;

	/**
	 * @generated from field: int64 team_count = 9;
	 */
	teamCount: bigint;

	/**
	 * @generated from field: repeated identities.v1.Member members = 10;
	 */
	members: Member[];

	/**
	 * @generated from field: repeated identities.v1.WorkspaceTeam assignments = 11;
	 */
	assignments: WorkspaceTeam[];

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 12;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 13;
	 */
	updatedAt?: Timestamp | undefined;

	/**
	 * @generated from field: optional google.protobuf.Timestamp deleted_at = 14;
	 */
	deletedAt?: Timestamp | undefined;

	/**
	 * @generated from field: optional identities.v1.OrgInviteStatus invite_status = 16;
	 */
	inviteStatus?: OrgInviteStatus | undefined;

	/**
	 * @generated from field: repeated identities.v1.SharedWorkspaceConnection shared_workspace_connections = 17;
	 */
	sharedWorkspaceConnections: SharedWorkspaceConnection[];
};

/**
 * @generated from message identities.v1.Workspace
 */
export type WorkspaceJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name?: string;

	/**
	 * @generated from field: string description = 3;
	 */
	description?: string;

	/**
	 * @generated from field: string org_id = 4;
	 */
	orgId?: string;

	/**
	 * @generated from field: string org_name = 15;
	 */
	orgName?: string;

	/**
	 * @generated from field: identities.v1.WorkspaceVisibility visibility = 5;
	 */
	visibility?: WorkspaceVisibilityJson;

	/**
	 * @generated from field: string photo_url = 6;
	 */
	photoUrl?: string;

	/**
	 * @generated from field: string slug = 7;
	 */
	slug?: string;

	/**
	 * @generated from field: int64 member_count = 8;
	 */
	memberCount?: string;

	/**
	 * @generated from field: int64 team_count = 9;
	 */
	teamCount?: string;

	/**
	 * @generated from field: repeated identities.v1.Member members = 10;
	 */
	members?: MemberJson[];

	/**
	 * @generated from field: repeated identities.v1.WorkspaceTeam assignments = 11;
	 */
	assignments?: WorkspaceTeamJson[];

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 12;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 13;
	 */
	updatedAt?: TimestampJson;

	/**
	 * @generated from field: optional google.protobuf.Timestamp deleted_at = 14;
	 */
	deletedAt?: TimestampJson;

	/**
	 * @generated from field: optional identities.v1.OrgInviteStatus invite_status = 16;
	 */
	inviteStatus?: OrgInviteStatusJson;

	/**
	 * @generated from field: repeated identities.v1.SharedWorkspaceConnection shared_workspace_connections = 17;
	 */
	sharedWorkspaceConnections?: SharedWorkspaceConnectionJson[];
};

/**
 * Describes the message identities.v1.Workspace.
 * Use `create(WorkspaceSchema)` to create a new message.
 */
export const WorkspaceSchema: GenMessage<Workspace, { jsonType: WorkspaceJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 64);

/**
 * Basic info about the workspace for displaying without returning secure data
 *
 * @generated from message identities.v1.WorkspacePublicInfo
 */
export type WorkspacePublicInfo = Message<"identities.v1.WorkspacePublicInfo"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name: string;

	/**
	 * @generated from field: string description = 3;
	 */
	description: string;

	/**
	 * @generated from field: string photo_url = 4;
	 */
	photoUrl: string;

	/**
	 * @generated from field: string org_name = 5;
	 */
	orgName: string;

	/**
	 * @generated from field: string org_id = 6;
	 */
	orgId: string;
};

/**
 * Basic info about the workspace for displaying without returning secure data
 *
 * @generated from message identities.v1.WorkspacePublicInfo
 */
export type WorkspacePublicInfoJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name?: string;

	/**
	 * @generated from field: string description = 3;
	 */
	description?: string;

	/**
	 * @generated from field: string photo_url = 4;
	 */
	photoUrl?: string;

	/**
	 * @generated from field: string org_name = 5;
	 */
	orgName?: string;

	/**
	 * @generated from field: string org_id = 6;
	 */
	orgId?: string;
};

/**
 * Describes the message identities.v1.WorkspacePublicInfo.
 * Use `create(WorkspacePublicInfoSchema)` to create a new message.
 */
export const WorkspacePublicInfoSchema: GenMessage<WorkspacePublicInfo, { jsonType: WorkspacePublicInfoJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 65);

/**
 * @generated from message identities.v1.WorkspaceCreated
 */
export type WorkspaceCreated = Message<"identities.v1.WorkspaceCreated"> & {
	/**
	 * @generated from field: string user_id = 1;
	 */
	userId: string;

	/**
	 * @generated from field: string email = 2;
	 */
	email: string;

	/**
	 * @generated from field: identities.v1.Workspace workspace = 3;
	 */
	workspace?: Workspace | undefined;
};

/**
 * @generated from message identities.v1.WorkspaceCreated
 */
export type WorkspaceCreatedJson = {
	/**
	 * @generated from field: string user_id = 1;
	 */
	userId?: string;

	/**
	 * @generated from field: string email = 2;
	 */
	email?: string;

	/**
	 * @generated from field: identities.v1.Workspace workspace = 3;
	 */
	workspace?: WorkspaceJson;
};

/**
 * Describes the message identities.v1.WorkspaceCreated.
 * Use `create(WorkspaceCreatedSchema)` to create a new message.
 */
export const WorkspaceCreatedSchema: GenMessage<WorkspaceCreated, { jsonType: WorkspaceCreatedJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 66);

/**
 * @generated from message identities.v1.WorkspaceDeleted
 */
export type WorkspaceDeleted = Message<"identities.v1.WorkspaceDeleted"> & {
	/**
	 * @generated from field: string user_id = 1;
	 */
	userId: string;

	/**
	 * @generated from field: string email = 2;
	 */
	email: string;

	/**
	 * @generated from field: identities.v1.Workspace workspace = 3;
	 */
	workspace?: Workspace | undefined;
};

/**
 * @generated from message identities.v1.WorkspaceDeleted
 */
export type WorkspaceDeletedJson = {
	/**
	 * @generated from field: string user_id = 1;
	 */
	userId?: string;

	/**
	 * @generated from field: string email = 2;
	 */
	email?: string;

	/**
	 * @generated from field: identities.v1.Workspace workspace = 3;
	 */
	workspace?: WorkspaceJson;
};

/**
 * Describes the message identities.v1.WorkspaceDeleted.
 * Use `create(WorkspaceDeletedSchema)` to create a new message.
 */
export const WorkspaceDeletedSchema: GenMessage<WorkspaceDeleted, { jsonType: WorkspaceDeletedJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 67);

/**
 * RemoveWorkspaceMemberRequest
 *
 * @generated from message identities.v1.RemoveWorkspaceMemberRequest
 */
export type RemoveWorkspaceMemberRequest = Message<"identities.v1.RemoveWorkspaceMemberRequest"> & {
	/**
	 * @generated from field: string workspace_id = 1;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string user_id = 2;
	 */
	userId: string;
};

/**
 * RemoveWorkspaceMemberRequest
 *
 * @generated from message identities.v1.RemoveWorkspaceMemberRequest
 */
export type RemoveWorkspaceMemberRequestJson = {
	/**
	 * @generated from field: string workspace_id = 1;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string user_id = 2;
	 */
	userId?: string;
};

/**
 * Describes the message identities.v1.RemoveWorkspaceMemberRequest.
 * Use `create(RemoveWorkspaceMemberRequestSchema)` to create a new message.
 */
export const RemoveWorkspaceMemberRequestSchema: GenMessage<RemoveWorkspaceMemberRequest, { jsonType: RemoveWorkspaceMemberRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 68);

/**
 * RemoveWorkspaceMemberResponse
 *
 * @generated from message identities.v1.RemoveWorkspaceMemberResponse
 */
export type RemoveWorkspaceMemberResponse = Message<"identities.v1.RemoveWorkspaceMemberResponse"> & {};

/**
 * RemoveWorkspaceMemberResponse
 *
 * @generated from message identities.v1.RemoveWorkspaceMemberResponse
 */
export type RemoveWorkspaceMemberResponseJson = {};

/**
 * Describes the message identities.v1.RemoveWorkspaceMemberResponse.
 * Use `create(RemoveWorkspaceMemberResponseSchema)` to create a new message.
 */
export const RemoveWorkspaceMemberResponseSchema: GenMessage<RemoveWorkspaceMemberResponse, { jsonType: RemoveWorkspaceMemberResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 69);

/**
 * @generated from message identities.v1.RemoveUserFromWorkspacesRequest
 */
export type RemoveUserFromWorkspacesRequest = Message<"identities.v1.RemoveUserFromWorkspacesRequest"> & {
	/**
	 * @generated from field: string user_id = 1;
	 */
	userId: string;

	/**
	 * @generated from field: repeated string workspace_ids = 2;
	 */
	workspaceIds: string[];
};

/**
 * @generated from message identities.v1.RemoveUserFromWorkspacesRequest
 */
export type RemoveUserFromWorkspacesRequestJson = {
	/**
	 * @generated from field: string user_id = 1;
	 */
	userId?: string;

	/**
	 * @generated from field: repeated string workspace_ids = 2;
	 */
	workspaceIds?: string[];
};

/**
 * Describes the message identities.v1.RemoveUserFromWorkspacesRequest.
 * Use `create(RemoveUserFromWorkspacesRequestSchema)` to create a new message.
 */
export const RemoveUserFromWorkspacesRequestSchema: GenMessage<RemoveUserFromWorkspacesRequest, { jsonType: RemoveUserFromWorkspacesRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 70);

/**
 * @generated from message identities.v1.RemoveUserFromWorkspacesResponse
 */
export type RemoveUserFromWorkspacesResponse = Message<"identities.v1.RemoveUserFromWorkspacesResponse"> & {};

/**
 * @generated from message identities.v1.RemoveUserFromWorkspacesResponse
 */
export type RemoveUserFromWorkspacesResponseJson = {};

/**
 * Describes the message identities.v1.RemoveUserFromWorkspacesResponse.
 * Use `create(RemoveUserFromWorkspacesResponseSchema)` to create a new message.
 */
export const RemoveUserFromWorkspacesResponseSchema: GenMessage<RemoveUserFromWorkspacesResponse, { jsonType: RemoveUserFromWorkspacesResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 71);

/**
 * GetWorkspaceRequest is the request object to get a user by id
 *
 * @generated from message identities.v1.GetWorkspaceRequest
 */
export type GetWorkspaceRequest = Message<"identities.v1.GetWorkspaceRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;

	/**
	 * @generated from field: string slug = 3;
	 */
	slug: string;
};

/**
 * GetWorkspaceRequest is the request object to get a user by id
 *
 * @generated from message identities.v1.GetWorkspaceRequest
 */
export type GetWorkspaceRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;

	/**
	 * @generated from field: string slug = 3;
	 */
	slug?: string;
};

/**
 * Describes the message identities.v1.GetWorkspaceRequest.
 * Use `create(GetWorkspaceRequestSchema)` to create a new message.
 */
export const GetWorkspaceRequestSchema: GenMessage<GetWorkspaceRequest, { jsonType: GetWorkspaceRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 72);

/**
 * GetWorkspaceResponse returned by the get request for the Workspace returning the Workspace
 *
 * @generated from message identities.v1.GetWorkspaceResponse
 */
export type GetWorkspaceResponse = Message<"identities.v1.GetWorkspaceResponse"> & {
	/**
	 * @generated from field: identities.v1.Workspace workspace = 1;
	 */
	workspace?: Workspace | undefined;
};

/**
 * GetWorkspaceResponse returned by the get request for the Workspace returning the Workspace
 *
 * @generated from message identities.v1.GetWorkspaceResponse
 */
export type GetWorkspaceResponseJson = {
	/**
	 * @generated from field: identities.v1.Workspace workspace = 1;
	 */
	workspace?: WorkspaceJson;
};

/**
 * Describes the message identities.v1.GetWorkspaceResponse.
 * Use `create(GetWorkspaceResponseSchema)` to create a new message.
 */
export const GetWorkspaceResponseSchema: GenMessage<GetWorkspaceResponse, { jsonType: GetWorkspaceResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 73);

/**
 * GetDefaultWorkspaceRequest is the request object to get a user by id
 *
 * @generated from message identities.v1.GetDefaultWorkspaceRequest
 */
export type GetDefaultWorkspaceRequest = Message<"identities.v1.GetDefaultWorkspaceRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string slug = 2;
	 */
	slug: string;
};

/**
 * GetDefaultWorkspaceRequest is the request object to get a user by id
 *
 * @generated from message identities.v1.GetDefaultWorkspaceRequest
 */
export type GetDefaultWorkspaceRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string slug = 2;
	 */
	slug?: string;
};

/**
 * Describes the message identities.v1.GetDefaultWorkspaceRequest.
 * Use `create(GetDefaultWorkspaceRequestSchema)` to create a new message.
 */
export const GetDefaultWorkspaceRequestSchema: GenMessage<GetDefaultWorkspaceRequest, { jsonType: GetDefaultWorkspaceRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 74);

/**
 * GetDefaultWorkspaceResponse returned by the get request for the Workspace returning the Workspace
 *
 * @generated from message identities.v1.GetDefaultWorkspaceResponse
 */
export type GetDefaultWorkspaceResponse = Message<"identities.v1.GetDefaultWorkspaceResponse"> & {
	/**
	 * @generated from field: identities.v1.Workspace workspace = 1;
	 */
	workspace?: Workspace | undefined;
};

/**
 * GetDefaultWorkspaceResponse returned by the get request for the Workspace returning the Workspace
 *
 * @generated from message identities.v1.GetDefaultWorkspaceResponse
 */
export type GetDefaultWorkspaceResponseJson = {
	/**
	 * @generated from field: identities.v1.Workspace workspace = 1;
	 */
	workspace?: WorkspaceJson;
};

/**
 * Describes the message identities.v1.GetDefaultWorkspaceResponse.
 * Use `create(GetDefaultWorkspaceResponseSchema)` to create a new message.
 */
export const GetDefaultWorkspaceResponseSchema: GenMessage<GetDefaultWorkspaceResponse, { jsonType: GetDefaultWorkspaceResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 75);

/**
 * CreateWorkspaceResponse is the object holding a user that is to be created
 *
 * @generated from message identities.v1.CreateWorkspaceRequest
 */
export type CreateWorkspaceRequest = Message<"identities.v1.CreateWorkspaceRequest"> & {
	/**
	 * @generated from field: string name = 1;
	 */
	name: string;

	/**
	 * @generated from field: string description = 2;
	 */
	description: string;

	/**
	 * @generated from field: string org_id = 3;
	 */
	orgId: string;

	/**
	 * @generated from field: string photo_url = 4;
	 */
	photoUrl: string;

	/**
	 * @generated from field: string slug = 5;
	 */
	slug: string;

	/**
	 * @generated from field: identities.v1.WorkspaceVisibility visibility = 6;
	 */
	visibility: WorkspaceVisibility;

	/**
	 * Setting the user_id with visibility PERSONAL will create a personal workspace for the user
	 *
	 * @generated from field: string user_id = 7;
	 */
	userId: string;
};

/**
 * CreateWorkspaceResponse is the object holding a user that is to be created
 *
 * @generated from message identities.v1.CreateWorkspaceRequest
 */
export type CreateWorkspaceRequestJson = {
	/**
	 * @generated from field: string name = 1;
	 */
	name?: string;

	/**
	 * @generated from field: string description = 2;
	 */
	description?: string;

	/**
	 * @generated from field: string org_id = 3;
	 */
	orgId?: string;

	/**
	 * @generated from field: string photo_url = 4;
	 */
	photoUrl?: string;

	/**
	 * @generated from field: string slug = 5;
	 */
	slug?: string;

	/**
	 * @generated from field: identities.v1.WorkspaceVisibility visibility = 6;
	 */
	visibility?: WorkspaceVisibilityJson;

	/**
	 * Setting the user_id with visibility PERSONAL will create a personal workspace for the user
	 *
	 * @generated from field: string user_id = 7;
	 */
	userId?: string;
};

/**
 * Describes the message identities.v1.CreateWorkspaceRequest.
 * Use `create(CreateWorkspaceRequestSchema)` to create a new message.
 */
export const CreateWorkspaceRequestSchema: GenMessage<CreateWorkspaceRequest, { jsonType: CreateWorkspaceRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 76);

/**
 * CreateWorkspaceResponse is the response to the create Workspace request sending back the id of the created
 *
 * @generated from message identities.v1.CreateWorkspaceResponse
 */
export type CreateWorkspaceResponse = Message<"identities.v1.CreateWorkspaceResponse"> & {
	/**
	 * @generated from field: identities.v1.Workspace workspace = 1;
	 */
	workspace?: Workspace | undefined;
};

/**
 * CreateWorkspaceResponse is the response to the create Workspace request sending back the id of the created
 *
 * @generated from message identities.v1.CreateWorkspaceResponse
 */
export type CreateWorkspaceResponseJson = {
	/**
	 * @generated from field: identities.v1.Workspace workspace = 1;
	 */
	workspace?: WorkspaceJson;
};

/**
 * Describes the message identities.v1.CreateWorkspaceResponse.
 * Use `create(CreateWorkspaceResponseSchema)` to create a new message.
 */
export const CreateWorkspaceResponseSchema: GenMessage<CreateWorkspaceResponse, { jsonType: CreateWorkspaceResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 77);

/**
 * ListWorkspacesRequest is an empty object, later we can fill it with filtering options
 *
 * @generated from message identities.v1.ListWorkspacesRequest
 */
export type ListWorkspacesRequest = Message<"identities.v1.ListWorkspacesRequest"> & {
	/**
	 * @generated from field: identities.v1.WorkspaceFilter filter = 1;
	 */
	filter?: WorkspaceFilter | undefined;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 2;
	 */
	paginate?: PaginationArguments | undefined;
};

/**
 * ListWorkspacesRequest is an empty object, later we can fill it with filtering options
 *
 * @generated from message identities.v1.ListWorkspacesRequest
 */
export type ListWorkspacesRequestJson = {
	/**
	 * @generated from field: identities.v1.WorkspaceFilter filter = 1;
	 */
	filter?: WorkspaceFilterJson;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 2;
	 */
	paginate?: PaginationArgumentsJson;
};

/**
 * Describes the message identities.v1.ListWorkspacesRequest.
 * Use `create(ListWorkspacesRequestSchema)` to create a new message.
 */
export const ListWorkspacesRequestSchema: GenMessage<ListWorkspacesRequest, { jsonType: ListWorkspacesRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 78);

/**
 * ListWorkspacesResponse returns an array of users
 *
 * @generated from message identities.v1.ListWorkspacesResponse
 */
export type ListWorkspacesResponse = Message<"identities.v1.ListWorkspacesResponse"> & {
	/**
	 * @generated from field: repeated identities.v1.Workspace items = 1;
	 */
	items: Workspace[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * ListWorkspacesResponse returns an array of users
 *
 * @generated from message identities.v1.ListWorkspacesResponse
 */
export type ListWorkspacesResponseJson = {
	/**
	 * @generated from field: repeated identities.v1.Workspace items = 1;
	 */
	items?: WorkspaceJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message identities.v1.ListWorkspacesResponse.
 * Use `create(ListWorkspacesResponseSchema)` to create a new message.
 */
export const ListWorkspacesResponseSchema: GenMessage<ListWorkspacesResponse, { jsonType: ListWorkspacesResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 79);

/**
 * ListWorkspacesByOrgRequest is an empty object, later we can fill it with filtering options
 *
 * @generated from message identities.v1.ListWorkspacesByOrgRequest
 */
export type ListWorkspacesByOrgRequest = Message<"identities.v1.ListWorkspacesByOrgRequest"> & {
	/**
	 * @generated from field: identities.v1.WorkspaceFilter filter = 1;
	 */
	filter?: WorkspaceFilter | undefined;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 2;
	 */
	paginate?: PaginationArguments | undefined;
};

/**
 * ListWorkspacesByOrgRequest is an empty object, later we can fill it with filtering options
 *
 * @generated from message identities.v1.ListWorkspacesByOrgRequest
 */
export type ListWorkspacesByOrgRequestJson = {
	/**
	 * @generated from field: identities.v1.WorkspaceFilter filter = 1;
	 */
	filter?: WorkspaceFilterJson;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 2;
	 */
	paginate?: PaginationArgumentsJson;
};

/**
 * Describes the message identities.v1.ListWorkspacesByOrgRequest.
 * Use `create(ListWorkspacesByOrgRequestSchema)` to create a new message.
 */
export const ListWorkspacesByOrgRequestSchema: GenMessage<ListWorkspacesByOrgRequest, { jsonType: ListWorkspacesByOrgRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 80);

/**
 * ListWorkspacesByOrgResponse returns an array of users
 *
 * @generated from message identities.v1.ListWorkspacesByOrgResponse
 */
export type ListWorkspacesByOrgResponse = Message<"identities.v1.ListWorkspacesByOrgResponse"> & {
	/**
	 * @generated from field: repeated identities.v1.Workspace items = 1;
	 */
	items: Workspace[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * ListWorkspacesByOrgResponse returns an array of users
 *
 * @generated from message identities.v1.ListWorkspacesByOrgResponse
 */
export type ListWorkspacesByOrgResponseJson = {
	/**
	 * @generated from field: repeated identities.v1.Workspace items = 1;
	 */
	items?: WorkspaceJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message identities.v1.ListWorkspacesByOrgResponse.
 * Use `create(ListWorkspacesByOrgResponseSchema)` to create a new message.
 */
export const ListWorkspacesByOrgResponseSchema: GenMessage<ListWorkspacesByOrgResponse, { jsonType: ListWorkspacesByOrgResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 81);

/**
 * GetWorkspacesByIds is the request object to get a group of users by ids
 *
 * @generated from message identities.v1.GetWorkspacesByIdsRequest
 */
export type GetWorkspacesByIdsRequest = Message<"identities.v1.GetWorkspacesByIdsRequest"> & {
	/**
	 * @generated from field: repeated string ids = 1;
	 */
	ids: string[];

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;
};

/**
 * GetWorkspacesByIds is the request object to get a group of users by ids
 *
 * @generated from message identities.v1.GetWorkspacesByIdsRequest
 */
export type GetWorkspacesByIdsRequestJson = {
	/**
	 * @generated from field: repeated string ids = 1;
	 */
	ids?: string[];

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;
};

/**
 * Describes the message identities.v1.GetWorkspacesByIdsRequest.
 * Use `create(GetWorkspacesByIdsRequestSchema)` to create a new message.
 */
export const GetWorkspacesByIdsRequestSchema: GenMessage<GetWorkspacesByIdsRequest, { jsonType: GetWorkspacesByIdsRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 82);

/**
 * GetWorkspacesByIdsResponse
 *
 * @generated from message identities.v1.GetWorkspacesByIdsResponse
 */
export type GetWorkspacesByIdsResponse = Message<"identities.v1.GetWorkspacesByIdsResponse"> & {
	/**
	 * @generated from field: repeated identities.v1.Workspace items = 1;
	 */
	items: Workspace[];
};

/**
 * GetWorkspacesByIdsResponse
 *
 * @generated from message identities.v1.GetWorkspacesByIdsResponse
 */
export type GetWorkspacesByIdsResponseJson = {
	/**
	 * @generated from field: repeated identities.v1.Workspace items = 1;
	 */
	items?: WorkspaceJson[];
};

/**
 * Describes the message identities.v1.GetWorkspacesByIdsResponse.
 * Use `create(GetWorkspacesByIdsResponseSchema)` to create a new message.
 */
export const GetWorkspacesByIdsResponseSchema: GenMessage<GetWorkspacesByIdsResponse, { jsonType: GetWorkspacesByIdsResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 83);

/**
 * DeleteWorkspaceRequest holds an id which is then deleted from the database
 *
 * @generated from message identities.v1.DeleteWorkspaceRequest
 */
export type DeleteWorkspaceRequest = Message<"identities.v1.DeleteWorkspaceRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;
};

/**
 * DeleteWorkspaceRequest holds an id which is then deleted from the database
 *
 * @generated from message identities.v1.DeleteWorkspaceRequest
 */
export type DeleteWorkspaceRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;
};

/**
 * Describes the message identities.v1.DeleteWorkspaceRequest.
 * Use `create(DeleteWorkspaceRequestSchema)` to create a new message.
 */
export const DeleteWorkspaceRequestSchema: GenMessage<DeleteWorkspaceRequest, { jsonType: DeleteWorkspaceRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 84);

/**
 * DeleteWorkspaceResponse <haven't figured out what to put here yet>
 *
 * @generated from message identities.v1.DeleteWorkspaceResponse
 */
export type DeleteWorkspaceResponse = Message<"identities.v1.DeleteWorkspaceResponse"> & {
	/**
	 * @generated from field: identities.v1.Workspace workspace = 1;
	 */
	workspace?: Workspace | undefined;
};

/**
 * DeleteWorkspaceResponse <haven't figured out what to put here yet>
 *
 * @generated from message identities.v1.DeleteWorkspaceResponse
 */
export type DeleteWorkspaceResponseJson = {
	/**
	 * @generated from field: identities.v1.Workspace workspace = 1;
	 */
	workspace?: WorkspaceJson;
};

/**
 * Describes the message identities.v1.DeleteWorkspaceResponse.
 * Use `create(DeleteWorkspaceResponseSchema)` to create a new message.
 */
export const DeleteWorkspaceResponseSchema: GenMessage<DeleteWorkspaceResponse, { jsonType: DeleteWorkspaceResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 85);

/**
 * UpdateWorkspaceRequest  update attributes on a user
 *
 * @generated from message identities.v1.UpdateWorkspaceRequest
 */
export type UpdateWorkspaceRequest = Message<"identities.v1.UpdateWorkspaceRequest"> & {
	/**
	 * @generated from field: identities.v1.Workspace workspace = 1;
	 */
	workspace?: Workspace | undefined;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMask | undefined;
};

/**
 * UpdateWorkspaceRequest  update attributes on a user
 *
 * @generated from message identities.v1.UpdateWorkspaceRequest
 */
export type UpdateWorkspaceRequestJson = {
	/**
	 * @generated from field: identities.v1.Workspace workspace = 1;
	 */
	workspace?: WorkspaceJson;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMaskJson;
};

/**
 * Describes the message identities.v1.UpdateWorkspaceRequest.
 * Use `create(UpdateWorkspaceRequestSchema)` to create a new message.
 */
export const UpdateWorkspaceRequestSchema: GenMessage<UpdateWorkspaceRequest, { jsonType: UpdateWorkspaceRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 86);

/**
 * UpdateWorkspaceReesponse
 *
 * @generated from message identities.v1.UpdateWorkspaceResponse
 */
export type UpdateWorkspaceResponse = Message<"identities.v1.UpdateWorkspaceResponse"> & {
	/**
	 * @generated from field: identities.v1.Workspace workspace = 1;
	 */
	workspace?: Workspace | undefined;
};

/**
 * UpdateWorkspaceReesponse
 *
 * @generated from message identities.v1.UpdateWorkspaceResponse
 */
export type UpdateWorkspaceResponseJson = {
	/**
	 * @generated from field: identities.v1.Workspace workspace = 1;
	 */
	workspace?: WorkspaceJson;
};

/**
 * Describes the message identities.v1.UpdateWorkspaceResponse.
 * Use `create(UpdateWorkspaceResponseSchema)` to create a new message.
 */
export const UpdateWorkspaceResponseSchema: GenMessage<UpdateWorkspaceResponse, { jsonType: UpdateWorkspaceResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 87);

/**
 * @generated from message identities.v1.AssignTeamRequestDetails
 */
export type AssignTeamRequestDetails = Message<"identities.v1.AssignTeamRequestDetails"> & {
	/**
	 * @generated from field: string team_id = 1;
	 */
	teamId: string;

	/**
	 * @generated from field: string role = 2 [deprecated = true];
	 * @deprecated
	 */
	role: string;

	/**
	 * @generated from field: repeated string role_names = 3;
	 */
	roleNames: string[];
};

/**
 * @generated from message identities.v1.AssignTeamRequestDetails
 */
export type AssignTeamRequestDetailsJson = {
	/**
	 * @generated from field: string team_id = 1;
	 */
	teamId?: string;

	/**
	 * @generated from field: string role = 2 [deprecated = true];
	 * @deprecated
	 */
	role?: string;

	/**
	 * @generated from field: repeated string role_names = 3;
	 */
	roleNames?: string[];
};

/**
 * Describes the message identities.v1.AssignTeamRequestDetails.
 * Use `create(AssignTeamRequestDetailsSchema)` to create a new message.
 */
export const AssignTeamRequestDetailsSchema: GenMessage<AssignTeamRequestDetails, { jsonType: AssignTeamRequestDetailsJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 88);

/**
 * @generated from message identities.v1.AssignTeamRequest
 */
export type AssignTeamRequest = Message<"identities.v1.AssignTeamRequest"> & {
	/**
	 * @generated from field: string workspace_id = 1;
	 */
	workspaceId: string;

	/**
	 * @generated from field: repeated identities.v1.AssignTeamRequestDetails teams = 2;
	 */
	teams: AssignTeamRequestDetails[];
};

/**
 * @generated from message identities.v1.AssignTeamRequest
 */
export type AssignTeamRequestJson = {
	/**
	 * @generated from field: string workspace_id = 1;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: repeated identities.v1.AssignTeamRequestDetails teams = 2;
	 */
	teams?: AssignTeamRequestDetailsJson[];
};

/**
 * Describes the message identities.v1.AssignTeamRequest.
 * Use `create(AssignTeamRequestSchema)` to create a new message.
 */
export const AssignTeamRequestSchema: GenMessage<AssignTeamRequest, { jsonType: AssignTeamRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 89);

/**
 * @generated from message identities.v1.AssignTeamResponse
 */
export type AssignTeamResponse = Message<"identities.v1.AssignTeamResponse"> & {
	/**
	 * @generated from field: identities.v1.Workspace workspace = 1;
	 */
	workspace?: Workspace | undefined;
};

/**
 * @generated from message identities.v1.AssignTeamResponse
 */
export type AssignTeamResponseJson = {
	/**
	 * @generated from field: identities.v1.Workspace workspace = 1;
	 */
	workspace?: WorkspaceJson;
};

/**
 * Describes the message identities.v1.AssignTeamResponse.
 * Use `create(AssignTeamResponseSchema)` to create a new message.
 */
export const AssignTeamResponseSchema: GenMessage<AssignTeamResponse, { jsonType: AssignTeamResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 90);

/**
 * @generated from message identities.v1.UnassignTeamRequest
 */
export type UnassignTeamRequest = Message<"identities.v1.UnassignTeamRequest"> & {
	/**
	 * @generated from field: string workspace_id = 1;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string team_id = 2;
	 */
	teamId: string;
};

/**
 * @generated from message identities.v1.UnassignTeamRequest
 */
export type UnassignTeamRequestJson = {
	/**
	 * @generated from field: string workspace_id = 1;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string team_id = 2;
	 */
	teamId?: string;
};

/**
 * Describes the message identities.v1.UnassignTeamRequest.
 * Use `create(UnassignTeamRequestSchema)` to create a new message.
 */
export const UnassignTeamRequestSchema: GenMessage<UnassignTeamRequest, { jsonType: UnassignTeamRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 91);

/**
 * @generated from message identities.v1.UnassignTeamResponse
 */
export type UnassignTeamResponse = Message<"identities.v1.UnassignTeamResponse"> & {};

/**
 * @generated from message identities.v1.UnassignTeamResponse
 */
export type UnassignTeamResponseJson = {};

/**
 * Describes the message identities.v1.UnassignTeamResponse.
 * Use `create(UnassignTeamResponseSchema)` to create a new message.
 */
export const UnassignTeamResponseSchema: GenMessage<UnassignTeamResponse, { jsonType: UnassignTeamResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 92);

/**
 * UpdateWorkspaceRequest role on
 *
 * @generated from message identities.v1.UpdateAssignTeamRequest
 */
export type UpdateAssignTeamRequest = Message<"identities.v1.UpdateAssignTeamRequest"> & {
	/**
	 * @generated from field: string workspace_id = 1;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string team_id = 2;
	 */
	teamId: string;

	/**
	 * @generated from field: string role = 3 [deprecated = true];
	 * @deprecated
	 */
	role: string;

	/**
	 * @generated from field: repeated string role_names = 4;
	 */
	roleNames: string[];
};

/**
 * UpdateWorkspaceRequest role on
 *
 * @generated from message identities.v1.UpdateAssignTeamRequest
 */
export type UpdateAssignTeamRequestJson = {
	/**
	 * @generated from field: string workspace_id = 1;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string team_id = 2;
	 */
	teamId?: string;

	/**
	 * @generated from field: string role = 3 [deprecated = true];
	 * @deprecated
	 */
	role?: string;

	/**
	 * @generated from field: repeated string role_names = 4;
	 */
	roleNames?: string[];
};

/**
 * Describes the message identities.v1.UpdateAssignTeamRequest.
 * Use `create(UpdateAssignTeamRequestSchema)` to create a new message.
 */
export const UpdateAssignTeamRequestSchema: GenMessage<UpdateAssignTeamRequest, { jsonType: UpdateAssignTeamRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 93);

/**
 * @generated from message identities.v1.UpdateAssignTeamResponse
 */
export type UpdateAssignTeamResponse = Message<"identities.v1.UpdateAssignTeamResponse"> & {
	/**
	 * @generated from field: identities.v1.WorkspaceTeam assignment = 1;
	 */
	assignment?: WorkspaceTeam | undefined;
};

/**
 * @generated from message identities.v1.UpdateAssignTeamResponse
 */
export type UpdateAssignTeamResponseJson = {
	/**
	 * @generated from field: identities.v1.WorkspaceTeam assignment = 1;
	 */
	assignment?: WorkspaceTeamJson;
};

/**
 * Describes the message identities.v1.UpdateAssignTeamResponse.
 * Use `create(UpdateAssignTeamResponseSchema)` to create a new message.
 */
export const UpdateAssignTeamResponseSchema: GenMessage<UpdateAssignTeamResponse, { jsonType: UpdateAssignTeamResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 94);

/**
 * @generated from message identities.v1.MemberFilter
 */
export type MemberFilter = Message<"identities.v1.MemberFilter"> & {
	/**
	 * @generated from field: optional string memberable_id = 1;
	 */
	memberableId?: string | undefined;

	/**
	 * @generated from field: optional identities.v1.MemberType memberable_type = 2;
	 */
	memberableType?: MemberType | undefined;

	/**
	 * @generated from field: optional string user_id = 3;
	 */
	userId?: string | undefined;

	/**
	 * @generated from field: optional string org_id = 4;
	 */
	orgId?: string | undefined;

	/**
	 * @generated from field: optional string email = 5;
	 */
	email?: string | undefined;

	/**
	 * @generated from field: optional string name = 6;
	 */
	name?: string | undefined;
};

/**
 * @generated from message identities.v1.MemberFilter
 */
export type MemberFilterJson = {
	/**
	 * @generated from field: optional string memberable_id = 1;
	 */
	memberableId?: string;

	/**
	 * @generated from field: optional identities.v1.MemberType memberable_type = 2;
	 */
	memberableType?: MemberTypeJson;

	/**
	 * @generated from field: optional string user_id = 3;
	 */
	userId?: string;

	/**
	 * @generated from field: optional string org_id = 4;
	 */
	orgId?: string;

	/**
	 * @generated from field: optional string email = 5;
	 */
	email?: string;

	/**
	 * @generated from field: optional string name = 6;
	 */
	name?: string;
};

/**
 * Describes the message identities.v1.MemberFilter.
 * Use `create(MemberFilterSchema)` to create a new message.
 */
export const MemberFilterSchema: GenMessage<MemberFilter, { jsonType: MemberFilterJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 95);

/**
 * Member
 *
 * @generated from message identities.v1.Member
 */
export type Member = Message<"identities.v1.Member"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string user_id = 2;
	 */
	userId: string;

	/**
	 * @generated from field: string invitation_id = 3;
	 */
	invitationId: string;

	/**
	 * @generated from field: string account_id = 4;
	 */
	accountId: string;

	/**
	 * @generated from field: string email = 5;
	 */
	email: string;

	/**
	 * @generated from field: identities.v1.MemberStatus status = 6;
	 */
	status: MemberStatus;

	/**
	 * @generated from field: string memberable_id = 7;
	 */
	memberableId: string;

	/**
	 * @generated from field: string memberable_type = 8;
	 */
	memberableType: string;

	/**
	 * @generated from field: identities.v1.User user = 9;
	 */
	user?: User | undefined;

	/**
	 * @generated from field: identities.v1.Workspace workspace = 10;
	 */
	workspace?: Workspace | undefined;

	/**
	 * @generated from field: identities.v1.Team team = 11;
	 */
	team?: Team | undefined;

	/**
	 * @generated from field: identities.v1.Org org = 16;
	 */
	org?: Org | undefined;

	/**
	 * @generated from field: repeated identities.v1.Role roles = 12;
	 */
	roles: Role[];

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 13;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 14;
	 */
	updatedAt?: Timestamp | undefined;

	/**
	 * @generated from field: optional google.protobuf.Timestamp deleted_at = 15;
	 */
	deletedAt?: Timestamp | undefined;

	/**
	 * @generated from field: identities.v1.Invitation invitation = 17;
	 */
	invitation?: Invitation | undefined;
};

/**
 * Member
 *
 * @generated from message identities.v1.Member
 */
export type MemberJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string user_id = 2;
	 */
	userId?: string;

	/**
	 * @generated from field: string invitation_id = 3;
	 */
	invitationId?: string;

	/**
	 * @generated from field: string account_id = 4;
	 */
	accountId?: string;

	/**
	 * @generated from field: string email = 5;
	 */
	email?: string;

	/**
	 * @generated from field: identities.v1.MemberStatus status = 6;
	 */
	status?: MemberStatusJson;

	/**
	 * @generated from field: string memberable_id = 7;
	 */
	memberableId?: string;

	/**
	 * @generated from field: string memberable_type = 8;
	 */
	memberableType?: string;

	/**
	 * @generated from field: identities.v1.User user = 9;
	 */
	user?: UserJson;

	/**
	 * @generated from field: identities.v1.Workspace workspace = 10;
	 */
	workspace?: WorkspaceJson;

	/**
	 * @generated from field: identities.v1.Team team = 11;
	 */
	team?: TeamJson;

	/**
	 * @generated from field: identities.v1.Org org = 16;
	 */
	org?: OrgJson;

	/**
	 * @generated from field: repeated identities.v1.Role roles = 12;
	 */
	roles?: RoleJson[];

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 13;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 14;
	 */
	updatedAt?: TimestampJson;

	/**
	 * @generated from field: optional google.protobuf.Timestamp deleted_at = 15;
	 */
	deletedAt?: TimestampJson;

	/**
	 * @generated from field: identities.v1.Invitation invitation = 17;
	 */
	invitation?: InvitationJson;
};

/**
 * Describes the message identities.v1.Member.
 * Use `create(MemberSchema)` to create a new message.
 */
export const MemberSchema: GenMessage<Member, { jsonType: MemberJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 96);

/**
 * MemberCreated is the event message published when a memebership is created
 *
 * @generated from message identities.v1.MemberCreated
 */
export type MemberCreated = Message<"identities.v1.MemberCreated"> & {
	/**
	 * @generated from field: identities.v1.Member member = 1;
	 */
	member?: Member | undefined;
};

/**
 * MemberCreated is the event message published when a memebership is created
 *
 * @generated from message identities.v1.MemberCreated
 */
export type MemberCreatedJson = {
	/**
	 * @generated from field: identities.v1.Member member = 1;
	 */
	member?: MemberJson;
};

/**
 * Describes the message identities.v1.MemberCreated.
 * Use `create(MemberCreatedSchema)` to create a new message.
 */
export const MemberCreatedSchema: GenMessage<MemberCreated, { jsonType: MemberCreatedJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 97);

/**
 * MemberUpdated is the event message published when a memebership is updated
 *
 * @generated from message identities.v1.MemberUpdated
 */
export type MemberUpdated = Message<"identities.v1.MemberUpdated"> & {
	/**
	 * @generated from field: identities.v1.Member member = 1;
	 */
	member?: Member | undefined;
};

/**
 * MemberUpdated is the event message published when a memebership is updated
 *
 * @generated from message identities.v1.MemberUpdated
 */
export type MemberUpdatedJson = {
	/**
	 * @generated from field: identities.v1.Member member = 1;
	 */
	member?: MemberJson;
};

/**
 * Describes the message identities.v1.MemberUpdated.
 * Use `create(MemberUpdatedSchema)` to create a new message.
 */
export const MemberUpdatedSchema: GenMessage<MemberUpdated, { jsonType: MemberUpdatedJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 98);

/**
 * MemberDeleted is the event message published when a memebership is deleted
 *
 * @generated from message identities.v1.MemberDeleted
 */
export type MemberDeleted = Message<"identities.v1.MemberDeleted"> & {
	/**
	 * @generated from field: identities.v1.Member member = 1;
	 */
	member?: Member | undefined;
};

/**
 * MemberDeleted is the event message published when a memebership is deleted
 *
 * @generated from message identities.v1.MemberDeleted
 */
export type MemberDeletedJson = {
	/**
	 * @generated from field: identities.v1.Member member = 1;
	 */
	member?: MemberJson;
};

/**
 * Describes the message identities.v1.MemberDeleted.
 * Use `create(MemberDeletedSchema)` to create a new message.
 */
export const MemberDeletedSchema: GenMessage<MemberDeleted, { jsonType: MemberDeletedJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 99);

/**
 * GetMemberRequest is the request object to get a user by id
 *
 * @generated from message identities.v1.GetMemberRequest
 */
export type GetMemberRequest = Message<"identities.v1.GetMemberRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * GetMemberRequest is the request object to get a user by id
 *
 * @generated from message identities.v1.GetMemberRequest
 */
export type GetMemberRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message identities.v1.GetMemberRequest.
 * Use `create(GetMemberRequestSchema)` to create a new message.
 */
export const GetMemberRequestSchema: GenMessage<GetMemberRequest, { jsonType: GetMemberRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 100);

/**
 * GetMemberResponse returned by the get request for the Member returning the Member
 *
 * @generated from message identities.v1.GetMemberResponse
 */
export type GetMemberResponse = Message<"identities.v1.GetMemberResponse"> & {
	/**
	 * @generated from field: identities.v1.Member member = 1;
	 */
	member?: Member | undefined;
};

/**
 * GetMemberResponse returned by the get request for the Member returning the Member
 *
 * @generated from message identities.v1.GetMemberResponse
 */
export type GetMemberResponseJson = {
	/**
	 * @generated from field: identities.v1.Member member = 1;
	 */
	member?: MemberJson;
};

/**
 * Describes the message identities.v1.GetMemberResponse.
 * Use `create(GetMemberResponseSchema)` to create a new message.
 */
export const GetMemberResponseSchema: GenMessage<GetMemberResponse, { jsonType: GetMemberResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 101);

/**
 * ListMembersRequest is an empty object, later we can fill it with filtering options
 *
 * @generated from message identities.v1.ListMembersRequest
 */
export type ListMembersRequest = Message<"identities.v1.ListMembersRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: identities.v1.MemberFilter filter = 2;
	 */
	filter?: MemberFilter | undefined;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 3;
	 */
	paginate?: PaginationArguments | undefined;
};

/**
 * ListMembersRequest is an empty object, later we can fill it with filtering options
 *
 * @generated from message identities.v1.ListMembersRequest
 */
export type ListMembersRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: identities.v1.MemberFilter filter = 2;
	 */
	filter?: MemberFilterJson;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 3;
	 */
	paginate?: PaginationArgumentsJson;
};

/**
 * Describes the message identities.v1.ListMembersRequest.
 * Use `create(ListMembersRequestSchema)` to create a new message.
 */
export const ListMembersRequestSchema: GenMessage<ListMembersRequest, { jsonType: ListMembersRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 102);

/**
 * ListMembersResponse returns an array of users
 *
 * @generated from message identities.v1.ListMembersResponse
 */
export type ListMembersResponse = Message<"identities.v1.ListMembersResponse"> & {
	/**
	 * @generated from field: repeated identities.v1.Member items = 1;
	 */
	items: Member[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * ListMembersResponse returns an array of users
 *
 * @generated from message identities.v1.ListMembersResponse
 */
export type ListMembersResponseJson = {
	/**
	 * @generated from field: repeated identities.v1.Member items = 1;
	 */
	items?: MemberJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message identities.v1.ListMembersResponse.
 * Use `create(ListMembersResponseSchema)` to create a new message.
 */
export const ListMembersResponseSchema: GenMessage<ListMembersResponse, { jsonType: ListMembersResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 103);

/**
 * DeleteMemberRequest holds an id which is then deleted from the database
 *
 * @generated from message identities.v1.DeleteMemberRequest
 */
export type DeleteMemberRequest = Message<"identities.v1.DeleteMemberRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;
};

/**
 * DeleteMemberRequest holds an id which is then deleted from the database
 *
 * @generated from message identities.v1.DeleteMemberRequest
 */
export type DeleteMemberRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;
};

/**
 * Describes the message identities.v1.DeleteMemberRequest.
 * Use `create(DeleteMemberRequestSchema)` to create a new message.
 */
export const DeleteMemberRequestSchema: GenMessage<DeleteMemberRequest, { jsonType: DeleteMemberRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 104);

/**
 * DeleteMemberResponse <haven't figured out what to put here yet>
 *
 * @generated from message identities.v1.DeleteMemberResponse
 */
export type DeleteMemberResponse = Message<"identities.v1.DeleteMemberResponse"> & {};

/**
 * DeleteMemberResponse <haven't figured out what to put here yet>
 *
 * @generated from message identities.v1.DeleteMemberResponse
 */
export type DeleteMemberResponseJson = {};

/**
 * Describes the message identities.v1.DeleteMemberResponse.
 * Use `create(DeleteMemberResponseSchema)` to create a new message.
 */
export const DeleteMemberResponseSchema: GenMessage<DeleteMemberResponse, { jsonType: DeleteMemberResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 105);

/**
 * UpdateMemberRequest  update attributes on a user
 *
 * @generated from message identities.v1.UpdateMemberRequest
 */
export type UpdateMemberRequest = Message<"identities.v1.UpdateMemberRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: identities.v1.MemberType member_type = 2;
	 */
	memberType: MemberType;

	/**
	 * @generated from field: identities.v1.MemberStatus status = 3;
	 */
	status: MemberStatus;

	/**
	 * @generated from field: string role = 4 [deprecated = true];
	 * @deprecated
	 */
	role: string;

	/**
	 * @generated from field: string org_id = 5;
	 */
	orgId: string;

	/**
	 * @generated from field: repeated string role_names = 6;
	 */
	roleNames: string[];
};

/**
 * UpdateMemberRequest  update attributes on a user
 *
 * @generated from message identities.v1.UpdateMemberRequest
 */
export type UpdateMemberRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: identities.v1.MemberType member_type = 2;
	 */
	memberType?: MemberTypeJson;

	/**
	 * @generated from field: identities.v1.MemberStatus status = 3;
	 */
	status?: MemberStatusJson;

	/**
	 * @generated from field: string role = 4 [deprecated = true];
	 * @deprecated
	 */
	role?: string;

	/**
	 * @generated from field: string org_id = 5;
	 */
	orgId?: string;

	/**
	 * @generated from field: repeated string role_names = 6;
	 */
	roleNames?: string[];
};

/**
 * Describes the message identities.v1.UpdateMemberRequest.
 * Use `create(UpdateMemberRequestSchema)` to create a new message.
 */
export const UpdateMemberRequestSchema: GenMessage<UpdateMemberRequest, { jsonType: UpdateMemberRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 106);

/**
 * UpdateMemberReesponse
 *
 * @generated from message identities.v1.UpdateMemberResponse
 */
export type UpdateMemberResponse = Message<"identities.v1.UpdateMemberResponse"> & {
	/**
	 * @generated from field: identities.v1.Member member = 1;
	 */
	member?: Member | undefined;
};

/**
 * UpdateMemberReesponse
 *
 * @generated from message identities.v1.UpdateMemberResponse
 */
export type UpdateMemberResponseJson = {
	/**
	 * @generated from field: identities.v1.Member member = 1;
	 */
	member?: MemberJson;
};

/**
 * Describes the message identities.v1.UpdateMemberResponse.
 * Use `create(UpdateMemberResponseSchema)` to create a new message.
 */
export const UpdateMemberResponseSchema: GenMessage<UpdateMemberResponse, { jsonType: UpdateMemberResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 107);

/**
 * AddOrgMemberRequest adds a member to specified org
 *
 * @generated from message identities.v1.AddOrgMemberRequest
 */
export type AddOrgMemberRequest = Message<"identities.v1.AddOrgMemberRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string user_id = 2;
	 */
	userId: string;

	/**
	 * @generated from field: string invitation_id = 3;
	 */
	invitationId: string;

	/**
	 * @generated from field: string role_id = 4;
	 */
	roleId: string;

	/**
	 * @generated from field: string email = 5;
	 */
	email: string;

	/**
	 * @generated from field: identities.v1.MemberStatus status = 6;
	 */
	status: MemberStatus;
};

/**
 * AddOrgMemberRequest adds a member to specified org
 *
 * @generated from message identities.v1.AddOrgMemberRequest
 */
export type AddOrgMemberRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string user_id = 2;
	 */
	userId?: string;

	/**
	 * @generated from field: string invitation_id = 3;
	 */
	invitationId?: string;

	/**
	 * @generated from field: string role_id = 4;
	 */
	roleId?: string;

	/**
	 * @generated from field: string email = 5;
	 */
	email?: string;

	/**
	 * @generated from field: identities.v1.MemberStatus status = 6;
	 */
	status?: MemberStatusJson;
};

/**
 * Describes the message identities.v1.AddOrgMemberRequest.
 * Use `create(AddOrgMemberRequestSchema)` to create a new message.
 */
export const AddOrgMemberRequestSchema: GenMessage<AddOrgMemberRequest, { jsonType: AddOrgMemberRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 108);

/**
 * @generated from message identities.v1.AddOrgMemberResponse
 */
export type AddOrgMemberResponse = Message<"identities.v1.AddOrgMemberResponse"> & {
	/**
	 * @generated from field: identities.v1.Member member = 1;
	 */
	member?: Member | undefined;
};

/**
 * @generated from message identities.v1.AddOrgMemberResponse
 */
export type AddOrgMemberResponseJson = {
	/**
	 * @generated from field: identities.v1.Member member = 1;
	 */
	member?: MemberJson;
};

/**
 * Describes the message identities.v1.AddOrgMemberResponse.
 * Use `create(AddOrgMemberResponseSchema)` to create a new message.
 */
export const AddOrgMemberResponseSchema: GenMessage<AddOrgMemberResponse, { jsonType: AddOrgMemberResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 109);

/**
 * @generated from message identities.v1.OrgMembershipChanged
 */
export type OrgMembershipChanged = Message<"identities.v1.OrgMembershipChanged"> & {
	/**
	 * @generated from field: identities.v1.User user = 1;
	 */
	user?: User | undefined;

	/**
	 * @generated from field: identities.v1.Org old_org = 3;
	 */
	oldOrg?: Org | undefined;

	/**
	 * @generated from field: identities.v1.Org new_org = 4;
	 */
	newOrg?: Org | undefined;

	/**
	 * @generated from field: identities.v1.User requester = 5;
	 */
	requester?: User | undefined;

	/**
	 * @generated from field: identities.v1.OrgPlan org_plan = 6;
	 */
	orgPlan: OrgPlan;
};

/**
 * @generated from message identities.v1.OrgMembershipChanged
 */
export type OrgMembershipChangedJson = {
	/**
	 * @generated from field: identities.v1.User user = 1;
	 */
	user?: UserJson;

	/**
	 * @generated from field: identities.v1.Org old_org = 3;
	 */
	oldOrg?: OrgJson;

	/**
	 * @generated from field: identities.v1.Org new_org = 4;
	 */
	newOrg?: OrgJson;

	/**
	 * @generated from field: identities.v1.User requester = 5;
	 */
	requester?: UserJson;

	/**
	 * @generated from field: identities.v1.OrgPlan org_plan = 6;
	 */
	orgPlan?: OrgPlanJson;
};

/**
 * Describes the message identities.v1.OrgMembershipChanged.
 * Use `create(OrgMembershipChangedSchema)` to create a new message.
 */
export const OrgMembershipChangedSchema: GenMessage<OrgMembershipChanged, { jsonType: OrgMembershipChangedJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 110);

/**
 * @generated from message identities.v1.AddWorkspaceMemberDetails
 */
export type AddWorkspaceMemberDetails = Message<"identities.v1.AddWorkspaceMemberDetails"> & {
	/**
	 * @generated from field: string user_id = 1;
	 */
	userId: string;

	/**
	 * @generated from field: string role_name = 2 [deprecated = true];
	 * @deprecated
	 */
	roleName: string;

	/**
	 * @generated from field: string email = 3;
	 */
	email: string;

	/**
	 * @generated from field: identities.v1.MemberStatus status = 4;
	 */
	status: MemberStatus;

	/**
	 * @generated from field: string workspace_id = 5;
	 */
	workspaceId: string;

	/**
	 * @generated from field: repeated string role_names = 6;
	 */
	roleNames: string[];
};

/**
 * @generated from message identities.v1.AddWorkspaceMemberDetails
 */
export type AddWorkspaceMemberDetailsJson = {
	/**
	 * @generated from field: string user_id = 1;
	 */
	userId?: string;

	/**
	 * @generated from field: string role_name = 2 [deprecated = true];
	 * @deprecated
	 */
	roleName?: string;

	/**
	 * @generated from field: string email = 3;
	 */
	email?: string;

	/**
	 * @generated from field: identities.v1.MemberStatus status = 4;
	 */
	status?: MemberStatusJson;

	/**
	 * @generated from field: string workspace_id = 5;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: repeated string role_names = 6;
	 */
	roleNames?: string[];
};

/**
 * Describes the message identities.v1.AddWorkspaceMemberDetails.
 * Use `create(AddWorkspaceMemberDetailsSchema)` to create a new message.
 */
export const AddWorkspaceMemberDetailsSchema: GenMessage<AddWorkspaceMemberDetails, { jsonType: AddWorkspaceMemberDetailsJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 111);

/**
 * AddWorkspaceMemberRequest adds a member to specified org
 *
 * @generated from message identities.v1.AddWorkspaceMemberRequest
 */
export type AddWorkspaceMemberRequest = Message<"identities.v1.AddWorkspaceMemberRequest"> & {
	/**
	 * Deprecated: use AddWorkspaceMemberDetails.workspace_id instead
	 *
	 * @generated from field: string workspace_id = 1 [deprecated = true];
	 * @deprecated
	 */
	workspaceId: string;

	/**
	 * @generated from field: repeated identities.v1.AddWorkspaceMemberDetails members = 2;
	 */
	members: AddWorkspaceMemberDetails[];
};

/**
 * AddWorkspaceMemberRequest adds a member to specified org
 *
 * @generated from message identities.v1.AddWorkspaceMemberRequest
 */
export type AddWorkspaceMemberRequestJson = {
	/**
	 * Deprecated: use AddWorkspaceMemberDetails.workspace_id instead
	 *
	 * @generated from field: string workspace_id = 1 [deprecated = true];
	 * @deprecated
	 */
	workspaceId?: string;

	/**
	 * @generated from field: repeated identities.v1.AddWorkspaceMemberDetails members = 2;
	 */
	members?: AddWorkspaceMemberDetailsJson[];
};

/**
 * Describes the message identities.v1.AddWorkspaceMemberRequest.
 * Use `create(AddWorkspaceMemberRequestSchema)` to create a new message.
 */
export const AddWorkspaceMemberRequestSchema: GenMessage<AddWorkspaceMemberRequest, { jsonType: AddWorkspaceMemberRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 112);

/**
 * @generated from message identities.v1.AddWorkspaceMemberResponse
 */
export type AddWorkspaceMemberResponse = Message<"identities.v1.AddWorkspaceMemberResponse"> & {
	/**
	 * Deprecated: use AddWorkspaceMemberResponse.members instead
	 *
	 * @generated from field: identities.v1.Member member = 1 [deprecated = true];
	 * @deprecated
	 */
	member?: Member | undefined;

	/**
	 * @generated from field: repeated identities.v1.Member members = 2;
	 */
	members: Member[];
};

/**
 * @generated from message identities.v1.AddWorkspaceMemberResponse
 */
export type AddWorkspaceMemberResponseJson = {
	/**
	 * Deprecated: use AddWorkspaceMemberResponse.members instead
	 *
	 * @generated from field: identities.v1.Member member = 1 [deprecated = true];
	 * @deprecated
	 */
	member?: MemberJson;

	/**
	 * @generated from field: repeated identities.v1.Member members = 2;
	 */
	members?: MemberJson[];
};

/**
 * Describes the message identities.v1.AddWorkspaceMemberResponse.
 * Use `create(AddWorkspaceMemberResponseSchema)` to create a new message.
 */
export const AddWorkspaceMemberResponseSchema: GenMessage<AddWorkspaceMemberResponse, { jsonType: AddWorkspaceMemberResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 113);

/**
 * @generated from message identities.v1.Role
 */
export type Role = Message<"identities.v1.Role"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name: string;

	/**
	 * @generated from field: string display_name = 3;
	 */
	displayName: string;

	/**
	 * @generated from field: string description = 4;
	 */
	description: string;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 5;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 6;
	 */
	updatedAt?: Timestamp | undefined;

	/**
	 * @generated from field: optional google.protobuf.Timestamp deleted_at = 7;
	 */
	deletedAt?: Timestamp | undefined;

	/**
	 * @generated from field: bool org = 8;
	 */
	org: boolean;

	/**
	 * @generated from field: bool workspace = 9;
	 */
	workspace: boolean;

	/**
	 * @generated from field: bool team = 10;
	 */
	team: boolean;

	/**
	 * @generated from field: identities.v1.RoleCategory category = 11;
	 */
	category: RoleCategory;

	/**
	 * @generated from field: int32 category_rank = 12;
	 */
	categoryRank: number;
};

/**
 * @generated from message identities.v1.Role
 */
export type RoleJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name?: string;

	/**
	 * @generated from field: string display_name = 3;
	 */
	displayName?: string;

	/**
	 * @generated from field: string description = 4;
	 */
	description?: string;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 5;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 6;
	 */
	updatedAt?: TimestampJson;

	/**
	 * @generated from field: optional google.protobuf.Timestamp deleted_at = 7;
	 */
	deletedAt?: TimestampJson;

	/**
	 * @generated from field: bool org = 8;
	 */
	org?: boolean;

	/**
	 * @generated from field: bool workspace = 9;
	 */
	workspace?: boolean;

	/**
	 * @generated from field: bool team = 10;
	 */
	team?: boolean;

	/**
	 * @generated from field: identities.v1.RoleCategory category = 11;
	 */
	category?: RoleCategoryJson;

	/**
	 * @generated from field: int32 category_rank = 12;
	 */
	categoryRank?: number;
};

/**
 * Describes the message identities.v1.Role.
 * Use `create(RoleSchema)` to create a new message.
 */
export const RoleSchema: GenMessage<Role, { jsonType: RoleJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 114);

/**
 * UpdateRoleRequest update attributes on a role
 *
 * @generated from message identities.v1.UpdateRoleRequest
 */
export type UpdateRoleRequest = Message<"identities.v1.UpdateRoleRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name: string;

	/**
	 * @generated from field: string display_name = 3;
	 */
	displayName: string;

	/**
	 * @generated from field: string description = 4;
	 */
	description: string;

	/**
	 * @generated from field: bool org = 5;
	 */
	org: boolean;

	/**
	 * @generated from field: bool workspace = 6;
	 */
	workspace: boolean;

	/**
	 * @generated from field: bool team = 7;
	 */
	team: boolean;

	/**
	 * @generated from field: identities.v1.RoleCategory category = 8;
	 */
	category: RoleCategory;

	/**
	 * @generated from field: int32 category_rank = 9;
	 */
	categoryRank: number;
};

/**
 * UpdateRoleRequest update attributes on a role
 *
 * @generated from message identities.v1.UpdateRoleRequest
 */
export type UpdateRoleRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name?: string;

	/**
	 * @generated from field: string display_name = 3;
	 */
	displayName?: string;

	/**
	 * @generated from field: string description = 4;
	 */
	description?: string;

	/**
	 * @generated from field: bool org = 5;
	 */
	org?: boolean;

	/**
	 * @generated from field: bool workspace = 6;
	 */
	workspace?: boolean;

	/**
	 * @generated from field: bool team = 7;
	 */
	team?: boolean;

	/**
	 * @generated from field: identities.v1.RoleCategory category = 8;
	 */
	category?: RoleCategoryJson;

	/**
	 * @generated from field: int32 category_rank = 9;
	 */
	categoryRank?: number;
};

/**
 * Describes the message identities.v1.UpdateRoleRequest.
 * Use `create(UpdateRoleRequestSchema)` to create a new message.
 */
export const UpdateRoleRequestSchema: GenMessage<UpdateRoleRequest, { jsonType: UpdateRoleRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 115);

/**
 * UpdateRoleResponse update attributes on a role
 *
 * @generated from message identities.v1.UpdateRoleResponse
 */
export type UpdateRoleResponse = Message<"identities.v1.UpdateRoleResponse"> & {
	/**
	 * @generated from field: identities.v1.Role role = 1;
	 */
	role?: Role | undefined;
};

/**
 * UpdateRoleResponse update attributes on a role
 *
 * @generated from message identities.v1.UpdateRoleResponse
 */
export type UpdateRoleResponseJson = {
	/**
	 * @generated from field: identities.v1.Role role = 1;
	 */
	role?: RoleJson;
};

/**
 * Describes the message identities.v1.UpdateRoleResponse.
 * Use `create(UpdateRoleResponseSchema)` to create a new message.
 */
export const UpdateRoleResponseSchema: GenMessage<UpdateRoleResponse, { jsonType: UpdateRoleResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 116);

/**
 * CreateRoleRequest
 *
 * @generated from message identities.v1.CreateRoleRequest
 */
export type CreateRoleRequest = Message<"identities.v1.CreateRoleRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name: string;

	/**
	 * @generated from field: string description = 3;
	 */
	description: string;

	/**
	 * @generated from field: string display_name = 4;
	 */
	displayName: string;

	/**
	 * @generated from field: bool org = 5;
	 */
	org: boolean;

	/**
	 * @generated from field: bool workspace = 6;
	 */
	workspace: boolean;

	/**
	 * @generated from field: bool team = 7;
	 */
	team: boolean;

	/**
	 * @generated from field: identities.v1.RoleCategory category = 8;
	 */
	category: RoleCategory;

	/**
	 * @generated from field: int32 category_rank = 9;
	 */
	categoryRank: number;
};

/**
 * CreateRoleRequest
 *
 * @generated from message identities.v1.CreateRoleRequest
 */
export type CreateRoleRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name?: string;

	/**
	 * @generated from field: string description = 3;
	 */
	description?: string;

	/**
	 * @generated from field: string display_name = 4;
	 */
	displayName?: string;

	/**
	 * @generated from field: bool org = 5;
	 */
	org?: boolean;

	/**
	 * @generated from field: bool workspace = 6;
	 */
	workspace?: boolean;

	/**
	 * @generated from field: bool team = 7;
	 */
	team?: boolean;

	/**
	 * @generated from field: identities.v1.RoleCategory category = 8;
	 */
	category?: RoleCategoryJson;

	/**
	 * @generated from field: int32 category_rank = 9;
	 */
	categoryRank?: number;
};

/**
 * Describes the message identities.v1.CreateRoleRequest.
 * Use `create(CreateRoleRequestSchema)` to create a new message.
 */
export const CreateRoleRequestSchema: GenMessage<CreateRoleRequest, { jsonType: CreateRoleRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 117);

/**
 * CreateRoleResponse
 *
 * @generated from message identities.v1.CreateRoleResponse
 */
export type CreateRoleResponse = Message<"identities.v1.CreateRoleResponse"> & {
	/**
	 * @generated from field: identities.v1.Role role = 1;
	 */
	role?: Role | undefined;
};

/**
 * CreateRoleResponse
 *
 * @generated from message identities.v1.CreateRoleResponse
 */
export type CreateRoleResponseJson = {
	/**
	 * @generated from field: identities.v1.Role role = 1;
	 */
	role?: RoleJson;
};

/**
 * Describes the message identities.v1.CreateRoleResponse.
 * Use `create(CreateRoleResponseSchema)` to create a new message.
 */
export const CreateRoleResponseSchema: GenMessage<CreateRoleResponse, { jsonType: CreateRoleResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 118);

/**
 * ListRolesFilter
 *
 * @generated from message identities.v1.ListRolesFilter
 */
export type ListRolesFilter = Message<"identities.v1.ListRolesFilter"> & {
	/**
	 * @generated from field: optional identities.v1.RoleType role_type = 1;
	 */
	roleType?: RoleType | undefined;

	/**
	 * @generated from field: optional identities.v1.RoleCategory category = 2;
	 */
	category?: RoleCategory | undefined;
};

/**
 * ListRolesFilter
 *
 * @generated from message identities.v1.ListRolesFilter
 */
export type ListRolesFilterJson = {
	/**
	 * @generated from field: optional identities.v1.RoleType role_type = 1;
	 */
	roleType?: RoleTypeJson;

	/**
	 * @generated from field: optional identities.v1.RoleCategory category = 2;
	 */
	category?: RoleCategoryJson;
};

/**
 * Describes the message identities.v1.ListRolesFilter.
 * Use `create(ListRolesFilterSchema)` to create a new message.
 */
export const ListRolesFilterSchema: GenMessage<ListRolesFilter, { jsonType: ListRolesFilterJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 119);

/**
 * ListRolesRequest is an empty object, later we can fill it with filtering options
 *
 * @generated from message identities.v1.ListRolesRequest
 */
export type ListRolesRequest = Message<"identities.v1.ListRolesRequest"> & {
	/**
	 * @generated from field: optional identities.v1.ListRolesFilter filter = 1;
	 */
	filter?: ListRolesFilter | undefined;
};

/**
 * ListRolesRequest is an empty object, later we can fill it with filtering options
 *
 * @generated from message identities.v1.ListRolesRequest
 */
export type ListRolesRequestJson = {
	/**
	 * @generated from field: optional identities.v1.ListRolesFilter filter = 1;
	 */
	filter?: ListRolesFilterJson;
};

/**
 * Describes the message identities.v1.ListRolesRequest.
 * Use `create(ListRolesRequestSchema)` to create a new message.
 */
export const ListRolesRequestSchema: GenMessage<ListRolesRequest, { jsonType: ListRolesRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 120);

/**
 * ListRolesResponse returns an array of users
 *
 * @generated from message identities.v1.ListRolesResponse
 */
export type ListRolesResponse = Message<"identities.v1.ListRolesResponse"> & {
	/**
	 * @generated from field: repeated identities.v1.Role items = 1;
	 */
	items: Role[];
};

/**
 * ListRolesResponse returns an array of users
 *
 * @generated from message identities.v1.ListRolesResponse
 */
export type ListRolesResponseJson = {
	/**
	 * @generated from field: repeated identities.v1.Role items = 1;
	 */
	items?: RoleJson[];
};

/**
 * Describes the message identities.v1.ListRolesResponse.
 * Use `create(ListRolesResponseSchema)` to create a new message.
 */
export const ListRolesResponseSchema: GenMessage<ListRolesResponse, { jsonType: ListRolesResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 121);

/**
 * Invitation represents the invivitation records in the database
 *
 * @generated from message identities.v1.Invitation
 */
export type Invitation = Message<"identities.v1.Invitation"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string email = 2;
	 */
	email: string;

	/**
	 * @generated from field: identities.v1.InvitationType invitation_type = 3;
	 */
	invitationType: InvitationType;

	/**
	 * @generated from field: identities.v1.InvitationStatus status = 4;
	 */
	status: InvitationStatus;

	/**
	 * @generated from field: string token = 5;
	 */
	token: string;

	/**
	 * @generated from field: string invitable_id = 6;
	 */
	invitableId: string;

	/**
	 * @generated from field: identities.v1.MemberStatus join_status = 7;
	 */
	joinStatus: MemberStatus;

	/**
	 * @generated from field: string org_id = 8;
	 */
	orgId: string;

	/**
	 * @generated from field: repeated identities.v1.Role roles = 9;
	 */
	roles: Role[];

	/**
	 * @generated from field: repeated string role_names = 14;
	 */
	roleNames: string[];

	/**
	 * @generated from field: google.protobuf.Timestamp expires_at = 10;
	 */
	expiresAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 11;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 12;
	 */
	updatedAt?: Timestamp | undefined;

	/**
	 * @generated from field: optional google.protobuf.Timestamp deleted_at = 13;
	 */
	deletedAt?: Timestamp | undefined;
};

/**
 * Invitation represents the invivitation records in the database
 *
 * @generated from message identities.v1.Invitation
 */
export type InvitationJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string email = 2;
	 */
	email?: string;

	/**
	 * @generated from field: identities.v1.InvitationType invitation_type = 3;
	 */
	invitationType?: InvitationTypeJson;

	/**
	 * @generated from field: identities.v1.InvitationStatus status = 4;
	 */
	status?: InvitationStatusJson;

	/**
	 * @generated from field: string token = 5;
	 */
	token?: string;

	/**
	 * @generated from field: string invitable_id = 6;
	 */
	invitableId?: string;

	/**
	 * @generated from field: identities.v1.MemberStatus join_status = 7;
	 */
	joinStatus?: MemberStatusJson;

	/**
	 * @generated from field: string org_id = 8;
	 */
	orgId?: string;

	/**
	 * @generated from field: repeated identities.v1.Role roles = 9;
	 */
	roles?: RoleJson[];

	/**
	 * @generated from field: repeated string role_names = 14;
	 */
	roleNames?: string[];

	/**
	 * @generated from field: google.protobuf.Timestamp expires_at = 10;
	 */
	expiresAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 11;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 12;
	 */
	updatedAt?: TimestampJson;

	/**
	 * @generated from field: optional google.protobuf.Timestamp deleted_at = 13;
	 */
	deletedAt?: TimestampJson;
};

/**
 * Describes the message identities.v1.Invitation.
 * Use `create(InvitationSchema)` to create a new message.
 */
export const InvitationSchema: GenMessage<Invitation, { jsonType: InvitationJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 122);

/**
 * @generated from message identities.v1.InviteUserData
 */
export type InviteUserData = Message<"identities.v1.InviteUserData"> & {
	/**
	 * @generated from field: string user_id = 1;
	 */
	userId: string;

	/**
	 * @generated from field: string email = 2;
	 */
	email: string;

	/**
	 * @generated from field: string org_id = 3;
	 */
	orgId: string;

	/**
	 * @generated from field: string zed_token = 4;
	 */
	zedToken: string;

	/**
	 * @generated from field: string invitable_id = 5;
	 */
	invitableId: string;
};

/**
 * @generated from message identities.v1.InviteUserData
 */
export type InviteUserDataJson = {
	/**
	 * @generated from field: string user_id = 1;
	 */
	userId?: string;

	/**
	 * @generated from field: string email = 2;
	 */
	email?: string;

	/**
	 * @generated from field: string org_id = 3;
	 */
	orgId?: string;

	/**
	 * @generated from field: string zed_token = 4;
	 */
	zedToken?: string;

	/**
	 * @generated from field: string invitable_id = 5;
	 */
	invitableId?: string;
};

/**
 * Describes the message identities.v1.InviteUserData.
 * Use `create(InviteUserDataSchema)` to create a new message.
 */
export const InviteUserDataSchema: GenMessage<InviteUserData, { jsonType: InviteUserDataJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 123);

/**
 * @generated from message identities.v1.InvitationCreated
 */
export type InvitationCreated = Message<"identities.v1.InvitationCreated"> & {
	/**
	 * @generated from field: identities.v1.InviteUserData invite = 1;
	 */
	invite?: InviteUserData | undefined;
};

/**
 * @generated from message identities.v1.InvitationCreated
 */
export type InvitationCreatedJson = {
	/**
	 * @generated from field: identities.v1.InviteUserData invite = 1;
	 */
	invite?: InviteUserDataJson;
};

/**
 * Describes the message identities.v1.InvitationCreated.
 * Use `create(InvitationCreatedSchema)` to create a new message.
 */
export const InvitationCreatedSchema: GenMessage<InvitationCreated, { jsonType: InvitationCreatedJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 124);

/**
 * CreateInvitationRequest
 *
 * @generated from message identities.v1.CreateInvitationRequest
 */
export type CreateInvitationRequest = Message<"identities.v1.CreateInvitationRequest"> & {
	/**
	 * @generated from field: string email = 1;
	 */
	email: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name: string;

	/**
	 * @generated from field: string metadata = 3;
	 */
	metadata: string;

	/**
	 * @generated from field: string phone_number = 4;
	 */
	phoneNumber: string;

	/**
	 * @generated from field: repeated string role_ids = 5;
	 */
	roleIds: string[];

	/**
	 * @generated from field: repeated string role_names = 10;
	 */
	roleNames: string[];

	/**
	 * @generated from field: string org_id = 6;
	 */
	orgId: string;

	/**
	 * @generated from field: string invitable_id = 7;
	 */
	invitableId: string;

	/**
	 * @generated from field: identities.v1.MemberStatus member_status = 8;
	 */
	memberStatus: MemberStatus;

	/**
	 * @generated from field: identities.v1.MemberType type = 9;
	 */
	type: MemberType;
};

/**
 * CreateInvitationRequest
 *
 * @generated from message identities.v1.CreateInvitationRequest
 */
export type CreateInvitationRequestJson = {
	/**
	 * @generated from field: string email = 1;
	 */
	email?: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name?: string;

	/**
	 * @generated from field: string metadata = 3;
	 */
	metadata?: string;

	/**
	 * @generated from field: string phone_number = 4;
	 */
	phoneNumber?: string;

	/**
	 * @generated from field: repeated string role_ids = 5;
	 */
	roleIds?: string[];

	/**
	 * @generated from field: repeated string role_names = 10;
	 */
	roleNames?: string[];

	/**
	 * @generated from field: string org_id = 6;
	 */
	orgId?: string;

	/**
	 * @generated from field: string invitable_id = 7;
	 */
	invitableId?: string;

	/**
	 * @generated from field: identities.v1.MemberStatus member_status = 8;
	 */
	memberStatus?: MemberStatusJson;

	/**
	 * @generated from field: identities.v1.MemberType type = 9;
	 */
	type?: MemberTypeJson;
};

/**
 * Describes the message identities.v1.CreateInvitationRequest.
 * Use `create(CreateInvitationRequestSchema)` to create a new message.
 */
export const CreateInvitationRequestSchema: GenMessage<CreateInvitationRequest, { jsonType: CreateInvitationRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 125);

/**
 * CreateInvitationResponse
 *
 * @generated from message identities.v1.CreateInvitationResponse
 */
export type CreateInvitationResponse = Message<"identities.v1.CreateInvitationResponse"> & {
	/**
	 * @generated from field: identities.v1.Invitation item = 1;
	 */
	item?: Invitation | undefined;
};

/**
 * CreateInvitationResponse
 *
 * @generated from message identities.v1.CreateInvitationResponse
 */
export type CreateInvitationResponseJson = {
	/**
	 * @generated from field: identities.v1.Invitation item = 1;
	 */
	item?: InvitationJson;
};

/**
 * Describes the message identities.v1.CreateInvitationResponse.
 * Use `create(CreateInvitationResponseSchema)` to create a new message.
 */
export const CreateInvitationResponseSchema: GenMessage<CreateInvitationResponse, { jsonType: CreateInvitationResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 126);

/**
 * OrgWorkspaceInvitationMapping is a mapping of org role names to workspace ids
 *
 * @generated from message identities.v1.OrgWorkspaceInvitationMapping
 */
export type OrgWorkspaceInvitationMapping = Message<"identities.v1.OrgWorkspaceInvitationMapping"> & {
	/**
	 * @generated from field: repeated string role_names = 1;
	 */
	roleNames: string[];

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;
};

/**
 * OrgWorkspaceInvitationMapping is a mapping of org role names to workspace ids
 *
 * @generated from message identities.v1.OrgWorkspaceInvitationMapping
 */
export type OrgWorkspaceInvitationMappingJson = {
	/**
	 * @generated from field: repeated string role_names = 1;
	 */
	roleNames?: string[];

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;
};

/**
 * Describes the message identities.v1.OrgWorkspaceInvitationMapping.
 * Use `create(OrgWorkspaceInvitationMappingSchema)` to create a new message.
 */
export const OrgWorkspaceInvitationMappingSchema: GenMessage<OrgWorkspaceInvitationMapping, { jsonType: OrgWorkspaceInvitationMappingJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 127);

/**
 * Invitiationvv2Identity object for grouping identity information
 * only field that is required is email
 *
 * @generated from message identities.v1.InvitationV2Identity
 */
export type InvitationV2Identity = Message<"identities.v1.InvitationV2Identity"> & {
	/**
	 * @generated from field: string email = 1;
	 */
	email: string;

	/**
	 * @generated from field: string first_name = 2;
	 */
	firstName: string;

	/**
	 * @generated from field: string last_name = 3;
	 */
	lastName: string;
};

/**
 * Invitiationvv2Identity object for grouping identity information
 * only field that is required is email
 *
 * @generated from message identities.v1.InvitationV2Identity
 */
export type InvitationV2IdentityJson = {
	/**
	 * @generated from field: string email = 1;
	 */
	email?: string;

	/**
	 * @generated from field: string first_name = 2;
	 */
	firstName?: string;

	/**
	 * @generated from field: string last_name = 3;
	 */
	lastName?: string;
};

/**
 * Describes the message identities.v1.InvitationV2Identity.
 * Use `create(InvitationV2IdentitySchema)` to create a new message.
 */
export const InvitationV2IdentitySchema: GenMessage<InvitationV2Identity, { jsonType: InvitationV2IdentityJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 128);

/**
 * CreateInvitationV2OrgRequest is the request object to create an invitation
 *
 * @generated from message identities.v1.CreateInvitationV2OrgRequest
 */
export type CreateInvitationV2OrgRequest = Message<"identities.v1.CreateInvitationV2OrgRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: repeated identities.v1.InvitationV2Identity users = 2;
	 */
	users: InvitationV2Identity[];

	/**
	 * @generated from field: repeated string org_role_names = 3;
	 */
	orgRoleNames: string[];

	/**
	 * @generated from field: repeated identities.v1.OrgWorkspaceInvitationMapping workspaces = 4;
	 */
	workspaces: OrgWorkspaceInvitationMapping[];

	/**
	 * @generated from field: bool skip_send_email = 5;
	 */
	skipSendEmail: boolean;

	/**
	 * @generated from field: bool wait_for_execution = 6;
	 */
	waitForExecution: boolean;
};

/**
 * CreateInvitationV2OrgRequest is the request object to create an invitation
 *
 * @generated from message identities.v1.CreateInvitationV2OrgRequest
 */
export type CreateInvitationV2OrgRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: repeated identities.v1.InvitationV2Identity users = 2;
	 */
	users?: InvitationV2IdentityJson[];

	/**
	 * @generated from field: repeated string org_role_names = 3;
	 */
	orgRoleNames?: string[];

	/**
	 * @generated from field: repeated identities.v1.OrgWorkspaceInvitationMapping workspaces = 4;
	 */
	workspaces?: OrgWorkspaceInvitationMappingJson[];

	/**
	 * @generated from field: bool skip_send_email = 5;
	 */
	skipSendEmail?: boolean;

	/**
	 * @generated from field: bool wait_for_execution = 6;
	 */
	waitForExecution?: boolean;
};

/**
 * Describes the message identities.v1.CreateInvitationV2OrgRequest.
 * Use `create(CreateInvitationV2OrgRequestSchema)` to create a new message.
 */
export const CreateInvitationV2OrgRequestSchema: GenMessage<CreateInvitationV2OrgRequest, { jsonType: CreateInvitationV2OrgRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 129);

/**
 * @generated from message identities.v1.InvitationJobIdMapping
 */
export type InvitationJobIdMapping = Message<"identities.v1.InvitationJobIdMapping"> & {
	/**
	 * @generated from field: string email = 1;
	 */
	email: string;

	/**
	 * @generated from field: string job_id = 2;
	 */
	jobId: string;

	/**
	 * @generated from field: string run_id = 3;
	 */
	runId: string;
};

/**
 * @generated from message identities.v1.InvitationJobIdMapping
 */
export type InvitationJobIdMappingJson = {
	/**
	 * @generated from field: string email = 1;
	 */
	email?: string;

	/**
	 * @generated from field: string job_id = 2;
	 */
	jobId?: string;

	/**
	 * @generated from field: string run_id = 3;
	 */
	runId?: string;
};

/**
 * Describes the message identities.v1.InvitationJobIdMapping.
 * Use `create(InvitationJobIdMappingSchema)` to create a new message.
 */
export const InvitationJobIdMappingSchema: GenMessage<InvitationJobIdMapping, { jsonType: InvitationJobIdMappingJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 130);

/**
 * @generated from message identities.v1.CreateInvitationV2OrgResponse
 */
export type CreateInvitationV2OrgResponse = Message<"identities.v1.CreateInvitationV2OrgResponse"> & {
	/**
	 * @generated from field: repeated identities.v1.InvitationJobIdMapping items = 1;
	 */
	items: InvitationJobIdMapping[];
};

/**
 * @generated from message identities.v1.CreateInvitationV2OrgResponse
 */
export type CreateInvitationV2OrgResponseJson = {
	/**
	 * @generated from field: repeated identities.v1.InvitationJobIdMapping items = 1;
	 */
	items?: InvitationJobIdMappingJson[];
};

/**
 * Describes the message identities.v1.CreateInvitationV2OrgResponse.
 * Use `create(CreateInvitationV2OrgResponseSchema)` to create a new message.
 */
export const CreateInvitationV2OrgResponseSchema: GenMessage<CreateInvitationV2OrgResponse, { jsonType: CreateInvitationV2OrgResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 131);

/**
 * @generated from message identities.v1.WorkspaceInvitationMapping
 */
export type WorkspaceInvitationMapping = Message<"identities.v1.WorkspaceInvitationMapping"> & {
	/**
	 * @generated from field: repeated string role_names = 1;
	 */
	roleNames: string[];

	/**
	 * @generated from field: string email = 2;
	 */
	email: string;
};

/**
 * @generated from message identities.v1.WorkspaceInvitationMapping
 */
export type WorkspaceInvitationMappingJson = {
	/**
	 * @generated from field: repeated string role_names = 1;
	 */
	roleNames?: string[];

	/**
	 * @generated from field: string email = 2;
	 */
	email?: string;
};

/**
 * Describes the message identities.v1.WorkspaceInvitationMapping.
 * Use `create(WorkspaceInvitationMappingSchema)` to create a new message.
 */
export const WorkspaceInvitationMappingSchema: GenMessage<WorkspaceInvitationMapping, { jsonType: WorkspaceInvitationMappingJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 132);

/**
 * @generated from message identities.v1.CreateInvitationV2WorkspaceRequest
 */
export type CreateInvitationV2WorkspaceRequest = Message<"identities.v1.CreateInvitationV2WorkspaceRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: repeated identities.v1.WorkspaceInvitationMapping users = 3;
	 */
	users: WorkspaceInvitationMapping[];
};

/**
 * @generated from message identities.v1.CreateInvitationV2WorkspaceRequest
 */
export type CreateInvitationV2WorkspaceRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: repeated identities.v1.WorkspaceInvitationMapping users = 3;
	 */
	users?: WorkspaceInvitationMappingJson[];
};

/**
 * Describes the message identities.v1.CreateInvitationV2WorkspaceRequest.
 * Use `create(CreateInvitationV2WorkspaceRequestSchema)` to create a new message.
 */
export const CreateInvitationV2WorkspaceRequestSchema: GenMessage<CreateInvitationV2WorkspaceRequest, { jsonType: CreateInvitationV2WorkspaceRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 133);

/**
 * @generated from message identities.v1.CreateInvitationV2WorkspaceResponse
 */
export type CreateInvitationV2WorkspaceResponse = Message<"identities.v1.CreateInvitationV2WorkspaceResponse"> & {
	/**
	 * @generated from field: repeated identities.v1.InvitationJobIdMapping items = 1;
	 */
	items: InvitationJobIdMapping[];
};

/**
 * @generated from message identities.v1.CreateInvitationV2WorkspaceResponse
 */
export type CreateInvitationV2WorkspaceResponseJson = {
	/**
	 * @generated from field: repeated identities.v1.InvitationJobIdMapping items = 1;
	 */
	items?: InvitationJobIdMappingJson[];
};

/**
 * Describes the message identities.v1.CreateInvitationV2WorkspaceResponse.
 * Use `create(CreateInvitationV2WorkspaceResponseSchema)` to create a new message.
 */
export const CreateInvitationV2WorkspaceResponseSchema: GenMessage<CreateInvitationV2WorkspaceResponse, { jsonType: CreateInvitationV2WorkspaceResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 134);

/**
 * ListInviationRequest
 *
 * @generated from message identities.v1.ListInvitationsRequest
 */
export type ListInvitationsRequest = Message<"identities.v1.ListInvitationsRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: optional string filter = 2;
	 */
	filter?: string | undefined;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 3;
	 */
	paginate?: PaginationArguments | undefined;
};

/**
 * ListInviationRequest
 *
 * @generated from message identities.v1.ListInvitationsRequest
 */
export type ListInvitationsRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: optional string filter = 2;
	 */
	filter?: string;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 3;
	 */
	paginate?: PaginationArgumentsJson;
};

/**
 * Describes the message identities.v1.ListInvitationsRequest.
 * Use `create(ListInvitationsRequestSchema)` to create a new message.
 */
export const ListInvitationsRequestSchema: GenMessage<ListInvitationsRequest, { jsonType: ListInvitationsRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 135);

/**
 * ListInvitationsResponse
 *
 * @generated from message identities.v1.ListInvitationsResponse
 */
export type ListInvitationsResponse = Message<"identities.v1.ListInvitationsResponse"> & {
	/**
	 * @generated from field: repeated identities.v1.Invitation items = 1;
	 */
	items: Invitation[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * ListInvitationsResponse
 *
 * @generated from message identities.v1.ListInvitationsResponse
 */
export type ListInvitationsResponseJson = {
	/**
	 * @generated from field: repeated identities.v1.Invitation items = 1;
	 */
	items?: InvitationJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message identities.v1.ListInvitationsResponse.
 * Use `create(ListInvitationsResponseSchema)` to create a new message.
 */
export const ListInvitationsResponseSchema: GenMessage<ListInvitationsResponse, { jsonType: ListInvitationsResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 136);

/**
 * AcceptInvitationRequest
 *
 * @generated from message identities.v1.AcceptInvitationRequest
 */
export type AcceptInvitationRequest = Message<"identities.v1.AcceptInvitationRequest"> & {
	/**
	 * @generated from field: string id = 2;
	 */
	id: string;

	/**
	 * @generated from field: string org_id = 3;
	 */
	orgId: string;
};

/**
 * AcceptInvitationRequest
 *
 * @generated from message identities.v1.AcceptInvitationRequest
 */
export type AcceptInvitationRequestJson = {
	/**
	 * @generated from field: string id = 2;
	 */
	id?: string;

	/**
	 * @generated from field: string org_id = 3;
	 */
	orgId?: string;
};

/**
 * Describes the message identities.v1.AcceptInvitationRequest.
 * Use `create(AcceptInvitationRequestSchema)` to create a new message.
 */
export const AcceptInvitationRequestSchema: GenMessage<AcceptInvitationRequest, { jsonType: AcceptInvitationRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 137);

/**
 * AcceptInvitationResponse
 *
 * @generated from message identities.v1.AcceptInvitationResponse
 */
export type AcceptInvitationResponse = Message<"identities.v1.AcceptInvitationResponse"> & {
	/**
	 * @generated from field: identities.v1.Invitation invitation = 1;
	 */
	invitation?: Invitation | undefined;
};

/**
 * AcceptInvitationResponse
 *
 * @generated from message identities.v1.AcceptInvitationResponse
 */
export type AcceptInvitationResponseJson = {
	/**
	 * @generated from field: identities.v1.Invitation invitation = 1;
	 */
	invitation?: InvitationJson;
};

/**
 * Describes the message identities.v1.AcceptInvitationResponse.
 * Use `create(AcceptInvitationResponseSchema)` to create a new message.
 */
export const AcceptInvitationResponseSchema: GenMessage<AcceptInvitationResponse, { jsonType: AcceptInvitationResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 138);

/**
 * @generated from message identities.v1.GetInvitationRequest
 */
export type GetInvitationRequest = Message<"identities.v1.GetInvitationRequest"> & {
	/**
	 * @generated from field: string email = 1;
	 */
	email: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;
};

/**
 * @generated from message identities.v1.GetInvitationRequest
 */
export type GetInvitationRequestJson = {
	/**
	 * @generated from field: string email = 1;
	 */
	email?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;
};

/**
 * Describes the message identities.v1.GetInvitationRequest.
 * Use `create(GetInvitationRequestSchema)` to create a new message.
 */
export const GetInvitationRequestSchema: GenMessage<GetInvitationRequest, { jsonType: GetInvitationRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 139);

/**
 * @generated from message identities.v1.GetInvitationResponse
 */
export type GetInvitationResponse = Message<"identities.v1.GetInvitationResponse"> & {
	/**
	 * @generated from field: identities.v1.Invitation item = 1;
	 */
	item?: Invitation | undefined;
};

/**
 * @generated from message identities.v1.GetInvitationResponse
 */
export type GetInvitationResponseJson = {
	/**
	 * @generated from field: identities.v1.Invitation item = 1;
	 */
	item?: InvitationJson;
};

/**
 * Describes the message identities.v1.GetInvitationResponse.
 * Use `create(GetInvitationResponseSchema)` to create a new message.
 */
export const GetInvitationResponseSchema: GenMessage<GetInvitationResponse, { jsonType: GetInvitationResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 140);

/**
 * Team
 *
 * @generated from message identities.v1.Team
 */
export type Team = Message<"identities.v1.Team"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name: string;

	/**
	 * @generated from field: string org_id = 3;
	 */
	orgId: string;

	/**
	 * @generated from field: string description = 4;
	 */
	description: string;

	/**
	 * @generated from field: string photo_url = 5;
	 */
	photoUrl: string;

	/**
	 * @generated from field: int64 member_count = 6;
	 */
	memberCount: bigint;

	/**
	 * @generated from field: repeated identities.v1.Member members = 7;
	 */
	members: Member[];

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 8;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 9;
	 */
	updatedAt?: Timestamp | undefined;

	/**
	 * @generated from field: optional google.protobuf.Timestamp deleted_at = 10;
	 */
	deletedAt?: Timestamp | undefined;

	/**
	 * @generated from field: identities.v1.TeamManagedBy managed_by = 11;
	 */
	managedBy: TeamManagedBy;

	/**
	 * @generated from field: repeated identities.v1.Role org_roles = 12;
	 */
	orgRoles: Role[];
};

/**
 * Team
 *
 * @generated from message identities.v1.Team
 */
export type TeamJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name?: string;

	/**
	 * @generated from field: string org_id = 3;
	 */
	orgId?: string;

	/**
	 * @generated from field: string description = 4;
	 */
	description?: string;

	/**
	 * @generated from field: string photo_url = 5;
	 */
	photoUrl?: string;

	/**
	 * @generated from field: int64 member_count = 6;
	 */
	memberCount?: string;

	/**
	 * @generated from field: repeated identities.v1.Member members = 7;
	 */
	members?: MemberJson[];

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 8;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 9;
	 */
	updatedAt?: TimestampJson;

	/**
	 * @generated from field: optional google.protobuf.Timestamp deleted_at = 10;
	 */
	deletedAt?: TimestampJson;

	/**
	 * @generated from field: identities.v1.TeamManagedBy managed_by = 11;
	 */
	managedBy?: TeamManagedByJson;

	/**
	 * @generated from field: repeated identities.v1.Role org_roles = 12;
	 */
	orgRoles?: RoleJson[];
};

/**
 * Describes the message identities.v1.Team.
 * Use `create(TeamSchema)` to create a new message.
 */
export const TeamSchema: GenMessage<Team, { jsonType: TeamJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 141);

/**
 * UpdateTeamRequestupdate attributes on a user
 *
 * @generated from message identities.v1.UpdateTeamRequest
 */
export type UpdateTeamRequest = Message<"identities.v1.UpdateTeamRequest"> & {
	/**
	 * @generated from field: identities.v1.Team team = 1;
	 */
	team?: Team | undefined;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMask | undefined;
};

/**
 * UpdateTeamRequestupdate attributes on a user
 *
 * @generated from message identities.v1.UpdateTeamRequest
 */
export type UpdateTeamRequestJson = {
	/**
	 * @generated from field: identities.v1.Team team = 1;
	 */
	team?: TeamJson;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMaskJson;
};

/**
 * Describes the message identities.v1.UpdateTeamRequest.
 * Use `create(UpdateTeamRequestSchema)` to create a new message.
 */
export const UpdateTeamRequestSchema: GenMessage<UpdateTeamRequest, { jsonType: UpdateTeamRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 142);

/**
 * @generated from message identities.v1.UpdateTeamResponse
 */
export type UpdateTeamResponse = Message<"identities.v1.UpdateTeamResponse"> & {
	/**
	 * @generated from field: identities.v1.Team team = 1;
	 */
	team?: Team | undefined;
};

/**
 * @generated from message identities.v1.UpdateTeamResponse
 */
export type UpdateTeamResponseJson = {
	/**
	 * @generated from field: identities.v1.Team team = 1;
	 */
	team?: TeamJson;
};

/**
 * Describes the message identities.v1.UpdateTeamResponse.
 * Use `create(UpdateTeamResponseSchema)` to create a new message.
 */
export const UpdateTeamResponseSchema: GenMessage<UpdateTeamResponse, { jsonType: UpdateTeamResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 143);

/**
 * DeleteTeamRequest deletes specified team
 *
 * @generated from message identities.v1.DeleteTeamRequest
 */
export type DeleteTeamRequest = Message<"identities.v1.DeleteTeamRequest"> & {
	/**
	 * @generated from field: string team_id = 1;
	 */
	teamId: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;
};

/**
 * DeleteTeamRequest deletes specified team
 *
 * @generated from message identities.v1.DeleteTeamRequest
 */
export type DeleteTeamRequestJson = {
	/**
	 * @generated from field: string team_id = 1;
	 */
	teamId?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;
};

/**
 * Describes the message identities.v1.DeleteTeamRequest.
 * Use `create(DeleteTeamRequestSchema)` to create a new message.
 */
export const DeleteTeamRequestSchema: GenMessage<DeleteTeamRequest, { jsonType: DeleteTeamRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 144);

/**
 * DeleteTeamResponse placeholder for the delete reponse
 *
 * @generated from message identities.v1.DeleteTeamResponse
 */
export type DeleteTeamResponse = Message<"identities.v1.DeleteTeamResponse"> & {};

/**
 * DeleteTeamResponse placeholder for the delete reponse
 *
 * @generated from message identities.v1.DeleteTeamResponse
 */
export type DeleteTeamResponseJson = {};

/**
 * Describes the message identities.v1.DeleteTeamResponse.
 * Use `create(DeleteTeamResponseSchema)` to create a new message.
 */
export const DeleteTeamResponseSchema: GenMessage<DeleteTeamResponse, { jsonType: DeleteTeamResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 145);

/**
 * RemoveTeamMemberRequest
 *
 * @generated from message identities.v1.RemoveTeamMemberRequest
 */
export type RemoveTeamMemberRequest = Message<"identities.v1.RemoveTeamMemberRequest"> & {
	/**
	 * @generated from field: string team_id = 1;
	 */
	teamId: string;

	/**
	 * @generated from field: string user_id = 2;
	 */
	userId: string;
};

/**
 * RemoveTeamMemberRequest
 *
 * @generated from message identities.v1.RemoveTeamMemberRequest
 */
export type RemoveTeamMemberRequestJson = {
	/**
	 * @generated from field: string team_id = 1;
	 */
	teamId?: string;

	/**
	 * @generated from field: string user_id = 2;
	 */
	userId?: string;
};

/**
 * Describes the message identities.v1.RemoveTeamMemberRequest.
 * Use `create(RemoveTeamMemberRequestSchema)` to create a new message.
 */
export const RemoveTeamMemberRequestSchema: GenMessage<RemoveTeamMemberRequest, { jsonType: RemoveTeamMemberRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 146);

/**
 * RemoveTeamMemberResponse
 *
 * @generated from message identities.v1.RemoveTeamMemberResponse
 */
export type RemoveTeamMemberResponse = Message<"identities.v1.RemoveTeamMemberResponse"> & {};

/**
 * RemoveTeamMemberResponse
 *
 * @generated from message identities.v1.RemoveTeamMemberResponse
 */
export type RemoveTeamMemberResponseJson = {};

/**
 * Describes the message identities.v1.RemoveTeamMemberResponse.
 * Use `create(RemoveTeamMemberResponseSchema)` to create a new message.
 */
export const RemoveTeamMemberResponseSchema: GenMessage<RemoveTeamMemberResponse, { jsonType: RemoveTeamMemberResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 147);

/**
 * CreateTeamRequest
 *
 * @generated from message identities.v1.CreateTeamRequest
 */
export type CreateTeamRequest = Message<"identities.v1.CreateTeamRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name: string;

	/**
	 * @generated from field: string description = 3;
	 */
	description: string;

	/**
	 * @generated from field: string photo_url = 4;
	 */
	photoUrl: string;
};

/**
 * CreateTeamRequest
 *
 * @generated from message identities.v1.CreateTeamRequest
 */
export type CreateTeamRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name?: string;

	/**
	 * @generated from field: string description = 3;
	 */
	description?: string;

	/**
	 * @generated from field: string photo_url = 4;
	 */
	photoUrl?: string;
};

/**
 * Describes the message identities.v1.CreateTeamRequest.
 * Use `create(CreateTeamRequestSchema)` to create a new message.
 */
export const CreateTeamRequestSchema: GenMessage<CreateTeamRequest, { jsonType: CreateTeamRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 148);

/**
 * CreateTeamResponse
 *
 * @generated from message identities.v1.CreateTeamResponse
 */
export type CreateTeamResponse = Message<"identities.v1.CreateTeamResponse"> & {
	/**
	 * @generated from field: identities.v1.Team team = 1;
	 */
	team?: Team | undefined;
};

/**
 * CreateTeamResponse
 *
 * @generated from message identities.v1.CreateTeamResponse
 */
export type CreateTeamResponseJson = {
	/**
	 * @generated from field: identities.v1.Team team = 1;
	 */
	team?: TeamJson;
};

/**
 * Describes the message identities.v1.CreateTeamResponse.
 * Use `create(CreateTeamResponseSchema)` to create a new message.
 */
export const CreateTeamResponseSchema: GenMessage<CreateTeamResponse, { jsonType: CreateTeamResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 149);

/**
 * TeamCreated is the event message published when a team is created
 *
 * @generated from message identities.v1.TeamCreated
 */
export type TeamCreated = Message<"identities.v1.TeamCreated"> & {
	/**
	 * @generated from field: identities.v1.Team team = 1;
	 */
	team?: Team | undefined;
};

/**
 * TeamCreated is the event message published when a team is created
 *
 * @generated from message identities.v1.TeamCreated
 */
export type TeamCreatedJson = {
	/**
	 * @generated from field: identities.v1.Team team = 1;
	 */
	team?: TeamJson;
};

/**
 * Describes the message identities.v1.TeamCreated.
 * Use `create(TeamCreatedSchema)` to create a new message.
 */
export const TeamCreatedSchema: GenMessage<TeamCreated, { jsonType: TeamCreatedJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 150);

/**
 * TeamUpdated is the event message published when a team is updated
 *
 * @generated from message identities.v1.TeamUpdated
 */
export type TeamUpdated = Message<"identities.v1.TeamUpdated"> & {
	/**
	 * @generated from field: identities.v1.Team team = 1;
	 */
	team?: Team | undefined;
};

/**
 * TeamUpdated is the event message published when a team is updated
 *
 * @generated from message identities.v1.TeamUpdated
 */
export type TeamUpdatedJson = {
	/**
	 * @generated from field: identities.v1.Team team = 1;
	 */
	team?: TeamJson;
};

/**
 * Describes the message identities.v1.TeamUpdated.
 * Use `create(TeamUpdatedSchema)` to create a new message.
 */
export const TeamUpdatedSchema: GenMessage<TeamUpdated, { jsonType: TeamUpdatedJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 151);

/**
 * TeamDeleted is the event message published when a team is deleted
 *
 * @generated from message identities.v1.TeamDeleted
 */
export type TeamDeleted = Message<"identities.v1.TeamDeleted"> & {
	/**
	 * @generated from field: identities.v1.Team team = 1;
	 */
	team?: Team | undefined;
};

/**
 * TeamDeleted is the event message published when a team is deleted
 *
 * @generated from message identities.v1.TeamDeleted
 */
export type TeamDeletedJson = {
	/**
	 * @generated from field: identities.v1.Team team = 1;
	 */
	team?: TeamJson;
};

/**
 * Describes the message identities.v1.TeamDeleted.
 * Use `create(TeamDeletedSchema)` to create a new message.
 */
export const TeamDeletedSchema: GenMessage<TeamDeleted, { jsonType: TeamDeletedJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 152);

/**
 * ExternalUser meant to be used with third party integrations like CANVA
 *
 * @generated from message identities.v1.ExternalUser
 */
export type ExternalUser = Message<"identities.v1.ExternalUser"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string user_id = 2;
	 */
	userId: string;

	/**
	 * @generated from field: string external_user_id = 3;
	 */
	externalUserId: string;

	/**
	 * @generated from field: string external_type = 4;
	 */
	externalType: string;

	/**
	 * @generated from field: bool is_external_sign_up = 5;
	 */
	isExternalSignUp: boolean;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 6;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 7;
	 */
	updatedAt?: Timestamp | undefined;

	/**
	 * @generated from field: optional google.protobuf.Timestamp deleted_at = 8;
	 */
	deletedAt?: Timestamp | undefined;
};

/**
 * ExternalUser meant to be used with third party integrations like CANVA
 *
 * @generated from message identities.v1.ExternalUser
 */
export type ExternalUserJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string user_id = 2;
	 */
	userId?: string;

	/**
	 * @generated from field: string external_user_id = 3;
	 */
	externalUserId?: string;

	/**
	 * @generated from field: string external_type = 4;
	 */
	externalType?: string;

	/**
	 * @generated from field: bool is_external_sign_up = 5;
	 */
	isExternalSignUp?: boolean;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 6;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 7;
	 */
	updatedAt?: TimestampJson;

	/**
	 * @generated from field: optional google.protobuf.Timestamp deleted_at = 8;
	 */
	deletedAt?: TimestampJson;
};

/**
 * Describes the message identities.v1.ExternalUser.
 * Use `create(ExternalUserSchema)` to create a new message.
 */
export const ExternalUserSchema: GenMessage<ExternalUser, { jsonType: ExternalUserJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 153);

/**
 * GetExternalUserRequest is the request object to get a ExternalUser by id
 *
 * @generated from message identities.v1.GetExternalUserRequest
 */
export type GetExternalUserRequest = Message<"identities.v1.GetExternalUserRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string external_id = 2;
	 */
	externalId: string;
};

/**
 * GetExternalUserRequest is the request object to get a ExternalUser by id
 *
 * @generated from message identities.v1.GetExternalUserRequest
 */
export type GetExternalUserRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string external_id = 2;
	 */
	externalId?: string;
};

/**
 * Describes the message identities.v1.GetExternalUserRequest.
 * Use `create(GetExternalUserRequestSchema)` to create a new message.
 */
export const GetExternalUserRequestSchema: GenMessage<GetExternalUserRequest, { jsonType: GetExternalUserRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 154);

/**
 * GetExternalUserResponse
 *
 * @generated from message identities.v1.GetExternalUserResponse
 */
export type GetExternalUserResponse = Message<"identities.v1.GetExternalUserResponse"> & {
	/**
	 * @generated from field: identities.v1.ExternalUser external_user = 1;
	 */
	externalUser?: ExternalUser | undefined;
};

/**
 * GetExternalUserResponse
 *
 * @generated from message identities.v1.GetExternalUserResponse
 */
export type GetExternalUserResponseJson = {
	/**
	 * @generated from field: identities.v1.ExternalUser external_user = 1;
	 */
	externalUser?: ExternalUserJson;
};

/**
 * Describes the message identities.v1.GetExternalUserResponse.
 * Use `create(GetExternalUserResponseSchema)` to create a new message.
 */
export const GetExternalUserResponseSchema: GenMessage<GetExternalUserResponse, { jsonType: GetExternalUserResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 155);

/**
 * CreateExternalUserResponse is the object holding a ExternalUser that is to be created
 *
 * @generated from message identities.v1.CreateExternalUserRequest
 */
export type CreateExternalUserRequest = Message<"identities.v1.CreateExternalUserRequest"> & {
	/**
	 * @generated from field: string user_id = 1;
	 */
	userId: string;

	/**
	 * @generated from field: string external_user_id = 2;
	 */
	externalUserId: string;

	/**
	 * @generated from field: string external_type = 3;
	 */
	externalType: string;

	/**
	 * @generated from field: bool is_external_sign_up = 4;
	 */
	isExternalSignUp: boolean;
};

/**
 * CreateExternalUserResponse is the object holding a ExternalUser that is to be created
 *
 * @generated from message identities.v1.CreateExternalUserRequest
 */
export type CreateExternalUserRequestJson = {
	/**
	 * @generated from field: string user_id = 1;
	 */
	userId?: string;

	/**
	 * @generated from field: string external_user_id = 2;
	 */
	externalUserId?: string;

	/**
	 * @generated from field: string external_type = 3;
	 */
	externalType?: string;

	/**
	 * @generated from field: bool is_external_sign_up = 4;
	 */
	isExternalSignUp?: boolean;
};

/**
 * Describes the message identities.v1.CreateExternalUserRequest.
 * Use `create(CreateExternalUserRequestSchema)` to create a new message.
 */
export const CreateExternalUserRequestSchema: GenMessage<CreateExternalUserRequest, { jsonType: CreateExternalUserRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 156);

/**
 * CreateExternalUserResponse is the response to the create ExternalUser request sending back the id of the created
 *
 * @generated from message identities.v1.CreateExternalUserResponse
 */
export type CreateExternalUserResponse = Message<"identities.v1.CreateExternalUserResponse"> & {
	/**
	 * @generated from field: identities.v1.ExternalUser external_user = 1;
	 */
	externalUser?: ExternalUser | undefined;
};

/**
 * CreateExternalUserResponse is the response to the create ExternalUser request sending back the id of the created
 *
 * @generated from message identities.v1.CreateExternalUserResponse
 */
export type CreateExternalUserResponseJson = {
	/**
	 * @generated from field: identities.v1.ExternalUser external_user = 1;
	 */
	externalUser?: ExternalUserJson;
};

/**
 * Describes the message identities.v1.CreateExternalUserResponse.
 * Use `create(CreateExternalUserResponseSchema)` to create a new message.
 */
export const CreateExternalUserResponseSchema: GenMessage<CreateExternalUserResponse, { jsonType: CreateExternalUserResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 157);

/**
 * ListExternalUsersRequest is an empty object, later we can fill it with filtering options
 *
 * @generated from message identities.v1.ListExternalUsersRequest
 */
export type ListExternalUsersRequest = Message<"identities.v1.ListExternalUsersRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;
};

/**
 * ListExternalUsersRequest is an empty object, later we can fill it with filtering options
 *
 * @generated from message identities.v1.ListExternalUsersRequest
 */
export type ListExternalUsersRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;
};

/**
 * Describes the message identities.v1.ListExternalUsersRequest.
 * Use `create(ListExternalUsersRequestSchema)` to create a new message.
 */
export const ListExternalUsersRequestSchema: GenMessage<ListExternalUsersRequest, { jsonType: ListExternalUsersRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 158);

/**
 * ListExternalUsersResponse returns an array of ExternalUsers
 *
 * @generated from message identities.v1.ListExternalUsersResponse
 */
export type ListExternalUsersResponse = Message<"identities.v1.ListExternalUsersResponse"> & {
	/**
	 * @generated from field: repeated identities.v1.ExternalUser items = 1;
	 */
	items: ExternalUser[];
};

/**
 * ListExternalUsersResponse returns an array of ExternalUsers
 *
 * @generated from message identities.v1.ListExternalUsersResponse
 */
export type ListExternalUsersResponseJson = {
	/**
	 * @generated from field: repeated identities.v1.ExternalUser items = 1;
	 */
	items?: ExternalUserJson[];
};

/**
 * Describes the message identities.v1.ListExternalUsersResponse.
 * Use `create(ListExternalUsersResponseSchema)` to create a new message.
 */
export const ListExternalUsersResponseSchema: GenMessage<ListExternalUsersResponse, { jsonType: ListExternalUsersResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 159);

/**
 * DeleteExternalUserRequest holds an id which is then deleted from the database
 *
 * @generated from message identities.v1.DeleteExternalUserRequest
 */
export type DeleteExternalUserRequest = Message<"identities.v1.DeleteExternalUserRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * DeleteExternalUserRequest holds an id which is then deleted from the database
 *
 * @generated from message identities.v1.DeleteExternalUserRequest
 */
export type DeleteExternalUserRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message identities.v1.DeleteExternalUserRequest.
 * Use `create(DeleteExternalUserRequestSchema)` to create a new message.
 */
export const DeleteExternalUserRequestSchema: GenMessage<DeleteExternalUserRequest, { jsonType: DeleteExternalUserRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 160);

/**
 * DeleteExternalUserResponse <haven't figured out what to put here yet>
 *
 * @generated from message identities.v1.DeleteExternalUserResponse
 */
export type DeleteExternalUserResponse = Message<"identities.v1.DeleteExternalUserResponse"> & {};

/**
 * DeleteExternalUserResponse <haven't figured out what to put here yet>
 *
 * @generated from message identities.v1.DeleteExternalUserResponse
 */
export type DeleteExternalUserResponseJson = {};

/**
 * Describes the message identities.v1.DeleteExternalUserResponse.
 * Use `create(DeleteExternalUserResponseSchema)` to create a new message.
 */
export const DeleteExternalUserResponseSchema: GenMessage<DeleteExternalUserResponse, { jsonType: DeleteExternalUserResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 161);

/**
 * @generated from message identities.v1.SamlAuthPrehookRequest
 */
export type SamlAuthPrehookRequest = Message<"identities.v1.SamlAuthPrehookRequest"> & {
	/**
	 * @generated from field: string event_key = 1;
	 */
	eventKey: string;

	/**
	 * @generated from field: identities.v1.Context prehook_context = 2;
	 */
	prehookContext?: Context | undefined;

	/**
	 * @generated from field: identities.v1.AuthData data = 3;
	 */
	data?: AuthData | undefined;
};

/**
 * @generated from message identities.v1.SamlAuthPrehookRequest
 */
export type SamlAuthPrehookRequestJson = {
	/**
	 * @generated from field: string event_key = 1;
	 */
	eventKey?: string;

	/**
	 * @generated from field: identities.v1.Context prehook_context = 2;
	 */
	prehookContext?: ContextJson;

	/**
	 * @generated from field: identities.v1.AuthData data = 3;
	 */
	data?: AuthDataJson;
};

/**
 * Describes the message identities.v1.SamlAuthPrehookRequest.
 * Use `create(SamlAuthPrehookRequestSchema)` to create a new message.
 */
export const SamlAuthPrehookRequestSchema: GenMessage<SamlAuthPrehookRequest, { jsonType: SamlAuthPrehookRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 162);

/**
 * @generated from message identities.v1.SamlAuthPrehookResponse
 */
export type SamlAuthPrehookResponse = Message<"identities.v1.SamlAuthPrehookResponse"> & {
	/**
	 * @generated from field: bool continue = 1;
	 */
	continue: boolean;

	/**
	 * @generated from field: identities.v1.ErrMsg error = 2;
	 */
	error?: ErrMsg | undefined;

	/**
	 * @generated from field: identities.v1.SamlResponse response = 3;
	 */
	response?: SamlResponse | undefined;
};

/**
 * @generated from message identities.v1.SamlAuthPrehookResponse
 */
export type SamlAuthPrehookResponseJson = {
	/**
	 * @generated from field: bool continue = 1;
	 */
	continue?: boolean;

	/**
	 * @generated from field: identities.v1.ErrMsg error = 2;
	 */
	error?: ErrMsgJson;

	/**
	 * @generated from field: identities.v1.SamlResponse response = 3;
	 */
	response?: SamlResponseJson;
};

/**
 * Describes the message identities.v1.SamlAuthPrehookResponse.
 * Use `create(SamlAuthPrehookResponseSchema)` to create a new message.
 */
export const SamlAuthPrehookResponseSchema: GenMessage<SamlAuthPrehookResponse, { jsonType: SamlAuthPrehookResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 163);

/**
 * @generated from message identities.v1.WorkspaceTeam
 */
export type WorkspaceTeam = Message<"identities.v1.WorkspaceTeam"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string role_id = 2 [deprecated = true];
	 * @deprecated
	 */
	roleId: string;

	/**
	 * @generated from field: string team_id = 3;
	 */
	teamId: string;

	/**
	 * @generated from field: string workspace_id = 4;
	 */
	workspaceId: string;

	/**
	 * @generated from field: identities.v1.Team team = 5;
	 */
	team?: Team | undefined;

	/**
	 * @generated from field: identities.v1.Role role = 6 [deprecated = true];
	 * @deprecated
	 */
	role?: Role | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 7;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 8;
	 */
	updatedAt?: Timestamp | undefined;

	/**
	 * @generated from field: optional google.protobuf.Timestamp deleted_at = 9;
	 */
	deletedAt?: Timestamp | undefined;

	/**
	 * @generated from field: repeated identities.v1.Role roles = 10;
	 */
	roles: Role[];

	/**
	 * @generated from field: identities.v1.Workspace workspace = 11;
	 */
	workspace?: Workspace | undefined;
};

/**
 * @generated from message identities.v1.WorkspaceTeam
 */
export type WorkspaceTeamJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string role_id = 2 [deprecated = true];
	 * @deprecated
	 */
	roleId?: string;

	/**
	 * @generated from field: string team_id = 3;
	 */
	teamId?: string;

	/**
	 * @generated from field: string workspace_id = 4;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: identities.v1.Team team = 5;
	 */
	team?: TeamJson;

	/**
	 * @generated from field: identities.v1.Role role = 6 [deprecated = true];
	 * @deprecated
	 */
	role?: RoleJson;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 7;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 8;
	 */
	updatedAt?: TimestampJson;

	/**
	 * @generated from field: optional google.protobuf.Timestamp deleted_at = 9;
	 */
	deletedAt?: TimestampJson;

	/**
	 * @generated from field: repeated identities.v1.Role roles = 10;
	 */
	roles?: RoleJson[];

	/**
	 * @generated from field: identities.v1.Workspace workspace = 11;
	 */
	workspace?: WorkspaceJson;
};

/**
 * Describes the message identities.v1.WorkspaceTeam.
 * Use `create(WorkspaceTeamSchema)` to create a new message.
 */
export const WorkspaceTeamSchema: GenMessage<WorkspaceTeam, { jsonType: WorkspaceTeamJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 164);

/**
 * @generated from message identities.v1.ListWorkspaceTeamsFilter
 */
export type ListWorkspaceTeamsFilter = Message<"identities.v1.ListWorkspaceTeamsFilter"> & {
	/**
	 * @generated from field: optional string name = 1;
	 */
	name?: string | undefined;
};

/**
 * @generated from message identities.v1.ListWorkspaceTeamsFilter
 */
export type ListWorkspaceTeamsFilterJson = {
	/**
	 * @generated from field: optional string name = 1;
	 */
	name?: string;
};

/**
 * Describes the message identities.v1.ListWorkspaceTeamsFilter.
 * Use `create(ListWorkspaceTeamsFilterSchema)` to create a new message.
 */
export const ListWorkspaceTeamsFilterSchema: GenMessage<ListWorkspaceTeamsFilter, { jsonType: ListWorkspaceTeamsFilterJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 165);

/**
 * @generated from message identities.v1.ListWorkspaceTeamsRequest
 */
export type ListWorkspaceTeamsRequest = Message<"identities.v1.ListWorkspaceTeamsRequest"> & {
	/**
	 * @generated from field: string workspace_id = 1;
	 */
	workspaceId: string;

	/**
	 * @generated from field: identities.v1.ListWorkspaceTeamsFilter filter = 3;
	 */
	filter?: ListWorkspaceTeamsFilter | undefined;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 2;
	 */
	paginate?: PaginationArguments | undefined;
};

/**
 * @generated from message identities.v1.ListWorkspaceTeamsRequest
 */
export type ListWorkspaceTeamsRequestJson = {
	/**
	 * @generated from field: string workspace_id = 1;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: identities.v1.ListWorkspaceTeamsFilter filter = 3;
	 */
	filter?: ListWorkspaceTeamsFilterJson;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 2;
	 */
	paginate?: PaginationArgumentsJson;
};

/**
 * Describes the message identities.v1.ListWorkspaceTeamsRequest.
 * Use `create(ListWorkspaceTeamsRequestSchema)` to create a new message.
 */
export const ListWorkspaceTeamsRequestSchema: GenMessage<ListWorkspaceTeamsRequest, { jsonType: ListWorkspaceTeamsRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 166);

/**
 * @generated from message identities.v1.ListWorkspaceTeamsDetails
 */
export type ListWorkspaceTeamsDetails = Message<"identities.v1.ListWorkspaceTeamsDetails"> & {
	/**
	 * @generated from field: identities.v1.Team team = 1;
	 */
	team?: Team | undefined;

	/**
	 * @generated from field: identities.v1.Role role = 2 [deprecated = true];
	 * @deprecated
	 */
	role?: Role | undefined;

	/**
	 * @generated from field: repeated identities.v1.Role roles = 3;
	 */
	roles: Role[];
};

/**
 * @generated from message identities.v1.ListWorkspaceTeamsDetails
 */
export type ListWorkspaceTeamsDetailsJson = {
	/**
	 * @generated from field: identities.v1.Team team = 1;
	 */
	team?: TeamJson;

	/**
	 * @generated from field: identities.v1.Role role = 2 [deprecated = true];
	 * @deprecated
	 */
	role?: RoleJson;

	/**
	 * @generated from field: repeated identities.v1.Role roles = 3;
	 */
	roles?: RoleJson[];
};

/**
 * Describes the message identities.v1.ListWorkspaceTeamsDetails.
 * Use `create(ListWorkspaceTeamsDetailsSchema)` to create a new message.
 */
export const ListWorkspaceTeamsDetailsSchema: GenMessage<ListWorkspaceTeamsDetails, { jsonType: ListWorkspaceTeamsDetailsJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 167);

/**
 * @generated from message identities.v1.ListWorkspaceTeamsResponse
 */
export type ListWorkspaceTeamsResponse = Message<"identities.v1.ListWorkspaceTeamsResponse"> & {
	/**
	 * @generated from field: repeated identities.v1.ListWorkspaceTeamsDetails teams = 1;
	 */
	teams: ListWorkspaceTeamsDetails[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message identities.v1.ListWorkspaceTeamsResponse
 */
export type ListWorkspaceTeamsResponseJson = {
	/**
	 * @generated from field: repeated identities.v1.ListWorkspaceTeamsDetails teams = 1;
	 */
	teams?: ListWorkspaceTeamsDetailsJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message identities.v1.ListWorkspaceTeamsResponse.
 * Use `create(ListWorkspaceTeamsResponseSchema)` to create a new message.
 */
export const ListWorkspaceTeamsResponseSchema: GenMessage<ListWorkspaceTeamsResponse, { jsonType: ListWorkspaceTeamsResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 168);

/**
 * @generated from message identities.v1.ListWorkspaceTeamAssignmentsRequest
 */
export type ListWorkspaceTeamAssignmentsRequest = Message<"identities.v1.ListWorkspaceTeamAssignmentsRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: identities.v1.WorkspaceTeamAssignmentFilter filter = 2;
	 */
	filter?: WorkspaceTeamAssignmentFilter | undefined;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 3;
	 */
	paginate?: PaginationArguments | undefined;
};

/**
 * @generated from message identities.v1.ListWorkspaceTeamAssignmentsRequest
 */
export type ListWorkspaceTeamAssignmentsRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: identities.v1.WorkspaceTeamAssignmentFilter filter = 2;
	 */
	filter?: WorkspaceTeamAssignmentFilterJson;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 3;
	 */
	paginate?: PaginationArgumentsJson;
};

/**
 * Describes the message identities.v1.ListWorkspaceTeamAssignmentsRequest.
 * Use `create(ListWorkspaceTeamAssignmentsRequestSchema)` to create a new message.
 */
export const ListWorkspaceTeamAssignmentsRequestSchema: GenMessage<ListWorkspaceTeamAssignmentsRequest, { jsonType: ListWorkspaceTeamAssignmentsRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 169);

/**
 * @generated from message identities.v1.WorkspaceTeamAssignmentFilter
 */
export type WorkspaceTeamAssignmentFilter = Message<"identities.v1.WorkspaceTeamAssignmentFilter"> & {
	/**
	 * @generated from field: optional string workspace_id = 1;
	 */
	workspaceId?: string | undefined;

	/**
	 * @generated from field: optional string team_id = 2;
	 */
	teamId?: string | undefined;

	/**
	 * filter to workspace team assignments where the requested user belongs to the team
	 *
	 * @generated from field: optional string user_id = 3;
	 */
	userId?: string | undefined;
};

/**
 * @generated from message identities.v1.WorkspaceTeamAssignmentFilter
 */
export type WorkspaceTeamAssignmentFilterJson = {
	/**
	 * @generated from field: optional string workspace_id = 1;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: optional string team_id = 2;
	 */
	teamId?: string;

	/**
	 * filter to workspace team assignments where the requested user belongs to the team
	 *
	 * @generated from field: optional string user_id = 3;
	 */
	userId?: string;
};

/**
 * Describes the message identities.v1.WorkspaceTeamAssignmentFilter.
 * Use `create(WorkspaceTeamAssignmentFilterSchema)` to create a new message.
 */
export const WorkspaceTeamAssignmentFilterSchema: GenMessage<WorkspaceTeamAssignmentFilter, { jsonType: WorkspaceTeamAssignmentFilterJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 170);

/**
 * @generated from message identities.v1.ListWorkspaceTeamAssignmentsResponse
 */
export type ListWorkspaceTeamAssignmentsResponse = Message<"identities.v1.ListWorkspaceTeamAssignmentsResponse"> & {
	/**
	 * @generated from field: repeated identities.v1.WorkspaceTeam items = 1;
	 */
	items: WorkspaceTeam[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message identities.v1.ListWorkspaceTeamAssignmentsResponse
 */
export type ListWorkspaceTeamAssignmentsResponseJson = {
	/**
	 * @generated from field: repeated identities.v1.WorkspaceTeam items = 1;
	 */
	items?: WorkspaceTeamJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message identities.v1.ListWorkspaceTeamAssignmentsResponse.
 * Use `create(ListWorkspaceTeamAssignmentsResponseSchema)` to create a new message.
 */
export const ListWorkspaceTeamAssignmentsResponseSchema: GenMessage<ListWorkspaceTeamAssignmentsResponse, { jsonType: ListWorkspaceTeamAssignmentsResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 171);

/**
 * @generated from message identities.v1.AccessRequest
 */
export type AccessRequest = Message<"identities.v1.AccessRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string user_id = 2;
	 */
	userId: string;

	/**
	 * @generated from field: string org_id = 3;
	 */
	orgId: string;

	/**
	 * @generated from field: string status = 4;
	 */
	status: string;

	/**
	 * @generated from field: string message = 5;
	 */
	message: string;

	/**
	 * @generated from field: string corp_id = 11;
	 */
	corpId: string;

	/**
	 * @generated from field: identities.v1.AccessRequestType access_type = 10;
	 */
	accessType: AccessRequestType;

	/**
	 * @generated from field: google.protobuf.Timestamp request_date = 6;
	 */
	requestDate?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 7;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 8;
	 */
	updatedAt?: Timestamp | undefined;

	/**
	 * @generated from field: optional google.protobuf.Timestamp deleted_at = 9;
	 */
	deletedAt?: Timestamp | undefined;
};

/**
 * @generated from message identities.v1.AccessRequest
 */
export type AccessRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string user_id = 2;
	 */
	userId?: string;

	/**
	 * @generated from field: string org_id = 3;
	 */
	orgId?: string;

	/**
	 * @generated from field: string status = 4;
	 */
	status?: string;

	/**
	 * @generated from field: string message = 5;
	 */
	message?: string;

	/**
	 * @generated from field: string corp_id = 11;
	 */
	corpId?: string;

	/**
	 * @generated from field: identities.v1.AccessRequestType access_type = 10;
	 */
	accessType?: AccessRequestTypeJson;

	/**
	 * @generated from field: google.protobuf.Timestamp request_date = 6;
	 */
	requestDate?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 7;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 8;
	 */
	updatedAt?: TimestampJson;

	/**
	 * @generated from field: optional google.protobuf.Timestamp deleted_at = 9;
	 */
	deletedAt?: TimestampJson;
};

/**
 * Describes the message identities.v1.AccessRequest.
 * Use `create(AccessRequestSchema)` to create a new message.
 */
export const AccessRequestSchema: GenMessage<AccessRequest, { jsonType: AccessRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 172);

/**
 * @generated from message identities.v1.CreateTempAccessRequest
 */
export type CreateTempAccessRequest = Message<"identities.v1.CreateTempAccessRequest"> & {
	/**
	 * @generated from field: string user_id = 1;
	 */
	userId: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;

	/**
	 * @generated from field: string corp_id = 4;
	 */
	corpId: string;

	/**
	 * @generated from field: string message = 3;
	 */
	message: string;

	/**
	 * @generated from field: identities.v1.AccessRequestType type = 5;
	 */
	type: AccessRequestType;
};

/**
 * @generated from message identities.v1.CreateTempAccessRequest
 */
export type CreateTempAccessRequestJson = {
	/**
	 * @generated from field: string user_id = 1;
	 */
	userId?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;

	/**
	 * @generated from field: string corp_id = 4;
	 */
	corpId?: string;

	/**
	 * @generated from field: string message = 3;
	 */
	message?: string;

	/**
	 * @generated from field: identities.v1.AccessRequestType type = 5;
	 */
	type?: AccessRequestTypeJson;
};

/**
 * Describes the message identities.v1.CreateTempAccessRequest.
 * Use `create(CreateTempAccessRequestSchema)` to create a new message.
 */
export const CreateTempAccessRequestSchema: GenMessage<CreateTempAccessRequest, { jsonType: CreateTempAccessRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 173);

/**
 * @generated from message identities.v1.CreateTempAccessResponse
 */
export type CreateTempAccessResponse = Message<"identities.v1.CreateTempAccessResponse"> & {
	/**
	 * @generated from field: identities.v1.AccessRequest item = 1;
	 */
	item?: AccessRequest | undefined;
};

/**
 * @generated from message identities.v1.CreateTempAccessResponse
 */
export type CreateTempAccessResponseJson = {
	/**
	 * @generated from field: identities.v1.AccessRequest item = 1;
	 */
	item?: AccessRequestJson;
};

/**
 * Describes the message identities.v1.CreateTempAccessResponse.
 * Use `create(CreateTempAccessResponseSchema)` to create a new message.
 */
export const CreateTempAccessResponseSchema: GenMessage<CreateTempAccessResponse, { jsonType: CreateTempAccessResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 174);

/**
 * @generated from message identities.v1.GetTempAccessRequest
 */
export type GetTempAccessRequest = Message<"identities.v1.GetTempAccessRequest"> & {
	/**
	 * @generated from field: string user_id = 1;
	 */
	userId: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;

	/**
	 * @generated from field: string corp_id = 3;
	 */
	corpId: string;

	/**
	 * @generated from field: identities.v1.AccessRequestType type = 4;
	 */
	type: AccessRequestType;
};

/**
 * @generated from message identities.v1.GetTempAccessRequest
 */
export type GetTempAccessRequestJson = {
	/**
	 * @generated from field: string user_id = 1;
	 */
	userId?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;

	/**
	 * @generated from field: string corp_id = 3;
	 */
	corpId?: string;

	/**
	 * @generated from field: identities.v1.AccessRequestType type = 4;
	 */
	type?: AccessRequestTypeJson;
};

/**
 * Describes the message identities.v1.GetTempAccessRequest.
 * Use `create(GetTempAccessRequestSchema)` to create a new message.
 */
export const GetTempAccessRequestSchema: GenMessage<GetTempAccessRequest, { jsonType: GetTempAccessRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 175);

/**
 * @generated from message identities.v1.GetTempAccessResponse
 */
export type GetTempAccessResponse = Message<"identities.v1.GetTempAccessResponse"> & {
	/**
	 * @generated from field: repeated identities.v1.AccessRequest items = 1;
	 */
	items: AccessRequest[];
};

/**
 * @generated from message identities.v1.GetTempAccessResponse
 */
export type GetTempAccessResponseJson = {
	/**
	 * @generated from field: repeated identities.v1.AccessRequest items = 1;
	 */
	items?: AccessRequestJson[];
};

/**
 * Describes the message identities.v1.GetTempAccessResponse.
 * Use `create(GetTempAccessResponseSchema)` to create a new message.
 */
export const GetTempAccessResponseSchema: GenMessage<GetTempAccessResponse, { jsonType: GetTempAccessResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 176);

/**
 * @generated from message identities.v1.ListTempAccessRequest
 */
export type ListTempAccessRequest = Message<"identities.v1.ListTempAccessRequest"> & {
	/**
	 * @generated from field: string user_id = 1;
	 */
	userId: string;
};

/**
 * @generated from message identities.v1.ListTempAccessRequest
 */
export type ListTempAccessRequestJson = {
	/**
	 * @generated from field: string user_id = 1;
	 */
	userId?: string;
};

/**
 * Describes the message identities.v1.ListTempAccessRequest.
 * Use `create(ListTempAccessRequestSchema)` to create a new message.
 */
export const ListTempAccessRequestSchema: GenMessage<ListTempAccessRequest, { jsonType: ListTempAccessRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 177);

/**
 * @generated from message identities.v1.ListTempAccessResponse
 */
export type ListTempAccessResponse = Message<"identities.v1.ListTempAccessResponse"> & {
	/**
	 * @generated from field: repeated identities.v1.AccessRequest items = 1;
	 */
	items: AccessRequest[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message identities.v1.ListTempAccessResponse
 */
export type ListTempAccessResponseJson = {
	/**
	 * @generated from field: repeated identities.v1.AccessRequest items = 1;
	 */
	items?: AccessRequestJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message identities.v1.ListTempAccessResponse.
 * Use `create(ListTempAccessResponseSchema)` to create a new message.
 */
export const ListTempAccessResponseSchema: GenMessage<ListTempAccessResponse, { jsonType: ListTempAccessResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 178);

/**
 * @generated from message identities.v1.DeleteTempAccessRequest
 */
export type DeleteTempAccessRequest = Message<"identities.v1.DeleteTempAccessRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string user_id = 2;
	 */
	userId: string;

	/**
	 * @generated from field: string corp_id = 3;
	 */
	corpId: string;

	/**
	 * @generated from field: identities.v1.AccessRequestType type = 4;
	 */
	type: AccessRequestType;
};

/**
 * @generated from message identities.v1.DeleteTempAccessRequest
 */
export type DeleteTempAccessRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string user_id = 2;
	 */
	userId?: string;

	/**
	 * @generated from field: string corp_id = 3;
	 */
	corpId?: string;

	/**
	 * @generated from field: identities.v1.AccessRequestType type = 4;
	 */
	type?: AccessRequestTypeJson;
};

/**
 * Describes the message identities.v1.DeleteTempAccessRequest.
 * Use `create(DeleteTempAccessRequestSchema)` to create a new message.
 */
export const DeleteTempAccessRequestSchema: GenMessage<DeleteTempAccessRequest, { jsonType: DeleteTempAccessRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 179);

/**
 * @generated from message identities.v1.DeleteTempAccessResponse
 */
export type DeleteTempAccessResponse = Message<"identities.v1.DeleteTempAccessResponse"> & {
	/**
	 * @generated from field: identities.v1.AccessRequest item = 1;
	 */
	item?: AccessRequest | undefined;
};

/**
 * @generated from message identities.v1.DeleteTempAccessResponse
 */
export type DeleteTempAccessResponseJson = {
	/**
	 * @generated from field: identities.v1.AccessRequest item = 1;
	 */
	item?: AccessRequestJson;
};

/**
 * Describes the message identities.v1.DeleteTempAccessResponse.
 * Use `create(DeleteTempAccessResponseSchema)` to create a new message.
 */
export const DeleteTempAccessResponseSchema: GenMessage<DeleteTempAccessResponse, { jsonType: DeleteTempAccessResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 180);

/**
 * @generated from message identities.v1.SSOConfigV2
 */
export type SSOConfigV2 = Message<"identities.v1.SSOConfigV2"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: bool enabled = 2;
	 */
	enabled: boolean;

	/**
	 * @generated from field: string acs_url = 3;
	 */
	acsUrl: string;

	/**
	 * @generated from field: string config_metadata = 4;
	 */
	configMetadata: string;

	/**
	 * @generated from field: bool force_authn = 5;
	 */
	forceAuthn: boolean;

	/**
	 * @generated from field: string generated_verification = 6;
	 */
	generatedVerification: string;

	/**
	 * @generated from field: string oidc_client_id = 7;
	 */
	oidcClientId: string;

	/**
	 * @generated from field: string oidc_secret = 8;
	 */
	oidcSecret: string;

	/**
	 * @generated from field: string public_certificate = 9;
	 */
	publicCertificate: string;

	/**
	 * @generated from field: repeated string role_ids = 10;
	 */
	roleIds: string[];

	/**
	 * @generated from field: bool sign_request = 11;
	 */
	signRequest: boolean;

	/**
	 * @generated from field: bool skip_email_domain_validation = 12;
	 */
	skipEmailDomainValidation: boolean;

	/**
	 * @generated from field: string sp_entity_id = 13;
	 */
	spEntityId: string;

	/**
	 * @generated from field: string sso_endpoint = 14;
	 */
	ssoEndpoint: string;

	/**
	 * @generated from field: string tenant_id = 15;
	 */
	tenantId: string;

	/**
	 * "saml" | "oidc"
	 *
	 * @generated from field: string type = 16;
	 */
	type: string;

	/**
	 * @generated from field: repeated identities.v1.SSOGroup groups = 17;
	 */
	groups: SSOGroup[];

	/**
	 * @generated from field: repeated identities.v1.SSODomain domains = 18;
	 */
	domains: SSODomain[];
};

/**
 * @generated from message identities.v1.SSOConfigV2
 */
export type SSOConfigV2Json = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: bool enabled = 2;
	 */
	enabled?: boolean;

	/**
	 * @generated from field: string acs_url = 3;
	 */
	acsUrl?: string;

	/**
	 * @generated from field: string config_metadata = 4;
	 */
	configMetadata?: string;

	/**
	 * @generated from field: bool force_authn = 5;
	 */
	forceAuthn?: boolean;

	/**
	 * @generated from field: string generated_verification = 6;
	 */
	generatedVerification?: string;

	/**
	 * @generated from field: string oidc_client_id = 7;
	 */
	oidcClientId?: string;

	/**
	 * @generated from field: string oidc_secret = 8;
	 */
	oidcSecret?: string;

	/**
	 * @generated from field: string public_certificate = 9;
	 */
	publicCertificate?: string;

	/**
	 * @generated from field: repeated string role_ids = 10;
	 */
	roleIds?: string[];

	/**
	 * @generated from field: bool sign_request = 11;
	 */
	signRequest?: boolean;

	/**
	 * @generated from field: bool skip_email_domain_validation = 12;
	 */
	skipEmailDomainValidation?: boolean;

	/**
	 * @generated from field: string sp_entity_id = 13;
	 */
	spEntityId?: string;

	/**
	 * @generated from field: string sso_endpoint = 14;
	 */
	ssoEndpoint?: string;

	/**
	 * @generated from field: string tenant_id = 15;
	 */
	tenantId?: string;

	/**
	 * "saml" | "oidc"
	 *
	 * @generated from field: string type = 16;
	 */
	type?: string;

	/**
	 * @generated from field: repeated identities.v1.SSOGroup groups = 17;
	 */
	groups?: SSOGroupJson[];

	/**
	 * @generated from field: repeated identities.v1.SSODomain domains = 18;
	 */
	domains?: SSODomainJson[];
};

/**
 * Describes the message identities.v1.SSOConfigV2.
 * Use `create(SSOConfigV2Schema)` to create a new message.
 */
export const SSOConfigV2Schema: GenMessage<SSOConfigV2, { jsonType: SSOConfigV2Json }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 181);

/**
 * @generated from message identities.v1.SsoConfiguration
 */
export type SsoConfiguration = Message<"identities.v1.SsoConfiguration"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;

	/**
	 * @generated from field: bool enabled = 3;
	 */
	enabled: boolean;

	/**
	 * @generated from field: string sso_endpoint = 4;
	 */
	ssoEndpoint: string;

	/**
	 * @generated from field: string public_certificate = 5;
	 */
	publicCertificate: string;

	/**
	 * @generated from field: string generated_verification = 6;
	 */
	generatedVerification: string;

	/**
	 * @generated from field: bool sign_request = 7;
	 */
	signRequest: boolean;

	/**
	 * @generated from field: string acs_url = 8;
	 */
	acsUrl: string;

	/**
	 * @generated from field: string sp_entity_id = 9;
	 */
	spEntityId: string;

	/**
	 * @generated from field: string oidc_client_id = 10;
	 */
	oidcClientId: string;

	/**
	 * @generated from field: string oidc_secret = 11;
	 */
	oidcSecret: string;

	/**
	 * @generated from field: string metadata_url = 13;
	 */
	metadataUrl: string;

	/**
	 * @generated from field: identities.v1.SSOType type = 14;
	 */
	type: SSOType;

	/**
	 * @generated from field: repeated identities.v1.SSODomain domains = 15;
	 */
	domains: SSODomain[];

	/**
	 * @generated from field: repeated identities.v1.SSOGroup groups = 16;
	 */
	groups: SSOGroup[];

	/**
	 * Deprecated: Use role_ids instead.
	 *
	 * @generated from field: string default_role = 17 [deprecated = true];
	 * @deprecated
	 */
	defaultRole: string;

	/**
	 * @generated from field: repeated string role_ids = 21;
	 */
	roleIds: string[];

	/**
	 * @generated from field: string metadata = 18;
	 */
	metadata: string;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 19;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 20;
	 */
	updatedAt?: Timestamp | undefined;
};

/**
 * @generated from message identities.v1.SsoConfiguration
 */
export type SsoConfigurationJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;

	/**
	 * @generated from field: bool enabled = 3;
	 */
	enabled?: boolean;

	/**
	 * @generated from field: string sso_endpoint = 4;
	 */
	ssoEndpoint?: string;

	/**
	 * @generated from field: string public_certificate = 5;
	 */
	publicCertificate?: string;

	/**
	 * @generated from field: string generated_verification = 6;
	 */
	generatedVerification?: string;

	/**
	 * @generated from field: bool sign_request = 7;
	 */
	signRequest?: boolean;

	/**
	 * @generated from field: string acs_url = 8;
	 */
	acsUrl?: string;

	/**
	 * @generated from field: string sp_entity_id = 9;
	 */
	spEntityId?: string;

	/**
	 * @generated from field: string oidc_client_id = 10;
	 */
	oidcClientId?: string;

	/**
	 * @generated from field: string oidc_secret = 11;
	 */
	oidcSecret?: string;

	/**
	 * @generated from field: string metadata_url = 13;
	 */
	metadataUrl?: string;

	/**
	 * @generated from field: identities.v1.SSOType type = 14;
	 */
	type?: SSOTypeJson;

	/**
	 * @generated from field: repeated identities.v1.SSODomain domains = 15;
	 */
	domains?: SSODomainJson[];

	/**
	 * @generated from field: repeated identities.v1.SSOGroup groups = 16;
	 */
	groups?: SSOGroupJson[];

	/**
	 * Deprecated: Use role_ids instead.
	 *
	 * @generated from field: string default_role = 17 [deprecated = true];
	 * @deprecated
	 */
	defaultRole?: string;

	/**
	 * @generated from field: repeated string role_ids = 21;
	 */
	roleIds?: string[];

	/**
	 * @generated from field: string metadata = 18;
	 */
	metadata?: string;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 19;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 20;
	 */
	updatedAt?: TimestampJson;
};

/**
 * Describes the message identities.v1.SsoConfiguration.
 * Use `create(SsoConfigurationSchema)` to create a new message.
 */
export const SsoConfigurationSchema: GenMessage<SsoConfiguration, { jsonType: SsoConfigurationJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 182);

/**
 * @generated from message identities.v1.ListSSOConfigurationsRequest
 */
export type ListSSOConfigurationsRequest = Message<"identities.v1.ListSSOConfigurationsRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 2;
	 */
	paginate?: PaginationArguments | undefined;
};

/**
 * @generated from message identities.v1.ListSSOConfigurationsRequest
 */
export type ListSSOConfigurationsRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 2;
	 */
	paginate?: PaginationArgumentsJson;
};

/**
 * Describes the message identities.v1.ListSSOConfigurationsRequest.
 * Use `create(ListSSOConfigurationsRequestSchema)` to create a new message.
 */
export const ListSSOConfigurationsRequestSchema: GenMessage<ListSSOConfigurationsRequest, { jsonType: ListSSOConfigurationsRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 183);

/**
 * @generated from message identities.v1.GetSSOGroupRequest
 */
export type GetSSOGroupRequest = Message<"identities.v1.GetSSOGroupRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string group_id = 2;
	 */
	groupId: string;

	/**
	 * @generated from field: string configuration_id = 3;
	 */
	configurationId: string;
};

/**
 * @generated from message identities.v1.GetSSOGroupRequest
 */
export type GetSSOGroupRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string group_id = 2;
	 */
	groupId?: string;

	/**
	 * @generated from field: string configuration_id = 3;
	 */
	configurationId?: string;
};

/**
 * Describes the message identities.v1.GetSSOGroupRequest.
 * Use `create(GetSSOGroupRequestSchema)` to create a new message.
 */
export const GetSSOGroupRequestSchema: GenMessage<GetSSOGroupRequest, { jsonType: GetSSOGroupRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 184);

/**
 * @generated from message identities.v1.GetSSOGroupResponse
 */
export type GetSSOGroupResponse = Message<"identities.v1.GetSSOGroupResponse"> & {
	/**
	 * @generated from field: identities.v1.SSOGroup item = 1;
	 */
	item?: SSOGroup | undefined;
};

/**
 * @generated from message identities.v1.GetSSOGroupResponse
 */
export type GetSSOGroupResponseJson = {
	/**
	 * @generated from field: identities.v1.SSOGroup item = 1;
	 */
	item?: SSOGroupJson;
};

/**
 * Describes the message identities.v1.GetSSOGroupResponse.
 * Use `create(GetSSOGroupResponseSchema)` to create a new message.
 */
export const GetSSOGroupResponseSchema: GenMessage<GetSSOGroupResponse, { jsonType: GetSSOGroupResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 185);

/**
 * @generated from message identities.v1.ListSSOConfigurationsResponse
 */
export type ListSSOConfigurationsResponse = Message<"identities.v1.ListSSOConfigurationsResponse"> & {
	/**
	 * @generated from field: repeated identities.v1.SsoConfiguration items = 1;
	 */
	items: SsoConfiguration[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message identities.v1.ListSSOConfigurationsResponse
 */
export type ListSSOConfigurationsResponseJson = {
	/**
	 * @generated from field: repeated identities.v1.SsoConfiguration items = 1;
	 */
	items?: SsoConfigurationJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message identities.v1.ListSSOConfigurationsResponse.
 * Use `create(ListSSOConfigurationsResponseSchema)` to create a new message.
 */
export const ListSSOConfigurationsResponseSchema: GenMessage<ListSSOConfigurationsResponse, { jsonType: ListSSOConfigurationsResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 186);

/**
 * @generated from message identities.v1.SSOApiConfig
 */
export type SSOApiConfig = Message<"identities.v1.SSOApiConfig"> & {
	/**
	 * @generated from field: bool enabled = 1;
	 */
	enabled: boolean;

	/**
	 * @generated from field: string sso_endpoint = 2;
	 */
	ssoEndpoint: string;

	/**
	 * @generated from field: string public_certificate = 3;
	 */
	publicCertificate: string;

	/**
	 * @generated from field: bool sign_request = 4;
	 */
	signRequest: boolean;

	/**
	 * @generated from field: string acs_url = 5;
	 */
	acsUrl: string;

	/**
	 * @generated from field: string sp_entity_id = 6;
	 */
	spEntityId: string;

	/**
	 * @generated from field: string oidc_client_id = 7;
	 */
	oidcClientId: string;

	/**
	 * @generated from field: string oidc_secret = 8;
	 */
	oidcSecret: string;

	/**
	 * @generated from field: identities.v1.SSOType type = 9;
	 */
	type: SSOType;
};

/**
 * @generated from message identities.v1.SSOApiConfig
 */
export type SSOApiConfigJson = {
	/**
	 * @generated from field: bool enabled = 1;
	 */
	enabled?: boolean;

	/**
	 * @generated from field: string sso_endpoint = 2;
	 */
	ssoEndpoint?: string;

	/**
	 * @generated from field: string public_certificate = 3;
	 */
	publicCertificate?: string;

	/**
	 * @generated from field: bool sign_request = 4;
	 */
	signRequest?: boolean;

	/**
	 * @generated from field: string acs_url = 5;
	 */
	acsUrl?: string;

	/**
	 * @generated from field: string sp_entity_id = 6;
	 */
	spEntityId?: string;

	/**
	 * @generated from field: string oidc_client_id = 7;
	 */
	oidcClientId?: string;

	/**
	 * @generated from field: string oidc_secret = 8;
	 */
	oidcSecret?: string;

	/**
	 * @generated from field: identities.v1.SSOType type = 9;
	 */
	type?: SSOTypeJson;
};

/**
 * Describes the message identities.v1.SSOApiConfig.
 * Use `create(SSOApiConfigSchema)` to create a new message.
 */
export const SSOApiConfigSchema: GenMessage<SSOApiConfig, { jsonType: SSOApiConfigJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 187);

/**
 * @generated from message identities.v1.SSOConfigV2Payload
 */
export type SSOConfigV2Payload = Message<"identities.v1.SSOConfigV2Payload"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: repeated string domains = 2;
	 */
	domains: string[];

	/**
	 * @generated from field: bool force_authn = 3;
	 */
	forceAuthn: boolean;

	/**
	 * @generated from field: repeated identities.v1.SSOGroup groups = 4;
	 */
	groups: SSOGroup[];

	/**
	 * @generated from field: string idp_config_type = 5;
	 */
	idpConfigType: string;

	/**
	 * @generated from field: string issuer_url = 6;
	 */
	issuerUrl: string;

	/**
	 * @generated from field: string oidc_client_id = 7;
	 */
	oidcClientId: string;

	/**
	 * @generated from field: string oidc_secret = 8;
	 */
	oidcSecret: string;

	/**
	 * @generated from field: string public_certificate = 9;
	 */
	publicCertificate: string;

	/**
	 * @generated from field: repeated string role_ids = 10;
	 */
	roleIds: string[];

	/**
	 * @generated from field: bool skip_email_domain_validation = 11;
	 */
	skipEmailDomainValidation: boolean;

	/**
	 * @generated from field: string sso_endpoint = 12;
	 */
	ssoEndpoint: string;

	/**
	 * @generated from field: string tenant_id = 13;
	 */
	tenantId: string;

	/**
	 * "saml" | "oidc"
	 *
	 * @generated from field: identities.v1.SSOType type = 14;
	 */
	type: SSOType;

	/**
	 * @generated from field: optional bool enabled = 15;
	 */
	enabled?: boolean | undefined;
};

/**
 * @generated from message identities.v1.SSOConfigV2Payload
 */
export type SSOConfigV2PayloadJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: repeated string domains = 2;
	 */
	domains?: string[];

	/**
	 * @generated from field: bool force_authn = 3;
	 */
	forceAuthn?: boolean;

	/**
	 * @generated from field: repeated identities.v1.SSOGroup groups = 4;
	 */
	groups?: SSOGroupJson[];

	/**
	 * @generated from field: string idp_config_type = 5;
	 */
	idpConfigType?: string;

	/**
	 * @generated from field: string issuer_url = 6;
	 */
	issuerUrl?: string;

	/**
	 * @generated from field: string oidc_client_id = 7;
	 */
	oidcClientId?: string;

	/**
	 * @generated from field: string oidc_secret = 8;
	 */
	oidcSecret?: string;

	/**
	 * @generated from field: string public_certificate = 9;
	 */
	publicCertificate?: string;

	/**
	 * @generated from field: repeated string role_ids = 10;
	 */
	roleIds?: string[];

	/**
	 * @generated from field: bool skip_email_domain_validation = 11;
	 */
	skipEmailDomainValidation?: boolean;

	/**
	 * @generated from field: string sso_endpoint = 12;
	 */
	ssoEndpoint?: string;

	/**
	 * @generated from field: string tenant_id = 13;
	 */
	tenantId?: string;

	/**
	 * "saml" | "oidc"
	 *
	 * @generated from field: identities.v1.SSOType type = 14;
	 */
	type?: SSOTypeJson;

	/**
	 * @generated from field: optional bool enabled = 15;
	 */
	enabled?: boolean;
};

/**
 * Describes the message identities.v1.SSOConfigV2Payload.
 * Use `create(SSOConfigV2PayloadSchema)` to create a new message.
 */
export const SSOConfigV2PayloadSchema: GenMessage<SSOConfigV2Payload, { jsonType: SSOConfigV2PayloadJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 188);

/**
 * @generated from message identities.v1.SSOMetadataConfig
 */
export type SSOMetadataConfig = Message<"identities.v1.SSOMetadataConfig"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string metadata = 2;
	 */
	metadata: string;
};

/**
 * @generated from message identities.v1.SSOMetadataConfig
 */
export type SSOMetadataConfigJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string metadata = 2;
	 */
	metadata?: string;
};

/**
 * Describes the message identities.v1.SSOMetadataConfig.
 * Use `create(SSOMetadataConfigSchema)` to create a new message.
 */
export const SSOMetadataConfigSchema: GenMessage<SSOMetadataConfig, { jsonType: SSOMetadataConfigJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 189);

/**
 * @generated from message identities.v1.CreateSSOConfigurationRequest
 */
export type CreateSSOConfigurationRequest = Message<"identities.v1.CreateSSOConfigurationRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: identities.v1.SSOConfigV2Payload config = 4;
	 */
	config?: SSOConfigV2Payload | undefined;

	/**
	 * @generated from field: optional string metadata = 5;
	 */
	metadata?: string | undefined;

	/**
	 * Deprecated: use Config and Metadata
	 *
	 * @generated from field: optional identities.v1.SSOApiConfig api_config = 2 [deprecated = true];
	 * @deprecated
	 */
	apiConfig?: SSOApiConfig | undefined;

	/**
	 * @generated from field: optional identities.v1.SSOMetadataConfig metadata_config = 3 [deprecated = true];
	 * @deprecated
	 */
	metadataConfig?: SSOMetadataConfig | undefined;
};

/**
 * @generated from message identities.v1.CreateSSOConfigurationRequest
 */
export type CreateSSOConfigurationRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: identities.v1.SSOConfigV2Payload config = 4;
	 */
	config?: SSOConfigV2PayloadJson;

	/**
	 * @generated from field: optional string metadata = 5;
	 */
	metadata?: string;

	/**
	 * Deprecated: use Config and Metadata
	 *
	 * @generated from field: optional identities.v1.SSOApiConfig api_config = 2 [deprecated = true];
	 * @deprecated
	 */
	apiConfig?: SSOApiConfigJson;

	/**
	 * @generated from field: optional identities.v1.SSOMetadataConfig metadata_config = 3 [deprecated = true];
	 * @deprecated
	 */
	metadataConfig?: SSOMetadataConfigJson;
};

/**
 * Describes the message identities.v1.CreateSSOConfigurationRequest.
 * Use `create(CreateSSOConfigurationRequestSchema)` to create a new message.
 */
export const CreateSSOConfigurationRequestSchema: GenMessage<CreateSSOConfigurationRequest, { jsonType: CreateSSOConfigurationRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 190);

/**
 * @generated from message identities.v1.CreateSSOConfigurationResponse
 */
export type CreateSSOConfigurationResponse = Message<"identities.v1.CreateSSOConfigurationResponse"> & {
	/**
	 * @generated from field: identities.v1.SsoConfiguration item = 1;
	 */
	item?: SsoConfiguration | undefined;
};

/**
 * @generated from message identities.v1.CreateSSOConfigurationResponse
 */
export type CreateSSOConfigurationResponseJson = {
	/**
	 * @generated from field: identities.v1.SsoConfiguration item = 1;
	 */
	item?: SsoConfigurationJson;
};

/**
 * Describes the message identities.v1.CreateSSOConfigurationResponse.
 * Use `create(CreateSSOConfigurationResponseSchema)` to create a new message.
 */
export const CreateSSOConfigurationResponseSchema: GenMessage<CreateSSOConfigurationResponse, { jsonType: CreateSSOConfigurationResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 191);

/**
 * @generated from message identities.v1.SSODomain
 */
export type SSODomain = Message<"identities.v1.SSODomain"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string configuration_id = 2;
	 */
	configurationId: string;

	/**
	 * @generated from field: string domain = 3;
	 */
	domain: string;

	/**
	 * @generated from field: bool validated = 4;
	 */
	validated: boolean;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 5;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 6;
	 */
	updatedAt?: Timestamp | undefined;
};

/**
 * @generated from message identities.v1.SSODomain
 */
export type SSODomainJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string configuration_id = 2;
	 */
	configurationId?: string;

	/**
	 * @generated from field: string domain = 3;
	 */
	domain?: string;

	/**
	 * @generated from field: bool validated = 4;
	 */
	validated?: boolean;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 5;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 6;
	 */
	updatedAt?: TimestampJson;
};

/**
 * Describes the message identities.v1.SSODomain.
 * Use `create(SSODomainSchema)` to create a new message.
 */
export const SSODomainSchema: GenMessage<SSODomain, { jsonType: SSODomainJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 192);

/**
 * @generated from message identities.v1.SSOGroup
 */
export type SSOGroup = Message<"identities.v1.SSOGroup"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string group = 2;
	 */
	group: string;

	/**
	 * @generated from field: bool enabled = 3;
	 */
	enabled: boolean;

	/**
	 * @generated from field: repeated string role_ids = 4;
	 */
	roleIds: string[];

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 5;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 6;
	 */
	updatedAt?: Timestamp | undefined;
};

/**
 * @generated from message identities.v1.SSOGroup
 */
export type SSOGroupJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string group = 2;
	 */
	group?: string;

	/**
	 * @generated from field: bool enabled = 3;
	 */
	enabled?: boolean;

	/**
	 * @generated from field: repeated string role_ids = 4;
	 */
	roleIds?: string[];

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 5;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 6;
	 */
	updatedAt?: TimestampJson;
};

/**
 * Describes the message identities.v1.SSOGroup.
 * Use `create(SSOGroupSchema)` to create a new message.
 */
export const SSOGroupSchema: GenMessage<SSOGroup, { jsonType: SSOGroupJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 193);

/**
 * @generated from message identities.v1.CreateSSOGroupRequest
 */
export type CreateSSOGroupRequest = Message<"identities.v1.CreateSSOGroupRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name: string;

	/**
	 * @generated from field: string description = 3;
	 */
	description: string;

	/**
	 * @generated from field: repeated string roles = 4;
	 */
	roles: string[];

	/**
	 * @generated from field: string configuration_id = 5;
	 */
	configurationId: string;
};

/**
 * @generated from message identities.v1.CreateSSOGroupRequest
 */
export type CreateSSOGroupRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name?: string;

	/**
	 * @generated from field: string description = 3;
	 */
	description?: string;

	/**
	 * @generated from field: repeated string roles = 4;
	 */
	roles?: string[];

	/**
	 * @generated from field: string configuration_id = 5;
	 */
	configurationId?: string;
};

/**
 * Describes the message identities.v1.CreateSSOGroupRequest.
 * Use `create(CreateSSOGroupRequestSchema)` to create a new message.
 */
export const CreateSSOGroupRequestSchema: GenMessage<CreateSSOGroupRequest, { jsonType: CreateSSOGroupRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 194);

/**
 * @generated from message identities.v1.CreateSSOGroupResponse
 */
export type CreateSSOGroupResponse = Message<"identities.v1.CreateSSOGroupResponse"> & {
	/**
	 * @generated from field: identities.v1.SSOGroup item = 1;
	 */
	item?: SSOGroup | undefined;
};

/**
 * @generated from message identities.v1.CreateSSOGroupResponse
 */
export type CreateSSOGroupResponseJson = {
	/**
	 * @generated from field: identities.v1.SSOGroup item = 1;
	 */
	item?: SSOGroupJson;
};

/**
 * Describes the message identities.v1.CreateSSOGroupResponse.
 * Use `create(CreateSSOGroupResponseSchema)` to create a new message.
 */
export const CreateSSOGroupResponseSchema: GenMessage<CreateSSOGroupResponse, { jsonType: CreateSSOGroupResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 195);

/**
 * @generated from message identities.v1.SetSSODefaultRoleRequest
 */
export type SetSSODefaultRoleRequest = Message<"identities.v1.SetSSODefaultRoleRequest"> & {
	/**
	 * @generated from field: string configuration_id = 1;
	 */
	configurationId: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;

	/**
	 * @generated from field: string role_id = 3;
	 */
	roleId: string;
};

/**
 * @generated from message identities.v1.SetSSODefaultRoleRequest
 */
export type SetSSODefaultRoleRequestJson = {
	/**
	 * @generated from field: string configuration_id = 1;
	 */
	configurationId?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;

	/**
	 * @generated from field: string role_id = 3;
	 */
	roleId?: string;
};

/**
 * Describes the message identities.v1.SetSSODefaultRoleRequest.
 * Use `create(SetSSODefaultRoleRequestSchema)` to create a new message.
 */
export const SetSSODefaultRoleRequestSchema: GenMessage<SetSSODefaultRoleRequest, { jsonType: SetSSODefaultRoleRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 196);

/**
 * @generated from message identities.v1.SetSSODefaultRoleResponse
 */
export type SetSSODefaultRoleResponse = Message<"identities.v1.SetSSODefaultRoleResponse"> & {
	/**
	 * @generated from field: identities.v1.SsoConfiguration item = 1;
	 */
	item?: SsoConfiguration | undefined;
};

/**
 * @generated from message identities.v1.SetSSODefaultRoleResponse
 */
export type SetSSODefaultRoleResponseJson = {
	/**
	 * @generated from field: identities.v1.SsoConfiguration item = 1;
	 */
	item?: SsoConfigurationJson;
};

/**
 * Describes the message identities.v1.SetSSODefaultRoleResponse.
 * Use `create(SetSSODefaultRoleResponseSchema)` to create a new message.
 */
export const SetSSODefaultRoleResponseSchema: GenMessage<SetSSODefaultRoleResponse, { jsonType: SetSSODefaultRoleResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 197);

/**
 * @generated from message identities.v1.CreateSSODomainRequest
 */
export type CreateSSODomainRequest = Message<"identities.v1.CreateSSODomainRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string configuration_id = 2;
	 */
	configurationId: string;

	/**
	 * @generated from field: string domain = 3;
	 */
	domain: string;
};

/**
 * @generated from message identities.v1.CreateSSODomainRequest
 */
export type CreateSSODomainRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string configuration_id = 2;
	 */
	configurationId?: string;

	/**
	 * @generated from field: string domain = 3;
	 */
	domain?: string;
};

/**
 * Describes the message identities.v1.CreateSSODomainRequest.
 * Use `create(CreateSSODomainRequestSchema)` to create a new message.
 */
export const CreateSSODomainRequestSchema: GenMessage<CreateSSODomainRequest, { jsonType: CreateSSODomainRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 198);

/**
 * @generated from message identities.v1.CreateSSODomainResponse
 */
export type CreateSSODomainResponse = Message<"identities.v1.CreateSSODomainResponse"> & {
	/**
	 * @generated from field: identities.v1.SSODomain item = 1;
	 */
	item?: SSODomain | undefined;
};

/**
 * @generated from message identities.v1.CreateSSODomainResponse
 */
export type CreateSSODomainResponseJson = {
	/**
	 * @generated from field: identities.v1.SSODomain item = 1;
	 */
	item?: SSODomainJson;
};

/**
 * Describes the message identities.v1.CreateSSODomainResponse.
 * Use `create(CreateSSODomainResponseSchema)` to create a new message.
 */
export const CreateSSODomainResponseSchema: GenMessage<CreateSSODomainResponse, { jsonType: CreateSSODomainResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 199);

/**
 * @generated from message identities.v1.DeleteSSOGroupRequest
 */
export type DeleteSSOGroupRequest = Message<"identities.v1.DeleteSSOGroupRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string group_id = 2;
	 */
	groupId: string;

	/**
	 * @generated from field: string configuration_id = 3;
	 */
	configurationId: string;
};

/**
 * @generated from message identities.v1.DeleteSSOGroupRequest
 */
export type DeleteSSOGroupRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string group_id = 2;
	 */
	groupId?: string;

	/**
	 * @generated from field: string configuration_id = 3;
	 */
	configurationId?: string;
};

/**
 * Describes the message identities.v1.DeleteSSOGroupRequest.
 * Use `create(DeleteSSOGroupRequestSchema)` to create a new message.
 */
export const DeleteSSOGroupRequestSchema: GenMessage<DeleteSSOGroupRequest, { jsonType: DeleteSSOGroupRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 200);

/**
 * @generated from message identities.v1.DeleteSSOGroupResponse
 */
export type DeleteSSOGroupResponse = Message<"identities.v1.DeleteSSOGroupResponse"> & {};

/**
 * @generated from message identities.v1.DeleteSSOGroupResponse
 */
export type DeleteSSOGroupResponseJson = {};

/**
 * Describes the message identities.v1.DeleteSSOGroupResponse.
 * Use `create(DeleteSSOGroupResponseSchema)` to create a new message.
 */
export const DeleteSSOGroupResponseSchema: GenMessage<DeleteSSOGroupResponse, { jsonType: DeleteSSOGroupResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 201);

/**
 * @generated from message identities.v1.DeleteSSODomainRequest
 */
export type DeleteSSODomainRequest = Message<"identities.v1.DeleteSSODomainRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string domain_id = 2;
	 */
	domainId: string;

	/**
	 * @generated from field: string configuration_id = 3;
	 */
	configurationId: string;
};

/**
 * @generated from message identities.v1.DeleteSSODomainRequest
 */
export type DeleteSSODomainRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string domain_id = 2;
	 */
	domainId?: string;

	/**
	 * @generated from field: string configuration_id = 3;
	 */
	configurationId?: string;
};

/**
 * Describes the message identities.v1.DeleteSSODomainRequest.
 * Use `create(DeleteSSODomainRequestSchema)` to create a new message.
 */
export const DeleteSSODomainRequestSchema: GenMessage<DeleteSSODomainRequest, { jsonType: DeleteSSODomainRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 202);

/**
 * @generated from message identities.v1.DeleteSSODomainResponse
 */
export type DeleteSSODomainResponse = Message<"identities.v1.DeleteSSODomainResponse"> & {};

/**
 * @generated from message identities.v1.DeleteSSODomainResponse
 */
export type DeleteSSODomainResponseJson = {};

/**
 * Describes the message identities.v1.DeleteSSODomainResponse.
 * Use `create(DeleteSSODomainResponseSchema)` to create a new message.
 */
export const DeleteSSODomainResponseSchema: GenMessage<DeleteSSODomainResponse, { jsonType: DeleteSSODomainResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 203);

/**
 * @generated from message identities.v1.DeleteSSOConfigurationRequest
 */
export type DeleteSSOConfigurationRequest = Message<"identities.v1.DeleteSSOConfigurationRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string configuration_id = 2;
	 */
	configurationId: string;
};

/**
 * @generated from message identities.v1.DeleteSSOConfigurationRequest
 */
export type DeleteSSOConfigurationRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string configuration_id = 2;
	 */
	configurationId?: string;
};

/**
 * Describes the message identities.v1.DeleteSSOConfigurationRequest.
 * Use `create(DeleteSSOConfigurationRequestSchema)` to create a new message.
 */
export const DeleteSSOConfigurationRequestSchema: GenMessage<DeleteSSOConfigurationRequest, { jsonType: DeleteSSOConfigurationRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 204);

/**
 * @generated from message identities.v1.DeleteSSOConfigurationResponse
 */
export type DeleteSSOConfigurationResponse = Message<"identities.v1.DeleteSSOConfigurationResponse"> & {};

/**
 * @generated from message identities.v1.DeleteSSOConfigurationResponse
 */
export type DeleteSSOConfigurationResponseJson = {};

/**
 * Describes the message identities.v1.DeleteSSOConfigurationResponse.
 * Use `create(DeleteSSOConfigurationResponseSchema)` to create a new message.
 */
export const DeleteSSOConfigurationResponseSchema: GenMessage<DeleteSSOConfigurationResponse, { jsonType: DeleteSSOConfigurationResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 205);

/**
 * @generated from message identities.v1.UpdateSSOConfigurationRequest
 */
export type UpdateSSOConfigurationRequest = Message<"identities.v1.UpdateSSOConfigurationRequest"> & {
	/**
	 * @generated from field: string id = 1 [deprecated = true];
	 * @deprecated
	 */
	id: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;

	/**
	 * @generated from field: bool enabled = 3 [deprecated = true];
	 * @deprecated
	 */
	enabled: boolean;

	/**
	 * @generated from field: string sso_endpoint = 4 [deprecated = true];
	 * @deprecated
	 */
	ssoEndpoint: string;

	/**
	 * @generated from field: string public_certificate = 5 [deprecated = true];
	 * @deprecated
	 */
	publicCertificate: string;

	/**
	 * @generated from field: bool sign_request = 6 [deprecated = true];
	 * @deprecated
	 */
	signRequest: boolean;

	/**
	 * @generated from field: string acs_url = 7 [deprecated = true];
	 * @deprecated
	 */
	acsUrl: string;

	/**
	 * @generated from field: string sp_entity_id = 8 [deprecated = true];
	 * @deprecated
	 */
	spEntityId: string;

	/**
	 * @generated from field: string oidc_client_id = 9 [deprecated = true];
	 * @deprecated
	 */
	oidcClientId: string;

	/**
	 * @generated from field: string oidc_secret = 10 [deprecated = true];
	 * @deprecated
	 */
	oidcSecret: string;

	/**
	 * @generated from field: identities.v1.SSOType type = 11 [deprecated = true];
	 * @deprecated
	 */
	type: SSOType;

	/**
	 * @generated from field: identities.v1.SSOConfigV2Payload config = 12;
	 */
	config?: SSOConfigV2Payload | undefined;

	/**
	 * @generated from field: optional string metadata = 13;
	 */
	metadata?: string | undefined;
};

/**
 * @generated from message identities.v1.UpdateSSOConfigurationRequest
 */
export type UpdateSSOConfigurationRequestJson = {
	/**
	 * @generated from field: string id = 1 [deprecated = true];
	 * @deprecated
	 */
	id?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;

	/**
	 * @generated from field: bool enabled = 3 [deprecated = true];
	 * @deprecated
	 */
	enabled?: boolean;

	/**
	 * @generated from field: string sso_endpoint = 4 [deprecated = true];
	 * @deprecated
	 */
	ssoEndpoint?: string;

	/**
	 * @generated from field: string public_certificate = 5 [deprecated = true];
	 * @deprecated
	 */
	publicCertificate?: string;

	/**
	 * @generated from field: bool sign_request = 6 [deprecated = true];
	 * @deprecated
	 */
	signRequest?: boolean;

	/**
	 * @generated from field: string acs_url = 7 [deprecated = true];
	 * @deprecated
	 */
	acsUrl?: string;

	/**
	 * @generated from field: string sp_entity_id = 8 [deprecated = true];
	 * @deprecated
	 */
	spEntityId?: string;

	/**
	 * @generated from field: string oidc_client_id = 9 [deprecated = true];
	 * @deprecated
	 */
	oidcClientId?: string;

	/**
	 * @generated from field: string oidc_secret = 10 [deprecated = true];
	 * @deprecated
	 */
	oidcSecret?: string;

	/**
	 * @generated from field: identities.v1.SSOType type = 11 [deprecated = true];
	 * @deprecated
	 */
	type?: SSOTypeJson;

	/**
	 * @generated from field: identities.v1.SSOConfigV2Payload config = 12;
	 */
	config?: SSOConfigV2PayloadJson;

	/**
	 * @generated from field: optional string metadata = 13;
	 */
	metadata?: string;
};

/**
 * Describes the message identities.v1.UpdateSSOConfigurationRequest.
 * Use `create(UpdateSSOConfigurationRequestSchema)` to create a new message.
 */
export const UpdateSSOConfigurationRequestSchema: GenMessage<UpdateSSOConfigurationRequest, { jsonType: UpdateSSOConfigurationRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 206);

/**
 * @generated from message identities.v1.UpdateSSOConfigurationResponse
 */
export type UpdateSSOConfigurationResponse = Message<"identities.v1.UpdateSSOConfigurationResponse"> & {
	/**
	 * @generated from field: identities.v1.SsoConfiguration item = 1;
	 */
	item?: SsoConfiguration | undefined;
};

/**
 * @generated from message identities.v1.UpdateSSOConfigurationResponse
 */
export type UpdateSSOConfigurationResponseJson = {
	/**
	 * @generated from field: identities.v1.SsoConfiguration item = 1;
	 */
	item?: SsoConfigurationJson;
};

/**
 * Describes the message identities.v1.UpdateSSOConfigurationResponse.
 * Use `create(UpdateSSOConfigurationResponseSchema)` to create a new message.
 */
export const UpdateSSOConfigurationResponseSchema: GenMessage<UpdateSSOConfigurationResponse, { jsonType: UpdateSSOConfigurationResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 207);

/**
 * @generated from message identities.v1.UpdateSSOGroupRequest
 */
export type UpdateSSOGroupRequest = Message<"identities.v1.UpdateSSOGroupRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string group_id = 2;
	 */
	groupId: string;

	/**
	 * @generated from field: string configuration_id = 3;
	 */
	configurationId: string;

	/**
	 * @generated from field: string group_name = 4;
	 */
	groupName: string;

	/**
	 * @generated from field: repeated string role_ids = 5;
	 */
	roleIds: string[];
};

/**
 * @generated from message identities.v1.UpdateSSOGroupRequest
 */
export type UpdateSSOGroupRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string group_id = 2;
	 */
	groupId?: string;

	/**
	 * @generated from field: string configuration_id = 3;
	 */
	configurationId?: string;

	/**
	 * @generated from field: string group_name = 4;
	 */
	groupName?: string;

	/**
	 * @generated from field: repeated string role_ids = 5;
	 */
	roleIds?: string[];
};

/**
 * Describes the message identities.v1.UpdateSSOGroupRequest.
 * Use `create(UpdateSSOGroupRequestSchema)` to create a new message.
 */
export const UpdateSSOGroupRequestSchema: GenMessage<UpdateSSOGroupRequest, { jsonType: UpdateSSOGroupRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 208);

/**
 * @generated from message identities.v1.UpdateSSOGroupResponse
 */
export type UpdateSSOGroupResponse = Message<"identities.v1.UpdateSSOGroupResponse"> & {
	/**
	 * @generated from field: identities.v1.SSOGroup item = 1;
	 */
	item?: SSOGroup | undefined;
};

/**
 * @generated from message identities.v1.UpdateSSOGroupResponse
 */
export type UpdateSSOGroupResponseJson = {
	/**
	 * @generated from field: identities.v1.SSOGroup item = 1;
	 */
	item?: SSOGroupJson;
};

/**
 * Describes the message identities.v1.UpdateSSOGroupResponse.
 * Use `create(UpdateSSOGroupResponseSchema)` to create a new message.
 */
export const UpdateSSOGroupResponseSchema: GenMessage<UpdateSSOGroupResponse, { jsonType: UpdateSSOGroupResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 209);

/**
 * @generated from message identities.v1.ValidateSSODomainRequest
 */
export type ValidateSSODomainRequest = Message<"identities.v1.ValidateSSODomainRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string domain_id = 2;
	 */
	domainId: string;

	/**
	 * @generated from field: string configuration_id = 3;
	 */
	configurationId: string;
};

/**
 * @generated from message identities.v1.ValidateSSODomainRequest
 */
export type ValidateSSODomainRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string domain_id = 2;
	 */
	domainId?: string;

	/**
	 * @generated from field: string configuration_id = 3;
	 */
	configurationId?: string;
};

/**
 * Describes the message identities.v1.ValidateSSODomainRequest.
 * Use `create(ValidateSSODomainRequestSchema)` to create a new message.
 */
export const ValidateSSODomainRequestSchema: GenMessage<ValidateSSODomainRequest, { jsonType: ValidateSSODomainRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 210);

/**
 * @generated from message identities.v1.ValidateSSODomainResponse
 */
export type ValidateSSODomainResponse = Message<"identities.v1.ValidateSSODomainResponse"> & {
	/**
	 * @generated from field: identities.v1.SSODomain item = 1;
	 */
	item?: SSODomain | undefined;
};

/**
 * @generated from message identities.v1.ValidateSSODomainResponse
 */
export type ValidateSSODomainResponseJson = {
	/**
	 * @generated from field: identities.v1.SSODomain item = 1;
	 */
	item?: SSODomainJson;
};

/**
 * Describes the message identities.v1.ValidateSSODomainResponse.
 * Use `create(ValidateSSODomainResponseSchema)` to create a new message.
 */
export const ValidateSSODomainResponseSchema: GenMessage<ValidateSSODomainResponse, { jsonType: ValidateSSODomainResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 211);

/**
 * @generated from message identities.v1.GetSSOConfigurationRequest
 */
export type GetSSOConfigurationRequest = Message<"identities.v1.GetSSOConfigurationRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string configuration_id = 2;
	 */
	configurationId: string;
};

/**
 * @generated from message identities.v1.GetSSOConfigurationRequest
 */
export type GetSSOConfigurationRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string configuration_id = 2;
	 */
	configurationId?: string;
};

/**
 * Describes the message identities.v1.GetSSOConfigurationRequest.
 * Use `create(GetSSOConfigurationRequestSchema)` to create a new message.
 */
export const GetSSOConfigurationRequestSchema: GenMessage<GetSSOConfigurationRequest, { jsonType: GetSSOConfigurationRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 212);

/**
 * @generated from message identities.v1.GetSSOConfigurationResponse
 */
export type GetSSOConfigurationResponse = Message<"identities.v1.GetSSOConfigurationResponse"> & {
	/**
	 * @generated from field: identities.v1.SsoConfiguration item = 1;
	 */
	item?: SsoConfiguration | undefined;
};

/**
 * @generated from message identities.v1.GetSSOConfigurationResponse
 */
export type GetSSOConfigurationResponseJson = {
	/**
	 * @generated from field: identities.v1.SsoConfiguration item = 1;
	 */
	item?: SsoConfigurationJson;
};

/**
 * Describes the message identities.v1.GetSSOConfigurationResponse.
 * Use `create(GetSSOConfigurationResponseSchema)` to create a new message.
 */
export const GetSSOConfigurationResponseSchema: GenMessage<GetSSOConfigurationResponse, { jsonType: GetSSOConfigurationResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 213);

/**
 * @generated from message identities.v1.CreateActivationLinkRequest
 */
export type CreateActivationLinkRequest = Message<"identities.v1.CreateActivationLinkRequest"> & {
	/**
	 * @generated from field: string user_id = 1;
	 */
	userId: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;
};

/**
 * @generated from message identities.v1.CreateActivationLinkRequest
 */
export type CreateActivationLinkRequestJson = {
	/**
	 * @generated from field: string user_id = 1;
	 */
	userId?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;
};

/**
 * Describes the message identities.v1.CreateActivationLinkRequest.
 * Use `create(CreateActivationLinkRequestSchema)` to create a new message.
 */
export const CreateActivationLinkRequestSchema: GenMessage<CreateActivationLinkRequest, { jsonType: CreateActivationLinkRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 214);

/**
 * @generated from message identities.v1.CreateActivationLinkResponse
 */
export type CreateActivationLinkResponse = Message<"identities.v1.CreateActivationLinkResponse"> & {
	/**
	 * @generated from field: string link = 1;
	 */
	link: string;

	/**
	 * @generated from field: string token = 2;
	 */
	token: string;

	/**
	 * @generated from field: string user_id = 3;
	 */
	userId: string;
};

/**
 * @generated from message identities.v1.CreateActivationLinkResponse
 */
export type CreateActivationLinkResponseJson = {
	/**
	 * @generated from field: string link = 1;
	 */
	link?: string;

	/**
	 * @generated from field: string token = 2;
	 */
	token?: string;

	/**
	 * @generated from field: string user_id = 3;
	 */
	userId?: string;
};

/**
 * Describes the message identities.v1.CreateActivationLinkResponse.
 * Use `create(CreateActivationLinkResponseSchema)` to create a new message.
 */
export const CreateActivationLinkResponseSchema: GenMessage<CreateActivationLinkResponse, { jsonType: CreateActivationLinkResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 215);

/**
 * @generated from message identities.v1.GetAllowedRolesRequest
 */
export type GetAllowedRolesRequest = Message<"identities.v1.GetAllowedRolesRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string user_id = 2;
	 */
	userId: string;
};

/**
 * @generated from message identities.v1.GetAllowedRolesRequest
 */
export type GetAllowedRolesRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string user_id = 2;
	 */
	userId?: string;
};

/**
 * Describes the message identities.v1.GetAllowedRolesRequest.
 * Use `create(GetAllowedRolesRequestSchema)` to create a new message.
 */
export const GetAllowedRolesRequestSchema: GenMessage<GetAllowedRolesRequest, { jsonType: GetAllowedRolesRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 216);

/**
 * @generated from message identities.v1.GetAllowedRolesResponse
 */
export type GetAllowedRolesResponse = Message<"identities.v1.GetAllowedRolesResponse"> & {
	/**
	 * @generated from field: repeated identities.v1.Role items = 1;
	 */
	items: Role[];
};

/**
 * @generated from message identities.v1.GetAllowedRolesResponse
 */
export type GetAllowedRolesResponseJson = {
	/**
	 * @generated from field: repeated identities.v1.Role items = 1;
	 */
	items?: RoleJson[];
};

/**
 * Describes the message identities.v1.GetAllowedRolesResponse.
 * Use `create(GetAllowedRolesResponseSchema)` to create a new message.
 */
export const GetAllowedRolesResponseSchema: GenMessage<GetAllowedRolesResponse, { jsonType: GetAllowedRolesResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 217);

/**
 * @generated from message identities.v1.CreateResendInvitationRequest
 */
export type CreateResendInvitationRequest = Message<"identities.v1.CreateResendInvitationRequest"> & {
	/**
	 * @generated from field: string email = 1;
	 */
	email: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;
};

/**
 * @generated from message identities.v1.CreateResendInvitationRequest
 */
export type CreateResendInvitationRequestJson = {
	/**
	 * @generated from field: string email = 1;
	 */
	email?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;
};

/**
 * Describes the message identities.v1.CreateResendInvitationRequest.
 * Use `create(CreateResendInvitationRequestSchema)` to create a new message.
 */
export const CreateResendInvitationRequestSchema: GenMessage<CreateResendInvitationRequest, { jsonType: CreateResendInvitationRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 218);

/**
 * @generated from message identities.v1.CreateResendInvitationResponse
 */
export type CreateResendInvitationResponse = Message<"identities.v1.CreateResendInvitationResponse"> & {};

/**
 * @generated from message identities.v1.CreateResendInvitationResponse
 */
export type CreateResendInvitationResponseJson = {};

/**
 * Describes the message identities.v1.CreateResendInvitationResponse.
 * Use `create(CreateResendInvitationResponseSchema)` to create a new message.
 */
export const CreateResendInvitationResponseSchema: GenMessage<CreateResendInvitationResponse, { jsonType: CreateResendInvitationResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 219);

/**
 * @generated from message identities.v1.IndustryVertical
 */
export type IndustryVertical = Message<"identities.v1.IndustryVertical"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string canonical_id = 2;
	 */
	canonicalId: string;

	/**
	 * @generated from field: string category_name = 3;
	 */
	categoryName: string;

	/**
	 * @generated from field: string description = 4;
	 */
	description: string;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 5;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 6;
	 */
	updatedAt?: Timestamp | undefined;
};

/**
 * @generated from message identities.v1.IndustryVertical
 */
export type IndustryVerticalJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string canonical_id = 2;
	 */
	canonicalId?: string;

	/**
	 * @generated from field: string category_name = 3;
	 */
	categoryName?: string;

	/**
	 * @generated from field: string description = 4;
	 */
	description?: string;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 5;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 6;
	 */
	updatedAt?: TimestampJson;
};

/**
 * Describes the message identities.v1.IndustryVertical.
 * Use `create(IndustryVerticalSchema)` to create a new message.
 */
export const IndustryVerticalSchema: GenMessage<IndustryVertical, { jsonType: IndustryVerticalJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 220);

/**
 * @generated from message identities.v1.VerticalFilter
 */
export type VerticalFilter = Message<"identities.v1.VerticalFilter"> & {
	/**
	 * @generated from field: optional string category_name = 1;
	 */
	categoryName?: string | undefined;
};

/**
 * @generated from message identities.v1.VerticalFilter
 */
export type VerticalFilterJson = {
	/**
	 * @generated from field: optional string category_name = 1;
	 */
	categoryName?: string;
};

/**
 * Describes the message identities.v1.VerticalFilter.
 * Use `create(VerticalFilterSchema)` to create a new message.
 */
export const VerticalFilterSchema: GenMessage<VerticalFilter, { jsonType: VerticalFilterJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 221);

/**
 * @generated from message identities.v1.GetIndustryVerticalRequest
 */
export type GetIndustryVerticalRequest = Message<"identities.v1.GetIndustryVerticalRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId: string;
};

/**
 * @generated from message identities.v1.GetIndustryVerticalRequest
 */
export type GetIndustryVerticalRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId?: string;
};

/**
 * Describes the message identities.v1.GetIndustryVerticalRequest.
 * Use `create(GetIndustryVerticalRequestSchema)` to create a new message.
 */
export const GetIndustryVerticalRequestSchema: GenMessage<GetIndustryVerticalRequest, { jsonType: GetIndustryVerticalRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 222);

/**
 * @generated from message identities.v1.GetIndustryVerticalResponse
 */
export type GetIndustryVerticalResponse = Message<"identities.v1.GetIndustryVerticalResponse"> & {
	/**
	 * @generated from field: identities.v1.IndustryVertical item = 1;
	 */
	item?: IndustryVertical | undefined;
};

/**
 * @generated from message identities.v1.GetIndustryVerticalResponse
 */
export type GetIndustryVerticalResponseJson = {
	/**
	 * @generated from field: identities.v1.IndustryVertical item = 1;
	 */
	item?: IndustryVerticalJson;
};

/**
 * Describes the message identities.v1.GetIndustryVerticalResponse.
 * Use `create(GetIndustryVerticalResponseSchema)` to create a new message.
 */
export const GetIndustryVerticalResponseSchema: GenMessage<GetIndustryVerticalResponse, { jsonType: GetIndustryVerticalResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 223);

/**
 * @generated from message identities.v1.ListIndustryVerticalsRequest
 */
export type ListIndustryVerticalsRequest = Message<"identities.v1.ListIndustryVerticalsRequest"> & {
	/**
	 * @generated from field: identities.v1.VerticalFilter filter = 1;
	 */
	filter?: VerticalFilter | undefined;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId: string;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 4;
	 */
	paginate?: PaginationArguments | undefined;
};

/**
 * @generated from message identities.v1.ListIndustryVerticalsRequest
 */
export type ListIndustryVerticalsRequestJson = {
	/**
	 * @generated from field: identities.v1.VerticalFilter filter = 1;
	 */
	filter?: VerticalFilterJson;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 4;
	 */
	paginate?: PaginationArgumentsJson;
};

/**
 * Describes the message identities.v1.ListIndustryVerticalsRequest.
 * Use `create(ListIndustryVerticalsRequestSchema)` to create a new message.
 */
export const ListIndustryVerticalsRequestSchema: GenMessage<ListIndustryVerticalsRequest, { jsonType: ListIndustryVerticalsRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 224);

/**
 * @generated from message identities.v1.ListIndustryVerticalsResponse
 */
export type ListIndustryVerticalsResponse = Message<"identities.v1.ListIndustryVerticalsResponse"> & {
	/**
	 * @generated from field: repeated identities.v1.IndustryVertical items = 1;
	 */
	items: IndustryVertical[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message identities.v1.ListIndustryVerticalsResponse
 */
export type ListIndustryVerticalsResponseJson = {
	/**
	 * @generated from field: repeated identities.v1.IndustryVertical items = 1;
	 */
	items?: IndustryVerticalJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message identities.v1.ListIndustryVerticalsResponse.
 * Use `create(ListIndustryVerticalsResponseSchema)` to create a new message.
 */
export const ListIndustryVerticalsResponseSchema: GenMessage<ListIndustryVerticalsResponse, { jsonType: ListIndustryVerticalsResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 225);

/**
 * @generated from message identities.v1.CorpMember
 */
export type CorpMember = Message<"identities.v1.CorpMember"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string user_id = 2;
	 */
	userId: string;

	/**
	 * @generated from field: string corp_id = 3;
	 */
	corpId: string;

	/**
	 * @generated from field: string email = 4;
	 */
	email: string;

	/**
	 * @generated from field: string name = 5;
	 */
	name: string;

	/**
	 * @generated from field: string role_id = 6;
	 */
	roleId: string;

	/**
	 * @generated from field: identities.v1.User user = 7;
	 */
	user?: User | undefined;

	/**
	 * @generated from field: identities.v1.Role role = 8;
	 */
	role?: Role | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 9;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 10;
	 */
	updatedAt?: Timestamp | undefined;

	/**
	 * @generated from field: optional google.protobuf.Timestamp deleted_at = 11;
	 */
	deletedAt?: Timestamp | undefined;
};

/**
 * @generated from message identities.v1.CorpMember
 */
export type CorpMemberJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string user_id = 2;
	 */
	userId?: string;

	/**
	 * @generated from field: string corp_id = 3;
	 */
	corpId?: string;

	/**
	 * @generated from field: string email = 4;
	 */
	email?: string;

	/**
	 * @generated from field: string name = 5;
	 */
	name?: string;

	/**
	 * @generated from field: string role_id = 6;
	 */
	roleId?: string;

	/**
	 * @generated from field: identities.v1.User user = 7;
	 */
	user?: UserJson;

	/**
	 * @generated from field: identities.v1.Role role = 8;
	 */
	role?: RoleJson;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 9;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 10;
	 */
	updatedAt?: TimestampJson;

	/**
	 * @generated from field: optional google.protobuf.Timestamp deleted_at = 11;
	 */
	deletedAt?: TimestampJson;
};

/**
 * Describes the message identities.v1.CorpMember.
 * Use `create(CorpMemberSchema)` to create a new message.
 */
export const CorpMemberSchema: GenMessage<CorpMember, { jsonType: CorpMemberJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 226);

/**
 * @generated from message identities.v1.Corp
 */
export type Corp = Message<"identities.v1.Corp"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name: string;

	/**
	 * @generated from field: string description = 3;
	 */
	description: string;

	/**
	 * @generated from field: string photo_url = 4;
	 */
	photoUrl: string;

	/**
	 * @generated from field: string owner = 5;
	 */
	owner: string;

	/**
	 * @generated from field: string zuora_id = 6;
	 */
	zuoraId: string;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 7;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 8;
	 */
	updatedAt?: Timestamp | undefined;

	/**
	 * @generated from field: optional google.protobuf.Timestamp deleted_at = 9;
	 */
	deletedAt?: Timestamp | undefined;

	/**
	 * @generated from field: repeated identities.v1.Org orgs = 10;
	 */
	orgs: Org[];

	/**
	 * @generated from field: repeated identities.v1.CorpMember members = 11;
	 */
	members: CorpMember[];
};

/**
 * @generated from message identities.v1.Corp
 */
export type CorpJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name?: string;

	/**
	 * @generated from field: string description = 3;
	 */
	description?: string;

	/**
	 * @generated from field: string photo_url = 4;
	 */
	photoUrl?: string;

	/**
	 * @generated from field: string owner = 5;
	 */
	owner?: string;

	/**
	 * @generated from field: string zuora_id = 6;
	 */
	zuoraId?: string;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 7;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 8;
	 */
	updatedAt?: TimestampJson;

	/**
	 * @generated from field: optional google.protobuf.Timestamp deleted_at = 9;
	 */
	deletedAt?: TimestampJson;

	/**
	 * @generated from field: repeated identities.v1.Org orgs = 10;
	 */
	orgs?: OrgJson[];

	/**
	 * @generated from field: repeated identities.v1.CorpMember members = 11;
	 */
	members?: CorpMemberJson[];
};

/**
 * Describes the message identities.v1.Corp.
 * Use `create(CorpSchema)` to create a new message.
 */
export const CorpSchema: GenMessage<Corp, { jsonType: CorpJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 227);

/**
 * @generated from message identities.v1.CorpUserFilter
 */
export type CorpUserFilter = Message<"identities.v1.CorpUserFilter"> & {
	/**
	 * @generated from field: optional string email = 1;
	 */
	email?: string | undefined;

	/**
	 * @generated from field: optional string name = 2;
	 */
	name?: string | undefined;
};

/**
 * @generated from message identities.v1.CorpUserFilter
 */
export type CorpUserFilterJson = {
	/**
	 * @generated from field: optional string email = 1;
	 */
	email?: string;

	/**
	 * @generated from field: optional string name = 2;
	 */
	name?: string;
};

/**
 * Describes the message identities.v1.CorpUserFilter.
 * Use `create(CorpUserFilterSchema)` to create a new message.
 */
export const CorpUserFilterSchema: GenMessage<CorpUserFilter, { jsonType: CorpUserFilterJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 228);

/**
 * @generated from message identities.v1.CreateCorpRequest
 */
export type CreateCorpRequest = Message<"identities.v1.CreateCorpRequest"> & {
	/**
	 * @generated from field: identities.v1.Corp corp = 1;
	 */
	corp?: Corp | undefined;
};

/**
 * @generated from message identities.v1.CreateCorpRequest
 */
export type CreateCorpRequestJson = {
	/**
	 * @generated from field: identities.v1.Corp corp = 1;
	 */
	corp?: CorpJson;
};

/**
 * Describes the message identities.v1.CreateCorpRequest.
 * Use `create(CreateCorpRequestSchema)` to create a new message.
 */
export const CreateCorpRequestSchema: GenMessage<CreateCorpRequest, { jsonType: CreateCorpRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 229);

/**
 * @generated from message identities.v1.CreateCorpResponse
 */
export type CreateCorpResponse = Message<"identities.v1.CreateCorpResponse"> & {
	/**
	 * @generated from field: identities.v1.Corp corp = 1;
	 */
	corp?: Corp | undefined;
};

/**
 * @generated from message identities.v1.CreateCorpResponse
 */
export type CreateCorpResponseJson = {
	/**
	 * @generated from field: identities.v1.Corp corp = 1;
	 */
	corp?: CorpJson;
};

/**
 * Describes the message identities.v1.CreateCorpResponse.
 * Use `create(CreateCorpResponseSchema)` to create a new message.
 */
export const CreateCorpResponseSchema: GenMessage<CreateCorpResponse, { jsonType: CreateCorpResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 230);

/**
 * @generated from message identities.v1.GetCorpRequest
 */
export type GetCorpRequest = Message<"identities.v1.GetCorpRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message identities.v1.GetCorpRequest
 */
export type GetCorpRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message identities.v1.GetCorpRequest.
 * Use `create(GetCorpRequestSchema)` to create a new message.
 */
export const GetCorpRequestSchema: GenMessage<GetCorpRequest, { jsonType: GetCorpRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 231);

/**
 * @generated from message identities.v1.GetCorpResponse
 */
export type GetCorpResponse = Message<"identities.v1.GetCorpResponse"> & {
	/**
	 * @generated from field: identities.v1.Corp corp = 1;
	 */
	corp?: Corp | undefined;
};

/**
 * @generated from message identities.v1.GetCorpResponse
 */
export type GetCorpResponseJson = {
	/**
	 * @generated from field: identities.v1.Corp corp = 1;
	 */
	corp?: CorpJson;
};

/**
 * Describes the message identities.v1.GetCorpResponse.
 * Use `create(GetCorpResponseSchema)` to create a new message.
 */
export const GetCorpResponseSchema: GenMessage<GetCorpResponse, { jsonType: GetCorpResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 232);

/**
 * @generated from message identities.v1.DeleteCorpRequest
 */
export type DeleteCorpRequest = Message<"identities.v1.DeleteCorpRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message identities.v1.DeleteCorpRequest
 */
export type DeleteCorpRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message identities.v1.DeleteCorpRequest.
 * Use `create(DeleteCorpRequestSchema)` to create a new message.
 */
export const DeleteCorpRequestSchema: GenMessage<DeleteCorpRequest, { jsonType: DeleteCorpRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 233);

/**
 * @generated from message identities.v1.DeleteCorpResponse
 */
export type DeleteCorpResponse = Message<"identities.v1.DeleteCorpResponse"> & {
	/**
	 * @generated from field: identities.v1.Corp corp = 1;
	 */
	corp?: Corp | undefined;
};

/**
 * @generated from message identities.v1.DeleteCorpResponse
 */
export type DeleteCorpResponseJson = {
	/**
	 * @generated from field: identities.v1.Corp corp = 1;
	 */
	corp?: CorpJson;
};

/**
 * Describes the message identities.v1.DeleteCorpResponse.
 * Use `create(DeleteCorpResponseSchema)` to create a new message.
 */
export const DeleteCorpResponseSchema: GenMessage<DeleteCorpResponse, { jsonType: DeleteCorpResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 234);

/**
 * @generated from message identities.v1.UpdateCorpRequest
 */
export type UpdateCorpRequest = Message<"identities.v1.UpdateCorpRequest"> & {
	/**
	 * @generated from field: identities.v1.Corp corp = 1;
	 */
	corp?: Corp | undefined;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMask | undefined;
};

/**
 * @generated from message identities.v1.UpdateCorpRequest
 */
export type UpdateCorpRequestJson = {
	/**
	 * @generated from field: identities.v1.Corp corp = 1;
	 */
	corp?: CorpJson;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMaskJson;
};

/**
 * Describes the message identities.v1.UpdateCorpRequest.
 * Use `create(UpdateCorpRequestSchema)` to create a new message.
 */
export const UpdateCorpRequestSchema: GenMessage<UpdateCorpRequest, { jsonType: UpdateCorpRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 235);

/**
 * @generated from message identities.v1.UpdateCorpResponse
 */
export type UpdateCorpResponse = Message<"identities.v1.UpdateCorpResponse"> & {
	/**
	 * @generated from field: identities.v1.Corp corp = 1;
	 */
	corp?: Corp | undefined;
};

/**
 * @generated from message identities.v1.UpdateCorpResponse
 */
export type UpdateCorpResponseJson = {
	/**
	 * @generated from field: identities.v1.Corp corp = 1;
	 */
	corp?: CorpJson;
};

/**
 * Describes the message identities.v1.UpdateCorpResponse.
 * Use `create(UpdateCorpResponseSchema)` to create a new message.
 */
export const UpdateCorpResponseSchema: GenMessage<UpdateCorpResponse, { jsonType: UpdateCorpResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 236);

/**
 * @generated from message identities.v1.IsCorpRequest
 */
export type IsCorpRequest = Message<"identities.v1.IsCorpRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message identities.v1.IsCorpRequest
 */
export type IsCorpRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message identities.v1.IsCorpRequest.
 * Use `create(IsCorpRequestSchema)` to create a new message.
 */
export const IsCorpRequestSchema: GenMessage<IsCorpRequest, { jsonType: IsCorpRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 237);

/**
 * @generated from message identities.v1.IsCorpResponse
 */
export type IsCorpResponse = Message<"identities.v1.IsCorpResponse"> & {
	/**
	 * @generated from field: bool is_corp = 1;
	 */
	isCorp: boolean;
};

/**
 * @generated from message identities.v1.IsCorpResponse
 */
export type IsCorpResponseJson = {
	/**
	 * @generated from field: bool is_corp = 1;
	 */
	isCorp?: boolean;
};

/**
 * Describes the message identities.v1.IsCorpResponse.
 * Use `create(IsCorpResponseSchema)` to create a new message.
 */
export const IsCorpResponseSchema: GenMessage<IsCorpResponse, { jsonType: IsCorpResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 238);

/**
 * @generated from message identities.v1.AddCorpMemberRequest
 */
export type AddCorpMemberRequest = Message<"identities.v1.AddCorpMemberRequest"> & {
	/**
	 * @generated from field: identities.v1.CorpMember member = 2;
	 */
	member?: CorpMember | undefined;
};

/**
 * @generated from message identities.v1.AddCorpMemberRequest
 */
export type AddCorpMemberRequestJson = {
	/**
	 * @generated from field: identities.v1.CorpMember member = 2;
	 */
	member?: CorpMemberJson;
};

/**
 * Describes the message identities.v1.AddCorpMemberRequest.
 * Use `create(AddCorpMemberRequestSchema)` to create a new message.
 */
export const AddCorpMemberRequestSchema: GenMessage<AddCorpMemberRequest, { jsonType: AddCorpMemberRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 239);

/**
 * @generated from message identities.v1.AddCorpMemberResponse
 */
export type AddCorpMemberResponse = Message<"identities.v1.AddCorpMemberResponse"> & {
	/**
	 * @generated from field: identities.v1.CorpMember member = 1;
	 */
	member?: CorpMember | undefined;
};

/**
 * @generated from message identities.v1.AddCorpMemberResponse
 */
export type AddCorpMemberResponseJson = {
	/**
	 * @generated from field: identities.v1.CorpMember member = 1;
	 */
	member?: CorpMemberJson;
};

/**
 * Describes the message identities.v1.AddCorpMemberResponse.
 * Use `create(AddCorpMemberResponseSchema)` to create a new message.
 */
export const AddCorpMemberResponseSchema: GenMessage<AddCorpMemberResponse, { jsonType: AddCorpMemberResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 240);

/**
 * @generated from message identities.v1.RemoveCorpMemberRequest
 */
export type RemoveCorpMemberRequest = Message<"identities.v1.RemoveCorpMemberRequest"> & {
	/**
	 * @generated from field: string user_id = 1;
	 */
	userId: string;

	/**
	 * @generated from field: string corp_id = 2;
	 */
	corpId: string;
};

/**
 * @generated from message identities.v1.RemoveCorpMemberRequest
 */
export type RemoveCorpMemberRequestJson = {
	/**
	 * @generated from field: string user_id = 1;
	 */
	userId?: string;

	/**
	 * @generated from field: string corp_id = 2;
	 */
	corpId?: string;
};

/**
 * Describes the message identities.v1.RemoveCorpMemberRequest.
 * Use `create(RemoveCorpMemberRequestSchema)` to create a new message.
 */
export const RemoveCorpMemberRequestSchema: GenMessage<RemoveCorpMemberRequest, { jsonType: RemoveCorpMemberRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 241);

/**
 * @generated from message identities.v1.RemoveCorpMemberResponse
 */
export type RemoveCorpMemberResponse = Message<"identities.v1.RemoveCorpMemberResponse"> & {
	/**
	 * @generated from field: identities.v1.CorpMember member = 1;
	 */
	member?: CorpMember | undefined;
};

/**
 * @generated from message identities.v1.RemoveCorpMemberResponse
 */
export type RemoveCorpMemberResponseJson = {
	/**
	 * @generated from field: identities.v1.CorpMember member = 1;
	 */
	member?: CorpMemberJson;
};

/**
 * Describes the message identities.v1.RemoveCorpMemberResponse.
 * Use `create(RemoveCorpMemberResponseSchema)` to create a new message.
 */
export const RemoveCorpMemberResponseSchema: GenMessage<RemoveCorpMemberResponse, { jsonType: RemoveCorpMemberResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 242);

/**
 * @generated from message identities.v1.ListCorpUsersRequest
 */
export type ListCorpUsersRequest = Message<"identities.v1.ListCorpUsersRequest"> & {
	/**
	 * @generated from field: string corp_id = 1;
	 */
	corpId: string;

	/**
	 * @generated from field: identities.v1.CorpUserFilter filter = 2;
	 */
	filter?: CorpUserFilter | undefined;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 3;
	 */
	paginate?: PaginationArguments | undefined;
};

/**
 * @generated from message identities.v1.ListCorpUsersRequest
 */
export type ListCorpUsersRequestJson = {
	/**
	 * @generated from field: string corp_id = 1;
	 */
	corpId?: string;

	/**
	 * @generated from field: identities.v1.CorpUserFilter filter = 2;
	 */
	filter?: CorpUserFilterJson;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 3;
	 */
	paginate?: PaginationArgumentsJson;
};

/**
 * Describes the message identities.v1.ListCorpUsersRequest.
 * Use `create(ListCorpUsersRequestSchema)` to create a new message.
 */
export const ListCorpUsersRequestSchema: GenMessage<ListCorpUsersRequest, { jsonType: ListCorpUsersRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 243);

/**
 * @generated from message identities.v1.ListCorpUsersResponse
 */
export type ListCorpUsersResponse = Message<"identities.v1.ListCorpUsersResponse"> & {
	/**
	 * @generated from field: repeated identities.v1.CorpMember items = 1;
	 */
	items: CorpMember[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message identities.v1.ListCorpUsersResponse
 */
export type ListCorpUsersResponseJson = {
	/**
	 * @generated from field: repeated identities.v1.CorpMember items = 1;
	 */
	items?: CorpMemberJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message identities.v1.ListCorpUsersResponse.
 * Use `create(ListCorpUsersResponseSchema)` to create a new message.
 */
export const ListCorpUsersResponseSchema: GenMessage<ListCorpUsersResponse, { jsonType: ListCorpUsersResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 244);

/**
 * ListCorpOrgsRequest is an empty object, later we can fill it with filtering options
 *
 * @generated from message identities.v1.ListCorpOrgsRequest
 */
export type ListCorpOrgsRequest = Message<"identities.v1.ListCorpOrgsRequest"> & {
	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 1;
	 */
	paginate?: PaginationArguments | undefined;

	/**
	 * @generated from field: string id = 3;
	 */
	id: string;
};

/**
 * ListCorpOrgsRequest is an empty object, later we can fill it with filtering options
 *
 * @generated from message identities.v1.ListCorpOrgsRequest
 */
export type ListCorpOrgsRequestJson = {
	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 1;
	 */
	paginate?: PaginationArgumentsJson;

	/**
	 * @generated from field: string id = 3;
	 */
	id?: string;
};

/**
 * Describes the message identities.v1.ListCorpOrgsRequest.
 * Use `create(ListCorpOrgsRequestSchema)` to create a new message.
 */
export const ListCorpOrgsRequestSchema: GenMessage<ListCorpOrgsRequest, { jsonType: ListCorpOrgsRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 245);

/**
 * ListOrgsResponse returns an array of users
 *
 * @generated from message identities.v1.ListCorpOrgsResponse
 */
export type ListCorpOrgsResponse = Message<"identities.v1.ListCorpOrgsResponse"> & {
	/**
	 * @generated from field: repeated identities.v1.Org items = 1;
	 */
	items: Org[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * ListOrgsResponse returns an array of users
 *
 * @generated from message identities.v1.ListCorpOrgsResponse
 */
export type ListCorpOrgsResponseJson = {
	/**
	 * @generated from field: repeated identities.v1.Org items = 1;
	 */
	items?: OrgJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message identities.v1.ListCorpOrgsResponse.
 * Use `create(ListCorpOrgsResponseSchema)` to create a new message.
 */
export const ListCorpOrgsResponseSchema: GenMessage<ListCorpOrgsResponse, { jsonType: ListCorpOrgsResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 246);

/**
 * @generated from message identities.v1.CorpFilter
 */
export type CorpFilter = Message<"identities.v1.CorpFilter"> & {
	/**
	 * @generated from field: optional string name = 1;
	 */
	name?: string | undefined;
};

/**
 * @generated from message identities.v1.CorpFilter
 */
export type CorpFilterJson = {
	/**
	 * @generated from field: optional string name = 1;
	 */
	name?: string;
};

/**
 * Describes the message identities.v1.CorpFilter.
 * Use `create(CorpFilterSchema)` to create a new message.
 */
export const CorpFilterSchema: GenMessage<CorpFilter, { jsonType: CorpFilterJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 247);

/**
 * ListCorpsRequest is an empty object, later we can fill it with filtering options
 *
 * @generated from message identities.v1.ListCorpsRequest
 */
export type ListCorpsRequest = Message<"identities.v1.ListCorpsRequest"> & {
	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 1;
	 */
	paginate?: PaginationArguments | undefined;

	/**
	 * @generated from field: identities.v1.CorpFilter filter = 2;
	 */
	filter?: CorpFilter | undefined;
};

/**
 * ListCorpsRequest is an empty object, later we can fill it with filtering options
 *
 * @generated from message identities.v1.ListCorpsRequest
 */
export type ListCorpsRequestJson = {
	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 1;
	 */
	paginate?: PaginationArgumentsJson;

	/**
	 * @generated from field: identities.v1.CorpFilter filter = 2;
	 */
	filter?: CorpFilterJson;
};

/**
 * Describes the message identities.v1.ListCorpsRequest.
 * Use `create(ListCorpsRequestSchema)` to create a new message.
 */
export const ListCorpsRequestSchema: GenMessage<ListCorpsRequest, { jsonType: ListCorpsRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 248);

/**
 * ListCorpsResponse returns an array of corporations
 *
 * @generated from message identities.v1.ListCorpsResponse
 */
export type ListCorpsResponse = Message<"identities.v1.ListCorpsResponse"> & {
	/**
	 * @generated from field: repeated identities.v1.Corp items = 1;
	 */
	items: Corp[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * ListCorpsResponse returns an array of corporations
 *
 * @generated from message identities.v1.ListCorpsResponse
 */
export type ListCorpsResponseJson = {
	/**
	 * @generated from field: repeated identities.v1.Corp items = 1;
	 */
	items?: CorpJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message identities.v1.ListCorpsResponse.
 * Use `create(ListCorpsResponseSchema)` to create a new message.
 */
export const ListCorpsResponseSchema: GenMessage<ListCorpsResponse, { jsonType: ListCorpsResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 249);

/**
 * ListMyCorps returns a list of corps that the user is a member of
 *
 * @generated from message identities.v1.ListMyCorpsRequest
 */
export type ListMyCorpsRequest = Message<"identities.v1.ListMyCorpsRequest"> & {
	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 1;
	 */
	paginate?: PaginationArguments | undefined;

	/**
	 * @generated from field: identities.v1.CorpFilter filter = 2;
	 */
	filter?: CorpFilter | undefined;
};

/**
 * ListMyCorps returns a list of corps that the user is a member of
 *
 * @generated from message identities.v1.ListMyCorpsRequest
 */
export type ListMyCorpsRequestJson = {
	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 1;
	 */
	paginate?: PaginationArgumentsJson;

	/**
	 * @generated from field: identities.v1.CorpFilter filter = 2;
	 */
	filter?: CorpFilterJson;
};

/**
 * Describes the message identities.v1.ListMyCorpsRequest.
 * Use `create(ListMyCorpsRequestSchema)` to create a new message.
 */
export const ListMyCorpsRequestSchema: GenMessage<ListMyCorpsRequest, { jsonType: ListMyCorpsRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 250);

/**
 * ListMyCorpsResponse returns an array of corporations
 *
 * @generated from message identities.v1.ListMyCorpsResponse
 */
export type ListMyCorpsResponse = Message<"identities.v1.ListMyCorpsResponse"> & {
	/**
	 * @generated from field: repeated identities.v1.Corp items = 1;
	 */
	items: Corp[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * ListMyCorpsResponse returns an array of corporations
 *
 * @generated from message identities.v1.ListMyCorpsResponse
 */
export type ListMyCorpsResponseJson = {
	/**
	 * @generated from field: repeated identities.v1.Corp items = 1;
	 */
	items?: CorpJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message identities.v1.ListMyCorpsResponse.
 * Use `create(ListMyCorpsResponseSchema)` to create a new message.
 */
export const ListMyCorpsResponseSchema: GenMessage<ListMyCorpsResponse, { jsonType: ListMyCorpsResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 251);

/**
 * @generated from message identities.v1.AssignOrgToCorpRequest
 */
export type AssignOrgToCorpRequest = Message<"identities.v1.AssignOrgToCorpRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string corp_id = 2;
	 */
	corpId: string;
};

/**
 * @generated from message identities.v1.AssignOrgToCorpRequest
 */
export type AssignOrgToCorpRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string corp_id = 2;
	 */
	corpId?: string;
};

/**
 * Describes the message identities.v1.AssignOrgToCorpRequest.
 * Use `create(AssignOrgToCorpRequestSchema)` to create a new message.
 */
export const AssignOrgToCorpRequestSchema: GenMessage<AssignOrgToCorpRequest, { jsonType: AssignOrgToCorpRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 252);

/**
 * @generated from message identities.v1.AssignOrgToCorpResponse
 */
export type AssignOrgToCorpResponse = Message<"identities.v1.AssignOrgToCorpResponse"> & {};

/**
 * @generated from message identities.v1.AssignOrgToCorpResponse
 */
export type AssignOrgToCorpResponseJson = {};

/**
 * Describes the message identities.v1.AssignOrgToCorpResponse.
 * Use `create(AssignOrgToCorpResponseSchema)` to create a new message.
 */
export const AssignOrgToCorpResponseSchema: GenMessage<AssignOrgToCorpResponse, { jsonType: AssignOrgToCorpResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 253);

/**
 * @generated from message identities.v1.RemoveOrgToCorpRequest
 */
export type RemoveOrgToCorpRequest = Message<"identities.v1.RemoveOrgToCorpRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string corp_id = 2;
	 */
	corpId: string;
};

/**
 * @generated from message identities.v1.RemoveOrgToCorpRequest
 */
export type RemoveOrgToCorpRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string corp_id = 2;
	 */
	corpId?: string;
};

/**
 * Describes the message identities.v1.RemoveOrgToCorpRequest.
 * Use `create(RemoveOrgToCorpRequestSchema)` to create a new message.
 */
export const RemoveOrgToCorpRequestSchema: GenMessage<RemoveOrgToCorpRequest, { jsonType: RemoveOrgToCorpRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 254);

/**
 * @generated from message identities.v1.RemoveOrgToCorpResponse
 */
export type RemoveOrgToCorpResponse = Message<"identities.v1.RemoveOrgToCorpResponse"> & {};

/**
 * @generated from message identities.v1.RemoveOrgToCorpResponse
 */
export type RemoveOrgToCorpResponseJson = {};

/**
 * Describes the message identities.v1.RemoveOrgToCorpResponse.
 * Use `create(RemoveOrgToCorpResponseSchema)` to create a new message.
 */
export const RemoveOrgToCorpResponseSchema: GenMessage<RemoveOrgToCorpResponse, { jsonType: RemoveOrgToCorpResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 255);

/**
 * @generated from message identities.v1.UpdateInvitationHookRequest
 */
export type UpdateInvitationHookRequest = Message<"identities.v1.UpdateInvitationHookRequest"> & {
	/**
	 * @generated from field: string event_key = 1;
	 */
	eventKey: string;

	/**
	 * @generated from field: identities.v1.PrehookInvitationContext event_context = 2;
	 */
	eventContext?: PrehookInvitationContext | undefined;

	/**
	 * @generated from field: identities.v1.FronteggUser user = 3;
	 */
	user?: FronteggUser | undefined;
};

/**
 * @generated from message identities.v1.UpdateInvitationHookRequest
 */
export type UpdateInvitationHookRequestJson = {
	/**
	 * @generated from field: string event_key = 1;
	 */
	eventKey?: string;

	/**
	 * @generated from field: identities.v1.PrehookInvitationContext event_context = 2;
	 */
	eventContext?: PrehookInvitationContextJson;

	/**
	 * @generated from field: identities.v1.FronteggUser user = 3;
	 */
	user?: FronteggUserJson;
};

/**
 * Describes the message identities.v1.UpdateInvitationHookRequest.
 * Use `create(UpdateInvitationHookRequestSchema)` to create a new message.
 */
export const UpdateInvitationHookRequestSchema: GenMessage<UpdateInvitationHookRequest, { jsonType: UpdateInvitationHookRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 256);

/**
 * @generated from message identities.v1.UpdateInvitationHookResponse
 */
export type UpdateInvitationHookResponse = Message<"identities.v1.UpdateInvitationHookResponse"> & {};

/**
 * @generated from message identities.v1.UpdateInvitationHookResponse
 */
export type UpdateInvitationHookResponseJson = {};

/**
 * Describes the message identities.v1.UpdateInvitationHookResponse.
 * Use `create(UpdateInvitationHookResponseSchema)` to create a new message.
 */
export const UpdateInvitationHookResponseSchema: GenMessage<UpdateInvitationHookResponse, { jsonType: UpdateInvitationHookResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 257);

/**
 * @generated from message identities.v1.SetUserPreferenceRequest
 */
export type SetUserPreferenceRequest = Message<"identities.v1.SetUserPreferenceRequest"> & {
	/**
	 * @generated from field: string key = 1;
	 */
	key: string;

	/**
	 * @generated from field: google.protobuf.Value value = 2;
	 */
	value?: Value | undefined;
};

/**
 * @generated from message identities.v1.SetUserPreferenceRequest
 */
export type SetUserPreferenceRequestJson = {
	/**
	 * @generated from field: string key = 1;
	 */
	key?: string;

	/**
	 * @generated from field: google.protobuf.Value value = 2;
	 */
	value?: ValueJson;
};

/**
 * Describes the message identities.v1.SetUserPreferenceRequest.
 * Use `create(SetUserPreferenceRequestSchema)` to create a new message.
 */
export const SetUserPreferenceRequestSchema: GenMessage<SetUserPreferenceRequest, { jsonType: SetUserPreferenceRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 258);

/**
 * @generated from message identities.v1.SetUserPreferenceResponse
 */
export type SetUserPreferenceResponse = Message<"identities.v1.SetUserPreferenceResponse"> & {
	/**
	 * @generated from field: string key = 1;
	 */
	key: string;

	/**
	 * @generated from field: google.protobuf.Value value = 2;
	 */
	value?: Value | undefined;
};

/**
 * @generated from message identities.v1.SetUserPreferenceResponse
 */
export type SetUserPreferenceResponseJson = {
	/**
	 * @generated from field: string key = 1;
	 */
	key?: string;

	/**
	 * @generated from field: google.protobuf.Value value = 2;
	 */
	value?: ValueJson;
};

/**
 * Describes the message identities.v1.SetUserPreferenceResponse.
 * Use `create(SetUserPreferenceResponseSchema)` to create a new message.
 */
export const SetUserPreferenceResponseSchema: GenMessage<SetUserPreferenceResponse, { jsonType: SetUserPreferenceResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 259);

/**
 * @generated from message identities.v1.ListUserPreferencesRequest
 */
export type ListUserPreferencesRequest = Message<"identities.v1.ListUserPreferencesRequest"> & {};

/**
 * @generated from message identities.v1.ListUserPreferencesRequest
 */
export type ListUserPreferencesRequestJson = {};

/**
 * Describes the message identities.v1.ListUserPreferencesRequest.
 * Use `create(ListUserPreferencesRequestSchema)` to create a new message.
 */
export const ListUserPreferencesRequestSchema: GenMessage<ListUserPreferencesRequest, { jsonType: ListUserPreferencesRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 260);

/**
 * @generated from message identities.v1.ListUserPreferencesResponse
 */
export type ListUserPreferencesResponse = Message<"identities.v1.ListUserPreferencesResponse"> & {
	/**
	 * @generated from field: string user_id = 1;
	 */
	userId: string;

	/**
	 * @generated from field: map<string, google.protobuf.Value> preferences = 2;
	 */
	preferences: { [key: string]: Value };
};

/**
 * @generated from message identities.v1.ListUserPreferencesResponse
 */
export type ListUserPreferencesResponseJson = {
	/**
	 * @generated from field: string user_id = 1;
	 */
	userId?: string;

	/**
	 * @generated from field: map<string, google.protobuf.Value> preferences = 2;
	 */
	preferences?: { [key: string]: ValueJson };
};

/**
 * Describes the message identities.v1.ListUserPreferencesResponse.
 * Use `create(ListUserPreferencesResponseSchema)` to create a new message.
 */
export const ListUserPreferencesResponseSchema: GenMessage<ListUserPreferencesResponse, { jsonType: ListUserPreferencesResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 261);

/**
 * SharedWorkspaceSetup tracks the in-progress handshake used to establish a
 * shared workspace connection between a sharer workspace and a recipient org.
 *
 * @generated from message identities.v1.SharedWorkspaceSetup
 */
export type SharedWorkspaceSetup = Message<"identities.v1.SharedWorkspaceSetup"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * The sharer's workspace; the source side of the connection.
	 *
	 * @generated from field: string source_workspace_id = 2;
	 */
	sourceWorkspaceId: string;

	/**
	 * The user who initiated the setup on the sharer side.
	 *
	 * @generated from field: string sharer_id = 3;
	 */
	sharerId: string;

	/**
	 * The invited user who configures the recipient side.
	 *
	 * @generated from field: string recipient_id = 4;
	 */
	recipientId: string;

	/**
	 * Chosen by the recipient in step 2 once they pick which of their orgs is
	 * the target for the connection.
	 *
	 * @generated from field: optional string target_org_id = 5;
	 */
	targetOrgId?: string | undefined;

	/**
	 * Free-form configuration data submitted by the recipient in step 2 and
	 * reviewed by the sharer in step 3.
	 *
	 * @generated from field: optional google.protobuf.Struct recipient_configuration = 6;
	 */
	recipientConfiguration?: JsonObject | undefined;

	/**
	 * @generated from field: identities.v1.SharedWorkspaceSetupStatus status = 7;
	 */
	status: SharedWorkspaceSetupStatus;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 8;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 9;
	 */
	updatedAt?: Timestamp | undefined;

	/**
	 * @generated from field: optional identities.v1.User sharer = 10;
	 */
	sharer?: User | undefined;

	/**
	 * @generated from field: optional identities.v1.User recipient = 11;
	 */
	recipient?: User | undefined;

	/**
	 * @generated from field: optional identities.v1.OrgPublicInfo target_org = 12;
	 */
	targetOrg?: OrgPublicInfo | undefined;

	/**
	 * @generated from field: optional identities.v1.WorkspacePublicInfo source_workspace = 13;
	 */
	sourceWorkspace?: WorkspacePublicInfo | undefined;

	/**
	 * @generated from field: optional google.protobuf.Timestamp effective_from_date = 14;
	 */
	effectiveFromDate?: Timestamp | undefined;
};

/**
 * SharedWorkspaceSetup tracks the in-progress handshake used to establish a
 * shared workspace connection between a sharer workspace and a recipient org.
 *
 * @generated from message identities.v1.SharedWorkspaceSetup
 */
export type SharedWorkspaceSetupJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * The sharer's workspace; the source side of the connection.
	 *
	 * @generated from field: string source_workspace_id = 2;
	 */
	sourceWorkspaceId?: string;

	/**
	 * The user who initiated the setup on the sharer side.
	 *
	 * @generated from field: string sharer_id = 3;
	 */
	sharerId?: string;

	/**
	 * The invited user who configures the recipient side.
	 *
	 * @generated from field: string recipient_id = 4;
	 */
	recipientId?: string;

	/**
	 * Chosen by the recipient in step 2 once they pick which of their orgs is
	 * the target for the connection.
	 *
	 * @generated from field: optional string target_org_id = 5;
	 */
	targetOrgId?: string;

	/**
	 * Free-form configuration data submitted by the recipient in step 2 and
	 * reviewed by the sharer in step 3.
	 *
	 * @generated from field: optional google.protobuf.Struct recipient_configuration = 6;
	 */
	recipientConfiguration?: StructJson;

	/**
	 * @generated from field: identities.v1.SharedWorkspaceSetupStatus status = 7;
	 */
	status?: SharedWorkspaceSetupStatusJson;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 8;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 9;
	 */
	updatedAt?: TimestampJson;

	/**
	 * @generated from field: optional identities.v1.User sharer = 10;
	 */
	sharer?: UserJson;

	/**
	 * @generated from field: optional identities.v1.User recipient = 11;
	 */
	recipient?: UserJson;

	/**
	 * @generated from field: optional identities.v1.OrgPublicInfo target_org = 12;
	 */
	targetOrg?: OrgPublicInfoJson;

	/**
	 * @generated from field: optional identities.v1.WorkspacePublicInfo source_workspace = 13;
	 */
	sourceWorkspace?: WorkspacePublicInfoJson;

	/**
	 * @generated from field: optional google.protobuf.Timestamp effective_from_date = 14;
	 */
	effectiveFromDate?: TimestampJson;
};

/**
 * Describes the message identities.v1.SharedWorkspaceSetup.
 * Use `create(SharedWorkspaceSetupSchema)` to create a new message.
 */
export const SharedWorkspaceSetupSchema: GenMessage<SharedWorkspaceSetup, { jsonType: SharedWorkspaceSetupJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 262);

/**
 * SharedWorkspaceConnection is the completed, durable record of a shared
 * workspace connection created once both parties confirm the setup.
 *
 * @generated from message identities.v1.SharedWorkspaceConnection
 */
export type SharedWorkspaceConnection = Message<"identities.v1.SharedWorkspaceConnection"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string setup_id = 2;
	 */
	setupId: string;

	/**
	 * @generated from field: string source_workspace_id = 3;
	 */
	sourceWorkspaceId: string;

	/**
	 * @generated from field: string target_org_id = 4;
	 */
	targetOrgId: string;

	/**
	 * @generated from field: optional google.protobuf.Struct configuration = 5;
	 */
	configuration?: JsonObject | undefined;

	/**
	 * @generated from field: identities.v1.SharedWorkspaceConnectionStatus status = 6;
	 */
	status: SharedWorkspaceConnectionStatus;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 7;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 8;
	 */
	updatedAt?: Timestamp | undefined;

	/**
	 * @generated from field: optional google.protobuf.Timestamp terminated_at = 9;
	 */
	terminatedAt?: Timestamp | undefined;

	/**
	 * @generated from field: optional identities.v1.WorkspacePublicInfo source_workspace = 10;
	 */
	sourceWorkspace?: WorkspacePublicInfo | undefined;

	/**
	 * @generated from field: optional identities.v1.OrgPublicInfo target_org = 11;
	 */
	targetOrg?: OrgPublicInfo | undefined;

	/**
	 * @generated from field: optional google.protobuf.Timestamp effective_from_date = 12;
	 */
	effectiveFromDate?: Timestamp | undefined;
};

/**
 * SharedWorkspaceConnection is the completed, durable record of a shared
 * workspace connection created once both parties confirm the setup.
 *
 * @generated from message identities.v1.SharedWorkspaceConnection
 */
export type SharedWorkspaceConnectionJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string setup_id = 2;
	 */
	setupId?: string;

	/**
	 * @generated from field: string source_workspace_id = 3;
	 */
	sourceWorkspaceId?: string;

	/**
	 * @generated from field: string target_org_id = 4;
	 */
	targetOrgId?: string;

	/**
	 * @generated from field: optional google.protobuf.Struct configuration = 5;
	 */
	configuration?: StructJson;

	/**
	 * @generated from field: identities.v1.SharedWorkspaceConnectionStatus status = 6;
	 */
	status?: SharedWorkspaceConnectionStatusJson;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 7;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 8;
	 */
	updatedAt?: TimestampJson;

	/**
	 * @generated from field: optional google.protobuf.Timestamp terminated_at = 9;
	 */
	terminatedAt?: TimestampJson;

	/**
	 * @generated from field: optional identities.v1.WorkspacePublicInfo source_workspace = 10;
	 */
	sourceWorkspace?: WorkspacePublicInfoJson;

	/**
	 * @generated from field: optional identities.v1.OrgPublicInfo target_org = 11;
	 */
	targetOrg?: OrgPublicInfoJson;

	/**
	 * @generated from field: optional google.protobuf.Timestamp effective_from_date = 12;
	 */
	effectiveFromDate?: TimestampJson;
};

/**
 * Describes the message identities.v1.SharedWorkspaceConnection.
 * Use `create(SharedWorkspaceConnectionSchema)` to create a new message.
 */
export const SharedWorkspaceConnectionSchema: GenMessage<SharedWorkspaceConnection, { jsonType: SharedWorkspaceConnectionJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 263);

/**
 * SharedWorkspaceConnectionCreated is the event message published when a shared workspace connection is created
 *
 * @generated from message identities.v1.SharedWorkspaceConnectionCreated
 */
export type SharedWorkspaceConnectionCreated = Message<"identities.v1.SharedWorkspaceConnectionCreated"> & {
	/**
	 * @generated from field: identities.v1.SharedWorkspaceConnection connection = 1;
	 */
	connection?: SharedWorkspaceConnection | undefined;
};

/**
 * SharedWorkspaceConnectionCreated is the event message published when a shared workspace connection is created
 *
 * @generated from message identities.v1.SharedWorkspaceConnectionCreated
 */
export type SharedWorkspaceConnectionCreatedJson = {
	/**
	 * @generated from field: identities.v1.SharedWorkspaceConnection connection = 1;
	 */
	connection?: SharedWorkspaceConnectionJson;
};

/**
 * Describes the message identities.v1.SharedWorkspaceConnectionCreated.
 * Use `create(SharedWorkspaceConnectionCreatedSchema)` to create a new message.
 */
export const SharedWorkspaceConnectionCreatedSchema: GenMessage<SharedWorkspaceConnectionCreated, { jsonType: SharedWorkspaceConnectionCreatedJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 264);

/**
 * SharedWorkspaceConnectionTerminated is the event message published when a shared workspace connection is terminated
 *
 * @generated from message identities.v1.SharedWorkspaceConnectionTerminated
 */
export type SharedWorkspaceConnectionTerminated = Message<"identities.v1.SharedWorkspaceConnectionTerminated"> & {
	/**
	 * @generated from field: identities.v1.SharedWorkspaceConnection connection = 1;
	 */
	connection?: SharedWorkspaceConnection | undefined;
};

/**
 * SharedWorkspaceConnectionTerminated is the event message published when a shared workspace connection is terminated
 *
 * @generated from message identities.v1.SharedWorkspaceConnectionTerminated
 */
export type SharedWorkspaceConnectionTerminatedJson = {
	/**
	 * @generated from field: identities.v1.SharedWorkspaceConnection connection = 1;
	 */
	connection?: SharedWorkspaceConnectionJson;
};

/**
 * Describes the message identities.v1.SharedWorkspaceConnectionTerminated.
 * Use `create(SharedWorkspaceConnectionTerminatedSchema)` to create a new message.
 */
export const SharedWorkspaceConnectionTerminatedSchema: GenMessage<SharedWorkspaceConnectionTerminated, { jsonType: SharedWorkspaceConnectionTerminatedJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 265);

/**
 * Step 1: an admin of the sharer workspace initiates the setup by supplying
 * the recipient's email. The recipient user is found and invited to configure
 * the target side of the connection.
 *
 * @generated from message identities.v1.CreateSharedWorkspaceSetupRequest
 */
export type CreateSharedWorkspaceSetupRequest = Message<"identities.v1.CreateSharedWorkspaceSetupRequest"> & {
	/**
	 * @generated from field: string recipient_email = 1;
	 */
	recipientEmail: string;

	/**
	 * @generated from field: string source_workspace_id = 2;
	 */
	sourceWorkspaceId: string;

	/**
	 * if the sharer belongs to the target org, they may optionally submit the target org id to skip the org selection step.
	 *
	 * @generated from field: optional string target_org_id = 3;
	 */
	targetOrgId?: string | undefined;

	/**
	 * @generated from field: optional google.protobuf.Timestamp effective_from_date = 4;
	 */
	effectiveFromDate?: Timestamp | undefined;
};

/**
 * Step 1: an admin of the sharer workspace initiates the setup by supplying
 * the recipient's email. The recipient user is found and invited to configure
 * the target side of the connection.
 *
 * @generated from message identities.v1.CreateSharedWorkspaceSetupRequest
 */
export type CreateSharedWorkspaceSetupRequestJson = {
	/**
	 * @generated from field: string recipient_email = 1;
	 */
	recipientEmail?: string;

	/**
	 * @generated from field: string source_workspace_id = 2;
	 */
	sourceWorkspaceId?: string;

	/**
	 * if the sharer belongs to the target org, they may optionally submit the target org id to skip the org selection step.
	 *
	 * @generated from field: optional string target_org_id = 3;
	 */
	targetOrgId?: string;

	/**
	 * @generated from field: optional google.protobuf.Timestamp effective_from_date = 4;
	 */
	effectiveFromDate?: TimestampJson;
};

/**
 * Describes the message identities.v1.CreateSharedWorkspaceSetupRequest.
 * Use `create(CreateSharedWorkspaceSetupRequestSchema)` to create a new message.
 */
export const CreateSharedWorkspaceSetupRequestSchema: GenMessage<CreateSharedWorkspaceSetupRequest, { jsonType: CreateSharedWorkspaceSetupRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 266);

/**
 * @generated from message identities.v1.CreateSharedWorkspaceSetupResponse
 */
export type CreateSharedWorkspaceSetupResponse = Message<"identities.v1.CreateSharedWorkspaceSetupResponse"> & {
	/**
	 * @generated from field: identities.v1.SharedWorkspaceSetup setup = 1;
	 */
	setup?: SharedWorkspaceSetup | undefined;
};

/**
 * @generated from message identities.v1.CreateSharedWorkspaceSetupResponse
 */
export type CreateSharedWorkspaceSetupResponseJson = {
	/**
	 * @generated from field: identities.v1.SharedWorkspaceSetup setup = 1;
	 */
	setup?: SharedWorkspaceSetupJson;
};

/**
 * Describes the message identities.v1.CreateSharedWorkspaceSetupResponse.
 * Use `create(CreateSharedWorkspaceSetupResponseSchema)` to create a new message.
 */
export const CreateSharedWorkspaceSetupResponseSchema: GenMessage<CreateSharedWorkspaceSetupResponse, { jsonType: CreateSharedWorkspaceSetupResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 267);

/**
 * Step 2: the recipient chooses which org will be the target and submits their
 * configuration. This moves the setup to PENDING_SHARER_CONFIRMATION and
 * notifies the sharer to review.
 *
 * @generated from message identities.v1.SubmitSharedWorkspaceSetupConfigurationRequest
 */
export type SubmitSharedWorkspaceSetupConfigurationRequest = Message<"identities.v1.SubmitSharedWorkspaceSetupConfigurationRequest"> & {
	/**
	 * @generated from field: string setup_id = 1;
	 */
	setupId: string;

	/**
	 * @generated from field: string target_org_id = 2;
	 */
	targetOrgId: string;

	/**
	 * @generated from field: optional google.protobuf.Struct recipient_configuration = 3;
	 */
	recipientConfiguration?: JsonObject | undefined;
};

/**
 * Step 2: the recipient chooses which org will be the target and submits their
 * configuration. This moves the setup to PENDING_SHARER_CONFIRMATION and
 * notifies the sharer to review.
 *
 * @generated from message identities.v1.SubmitSharedWorkspaceSetupConfigurationRequest
 */
export type SubmitSharedWorkspaceSetupConfigurationRequestJson = {
	/**
	 * @generated from field: string setup_id = 1;
	 */
	setupId?: string;

	/**
	 * @generated from field: string target_org_id = 2;
	 */
	targetOrgId?: string;

	/**
	 * @generated from field: optional google.protobuf.Struct recipient_configuration = 3;
	 */
	recipientConfiguration?: StructJson;
};

/**
 * Describes the message identities.v1.SubmitSharedWorkspaceSetupConfigurationRequest.
 * Use `create(SubmitSharedWorkspaceSetupConfigurationRequestSchema)` to create a new message.
 */
export const SubmitSharedWorkspaceSetupConfigurationRequestSchema: GenMessage<SubmitSharedWorkspaceSetupConfigurationRequest, { jsonType: SubmitSharedWorkspaceSetupConfigurationRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 268);

/**
 * @generated from message identities.v1.SubmitSharedWorkspaceSetupConfigurationResponse
 */
export type SubmitSharedWorkspaceSetupConfigurationResponse = Message<"identities.v1.SubmitSharedWorkspaceSetupConfigurationResponse"> & {
	/**
	 * @generated from field: identities.v1.SharedWorkspaceSetup setup = 1;
	 */
	setup?: SharedWorkspaceSetup | undefined;
};

/**
 * @generated from message identities.v1.SubmitSharedWorkspaceSetupConfigurationResponse
 */
export type SubmitSharedWorkspaceSetupConfigurationResponseJson = {
	/**
	 * @generated from field: identities.v1.SharedWorkspaceSetup setup = 1;
	 */
	setup?: SharedWorkspaceSetupJson;
};

/**
 * Describes the message identities.v1.SubmitSharedWorkspaceSetupConfigurationResponse.
 * Use `create(SubmitSharedWorkspaceSetupConfigurationResponseSchema)` to create a new message.
 */
export const SubmitSharedWorkspaceSetupConfigurationResponseSchema: GenMessage<SubmitSharedWorkspaceSetupConfigurationResponse, { jsonType: SubmitSharedWorkspaceSetupConfigurationResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 269);

/**
 * Step 3: the sharer reviews the recipient's configuration and confirms,
 * completing the setup and creating the SharedWorkspaceConnection.
 *
 * @generated from message identities.v1.CompleteSharedWorkspaceSetupRequest
 */
export type CompleteSharedWorkspaceSetupRequest = Message<"identities.v1.CompleteSharedWorkspaceSetupRequest"> & {
	/**
	 * @generated from field: string setup_id = 1;
	 */
	setupId: string;
};

/**
 * Step 3: the sharer reviews the recipient's configuration and confirms,
 * completing the setup and creating the SharedWorkspaceConnection.
 *
 * @generated from message identities.v1.CompleteSharedWorkspaceSetupRequest
 */
export type CompleteSharedWorkspaceSetupRequestJson = {
	/**
	 * @generated from field: string setup_id = 1;
	 */
	setupId?: string;
};

/**
 * Describes the message identities.v1.CompleteSharedWorkspaceSetupRequest.
 * Use `create(CompleteSharedWorkspaceSetupRequestSchema)` to create a new message.
 */
export const CompleteSharedWorkspaceSetupRequestSchema: GenMessage<CompleteSharedWorkspaceSetupRequest, { jsonType: CompleteSharedWorkspaceSetupRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 270);

/**
 * @generated from message identities.v1.CompleteSharedWorkspaceSetupResponse
 */
export type CompleteSharedWorkspaceSetupResponse = Message<"identities.v1.CompleteSharedWorkspaceSetupResponse"> & {
	/**
	 * @generated from field: identities.v1.SharedWorkspaceSetup setup = 1;
	 */
	setup?: SharedWorkspaceSetup | undefined;

	/**
	 * @generated from field: identities.v1.SharedWorkspaceConnection connection = 2;
	 */
	connection?: SharedWorkspaceConnection | undefined;
};

/**
 * @generated from message identities.v1.CompleteSharedWorkspaceSetupResponse
 */
export type CompleteSharedWorkspaceSetupResponseJson = {
	/**
	 * @generated from field: identities.v1.SharedWorkspaceSetup setup = 1;
	 */
	setup?: SharedWorkspaceSetupJson;

	/**
	 * @generated from field: identities.v1.SharedWorkspaceConnection connection = 2;
	 */
	connection?: SharedWorkspaceConnectionJson;
};

/**
 * Describes the message identities.v1.CompleteSharedWorkspaceSetupResponse.
 * Use `create(CompleteSharedWorkspaceSetupResponseSchema)` to create a new message.
 */
export const CompleteSharedWorkspaceSetupResponseSchema: GenMessage<CompleteSharedWorkspaceSetupResponse, { jsonType: CompleteSharedWorkspaceSetupResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 271);

/**
 * @generated from message identities.v1.GetSharedWorkspaceSetupRequest
 */
export type GetSharedWorkspaceSetupRequest = Message<"identities.v1.GetSharedWorkspaceSetupRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message identities.v1.GetSharedWorkspaceSetupRequest
 */
export type GetSharedWorkspaceSetupRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message identities.v1.GetSharedWorkspaceSetupRequest.
 * Use `create(GetSharedWorkspaceSetupRequestSchema)` to create a new message.
 */
export const GetSharedWorkspaceSetupRequestSchema: GenMessage<GetSharedWorkspaceSetupRequest, { jsonType: GetSharedWorkspaceSetupRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 272);

/**
 * @generated from message identities.v1.GetSharedWorkspaceSetupResponse
 */
export type GetSharedWorkspaceSetupResponse = Message<"identities.v1.GetSharedWorkspaceSetupResponse"> & {
	/**
	 * @generated from field: identities.v1.SharedWorkspaceSetup setup = 1;
	 */
	setup?: SharedWorkspaceSetup | undefined;
};

/**
 * @generated from message identities.v1.GetSharedWorkspaceSetupResponse
 */
export type GetSharedWorkspaceSetupResponseJson = {
	/**
	 * @generated from field: identities.v1.SharedWorkspaceSetup setup = 1;
	 */
	setup?: SharedWorkspaceSetupJson;
};

/**
 * Describes the message identities.v1.GetSharedWorkspaceSetupResponse.
 * Use `create(GetSharedWorkspaceSetupResponseSchema)` to create a new message.
 */
export const GetSharedWorkspaceSetupResponseSchema: GenMessage<GetSharedWorkspaceSetupResponse, { jsonType: GetSharedWorkspaceSetupResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 273);

/**
 * @generated from message identities.v1.CancelSharedWorkspaceSetupRequest
 */
export type CancelSharedWorkspaceSetupRequest = Message<"identities.v1.CancelSharedWorkspaceSetupRequest"> & {
	/**
	 * @generated from field: string setup_id = 1;
	 */
	setupId: string;
};

/**
 * @generated from message identities.v1.CancelSharedWorkspaceSetupRequest
 */
export type CancelSharedWorkspaceSetupRequestJson = {
	/**
	 * @generated from field: string setup_id = 1;
	 */
	setupId?: string;
};

/**
 * Describes the message identities.v1.CancelSharedWorkspaceSetupRequest.
 * Use `create(CancelSharedWorkspaceSetupRequestSchema)` to create a new message.
 */
export const CancelSharedWorkspaceSetupRequestSchema: GenMessage<CancelSharedWorkspaceSetupRequest, { jsonType: CancelSharedWorkspaceSetupRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 274);

/**
 * @generated from message identities.v1.CancelSharedWorkspaceSetupResponse
 */
export type CancelSharedWorkspaceSetupResponse = Message<"identities.v1.CancelSharedWorkspaceSetupResponse"> & {
	/**
	 * @generated from field: identities.v1.SharedWorkspaceSetup setup = 1;
	 */
	setup?: SharedWorkspaceSetup | undefined;
};

/**
 * @generated from message identities.v1.CancelSharedWorkspaceSetupResponse
 */
export type CancelSharedWorkspaceSetupResponseJson = {
	/**
	 * @generated from field: identities.v1.SharedWorkspaceSetup setup = 1;
	 */
	setup?: SharedWorkspaceSetupJson;
};

/**
 * Describes the message identities.v1.CancelSharedWorkspaceSetupResponse.
 * Use `create(CancelSharedWorkspaceSetupResponseSchema)` to create a new message.
 */
export const CancelSharedWorkspaceSetupResponseSchema: GenMessage<CancelSharedWorkspaceSetupResponse, { jsonType: CancelSharedWorkspaceSetupResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 275);

/**
 * @generated from message identities.v1.SharedWorkspaceSetupFilter
 */
export type SharedWorkspaceSetupFilter = Message<"identities.v1.SharedWorkspaceSetupFilter"> & {
	/**
	 * @generated from field: optional string source_workspace_id = 1;
	 */
	sourceWorkspaceId?: string | undefined;

	/**
	 * @generated from field: optional string target_org_id = 2;
	 */
	targetOrgId?: string | undefined;

	/**
	 * @generated from field: repeated identities.v1.SharedWorkspaceSetupStatus statuses = 3;
	 */
	statuses: SharedWorkspaceSetupStatus[];
};

/**
 * @generated from message identities.v1.SharedWorkspaceSetupFilter
 */
export type SharedWorkspaceSetupFilterJson = {
	/**
	 * @generated from field: optional string source_workspace_id = 1;
	 */
	sourceWorkspaceId?: string;

	/**
	 * @generated from field: optional string target_org_id = 2;
	 */
	targetOrgId?: string;

	/**
	 * @generated from field: repeated identities.v1.SharedWorkspaceSetupStatus statuses = 3;
	 */
	statuses?: SharedWorkspaceSetupStatusJson[];
};

/**
 * Describes the message identities.v1.SharedWorkspaceSetupFilter.
 * Use `create(SharedWorkspaceSetupFilterSchema)` to create a new message.
 */
export const SharedWorkspaceSetupFilterSchema: GenMessage<SharedWorkspaceSetupFilter, { jsonType: SharedWorkspaceSetupFilterJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 276);

/**
 * @generated from message identities.v1.ListSharedWorkspaceSetupsRequest
 */
export type ListSharedWorkspaceSetupsRequest = Message<"identities.v1.ListSharedWorkspaceSetupsRequest"> & {
	/**
	 * @generated from field: identities.v1.SharedWorkspaceSetupFilter filter = 1;
	 */
	filter?: SharedWorkspaceSetupFilter | undefined;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 2;
	 */
	paginate?: PaginationArguments | undefined;
};

/**
 * @generated from message identities.v1.ListSharedWorkspaceSetupsRequest
 */
export type ListSharedWorkspaceSetupsRequestJson = {
	/**
	 * @generated from field: identities.v1.SharedWorkspaceSetupFilter filter = 1;
	 */
	filter?: SharedWorkspaceSetupFilterJson;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 2;
	 */
	paginate?: PaginationArgumentsJson;
};

/**
 * Describes the message identities.v1.ListSharedWorkspaceSetupsRequest.
 * Use `create(ListSharedWorkspaceSetupsRequestSchema)` to create a new message.
 */
export const ListSharedWorkspaceSetupsRequestSchema: GenMessage<ListSharedWorkspaceSetupsRequest, { jsonType: ListSharedWorkspaceSetupsRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 277);

/**
 * @generated from message identities.v1.ListSharedWorkspaceSetupsResponse
 */
export type ListSharedWorkspaceSetupsResponse = Message<"identities.v1.ListSharedWorkspaceSetupsResponse"> & {
	/**
	 * @generated from field: repeated identities.v1.SharedWorkspaceSetup items = 1;
	 */
	items: SharedWorkspaceSetup[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message identities.v1.ListSharedWorkspaceSetupsResponse
 */
export type ListSharedWorkspaceSetupsResponseJson = {
	/**
	 * @generated from field: repeated identities.v1.SharedWorkspaceSetup items = 1;
	 */
	items?: SharedWorkspaceSetupJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message identities.v1.ListSharedWorkspaceSetupsResponse.
 * Use `create(ListSharedWorkspaceSetupsResponseSchema)` to create a new message.
 */
export const ListSharedWorkspaceSetupsResponseSchema: GenMessage<ListSharedWorkspaceSetupsResponse, { jsonType: ListSharedWorkspaceSetupsResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 278);

/**
 * @generated from message identities.v1.GetSharedWorkspaceConnectionRequest
 */
export type GetSharedWorkspaceConnectionRequest = Message<"identities.v1.GetSharedWorkspaceConnectionRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message identities.v1.GetSharedWorkspaceConnectionRequest
 */
export type GetSharedWorkspaceConnectionRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message identities.v1.GetSharedWorkspaceConnectionRequest.
 * Use `create(GetSharedWorkspaceConnectionRequestSchema)` to create a new message.
 */
export const GetSharedWorkspaceConnectionRequestSchema: GenMessage<GetSharedWorkspaceConnectionRequest, { jsonType: GetSharedWorkspaceConnectionRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 279);

/**
 * @generated from message identities.v1.GetSharedWorkspaceConnectionResponse
 */
export type GetSharedWorkspaceConnectionResponse = Message<"identities.v1.GetSharedWorkspaceConnectionResponse"> & {
	/**
	 * @generated from field: identities.v1.SharedWorkspaceConnection connection = 1;
	 */
	connection?: SharedWorkspaceConnection | undefined;
};

/**
 * @generated from message identities.v1.GetSharedWorkspaceConnectionResponse
 */
export type GetSharedWorkspaceConnectionResponseJson = {
	/**
	 * @generated from field: identities.v1.SharedWorkspaceConnection connection = 1;
	 */
	connection?: SharedWorkspaceConnectionJson;
};

/**
 * Describes the message identities.v1.GetSharedWorkspaceConnectionResponse.
 * Use `create(GetSharedWorkspaceConnectionResponseSchema)` to create a new message.
 */
export const GetSharedWorkspaceConnectionResponseSchema: GenMessage<GetSharedWorkspaceConnectionResponse, { jsonType: GetSharedWorkspaceConnectionResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 280);

/**
 * @generated from message identities.v1.SharedWorkspaceConnectionFilter
 */
export type SharedWorkspaceConnectionFilter = Message<"identities.v1.SharedWorkspaceConnectionFilter"> & {
	/**
	 * @generated from field: optional string source_workspace_id = 1;
	 */
	sourceWorkspaceId?: string | undefined;

	/**
	 * @generated from field: optional string target_org_id = 2;
	 */
	targetOrgId?: string | undefined;

	/**
	 * @generated from field: optional identities.v1.SharedWorkspaceConnectionStatus status = 3;
	 */
	status?: SharedWorkspaceConnectionStatus | undefined;
};

/**
 * @generated from message identities.v1.SharedWorkspaceConnectionFilter
 */
export type SharedWorkspaceConnectionFilterJson = {
	/**
	 * @generated from field: optional string source_workspace_id = 1;
	 */
	sourceWorkspaceId?: string;

	/**
	 * @generated from field: optional string target_org_id = 2;
	 */
	targetOrgId?: string;

	/**
	 * @generated from field: optional identities.v1.SharedWorkspaceConnectionStatus status = 3;
	 */
	status?: SharedWorkspaceConnectionStatusJson;
};

/**
 * Describes the message identities.v1.SharedWorkspaceConnectionFilter.
 * Use `create(SharedWorkspaceConnectionFilterSchema)` to create a new message.
 */
export const SharedWorkspaceConnectionFilterSchema: GenMessage<SharedWorkspaceConnectionFilter, { jsonType: SharedWorkspaceConnectionFilterJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 281);

/**
 * @generated from message identities.v1.ListSharedWorkspaceConnectionsRequest
 */
export type ListSharedWorkspaceConnectionsRequest = Message<"identities.v1.ListSharedWorkspaceConnectionsRequest"> & {
	/**
	 * @generated from field: identities.v1.SharedWorkspaceConnectionFilter filter = 1;
	 */
	filter?: SharedWorkspaceConnectionFilter | undefined;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 2;
	 */
	paginate?: PaginationArguments | undefined;
};

/**
 * @generated from message identities.v1.ListSharedWorkspaceConnectionsRequest
 */
export type ListSharedWorkspaceConnectionsRequestJson = {
	/**
	 * @generated from field: identities.v1.SharedWorkspaceConnectionFilter filter = 1;
	 */
	filter?: SharedWorkspaceConnectionFilterJson;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 2;
	 */
	paginate?: PaginationArgumentsJson;
};

/**
 * Describes the message identities.v1.ListSharedWorkspaceConnectionsRequest.
 * Use `create(ListSharedWorkspaceConnectionsRequestSchema)` to create a new message.
 */
export const ListSharedWorkspaceConnectionsRequestSchema: GenMessage<ListSharedWorkspaceConnectionsRequest, { jsonType: ListSharedWorkspaceConnectionsRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 282);

/**
 * @generated from message identities.v1.ListSharedWorkspaceConnectionsResponse
 */
export type ListSharedWorkspaceConnectionsResponse = Message<"identities.v1.ListSharedWorkspaceConnectionsResponse"> & {
	/**
	 * @generated from field: repeated identities.v1.SharedWorkspaceConnection items = 1;
	 */
	items: SharedWorkspaceConnection[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message identities.v1.ListSharedWorkspaceConnectionsResponse
 */
export type ListSharedWorkspaceConnectionsResponseJson = {
	/**
	 * @generated from field: repeated identities.v1.SharedWorkspaceConnection items = 1;
	 */
	items?: SharedWorkspaceConnectionJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message identities.v1.ListSharedWorkspaceConnectionsResponse.
 * Use `create(ListSharedWorkspaceConnectionsResponseSchema)` to create a new message.
 */
export const ListSharedWorkspaceConnectionsResponseSchema: GenMessage<ListSharedWorkspaceConnectionsResponse, { jsonType: ListSharedWorkspaceConnectionsResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 283);

/**
 * Terminates an active connection, moving it to TERMINATED. May be initiated
 * by either the sharer or the recipient side.
 *
 * @generated from message identities.v1.TerminateSharedWorkspaceConnectionRequest
 */
export type TerminateSharedWorkspaceConnectionRequest = Message<"identities.v1.TerminateSharedWorkspaceConnectionRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * Terminates an active connection, moving it to TERMINATED. May be initiated
 * by either the sharer or the recipient side.
 *
 * @generated from message identities.v1.TerminateSharedWorkspaceConnectionRequest
 */
export type TerminateSharedWorkspaceConnectionRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message identities.v1.TerminateSharedWorkspaceConnectionRequest.
 * Use `create(TerminateSharedWorkspaceConnectionRequestSchema)` to create a new message.
 */
export const TerminateSharedWorkspaceConnectionRequestSchema: GenMessage<TerminateSharedWorkspaceConnectionRequest, { jsonType: TerminateSharedWorkspaceConnectionRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 284);

/**
 * @generated from message identities.v1.TerminateSharedWorkspaceConnectionResponse
 */
export type TerminateSharedWorkspaceConnectionResponse = Message<"identities.v1.TerminateSharedWorkspaceConnectionResponse"> & {
	/**
	 * @generated from field: identities.v1.SharedWorkspaceConnection connection = 1;
	 */
	connection?: SharedWorkspaceConnection | undefined;
};

/**
 * @generated from message identities.v1.TerminateSharedWorkspaceConnectionResponse
 */
export type TerminateSharedWorkspaceConnectionResponseJson = {
	/**
	 * @generated from field: identities.v1.SharedWorkspaceConnection connection = 1;
	 */
	connection?: SharedWorkspaceConnectionJson;
};

/**
 * Describes the message identities.v1.TerminateSharedWorkspaceConnectionResponse.
 * Use `create(TerminateSharedWorkspaceConnectionResponseSchema)` to create a new message.
 */
export const TerminateSharedWorkspaceConnectionResponseSchema: GenMessage<TerminateSharedWorkspaceConnectionResponse, { jsonType: TerminateSharedWorkspaceConnectionResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 285);

/**
 * @generated from message identities.v1.CreateSCIMConfigurationRequest
 */
export type CreateSCIMConfigurationRequest = Message<"identities.v1.CreateSCIMConfigurationRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * "okta" | "azure-ad" | "other"
	 *
	 * @generated from field: string source = 2;
	 */
	source: string;

	/**
	 * @generated from field: string connection_name = 3;
	 */
	connectionName: string;

	/**
	 * @generated from field: bool sync_to_user_management = 4;
	 */
	syncToUserManagement: boolean;

	/**
	 * @generated from field: string metadata = 5;
	 */
	metadata: string;
};

/**
 * @generated from message identities.v1.CreateSCIMConfigurationRequest
 */
export type CreateSCIMConfigurationRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * "okta" | "azure-ad" | "other"
	 *
	 * @generated from field: string source = 2;
	 */
	source?: string;

	/**
	 * @generated from field: string connection_name = 3;
	 */
	connectionName?: string;

	/**
	 * @generated from field: bool sync_to_user_management = 4;
	 */
	syncToUserManagement?: boolean;

	/**
	 * @generated from field: string metadata = 5;
	 */
	metadata?: string;
};

/**
 * Describes the message identities.v1.CreateSCIMConfigurationRequest.
 * Use `create(CreateSCIMConfigurationRequestSchema)` to create a new message.
 */
export const CreateSCIMConfigurationRequestSchema: GenMessage<CreateSCIMConfigurationRequest, { jsonType: CreateSCIMConfigurationRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 286);

/**
 * @generated from message identities.v1.SCIMConfiguration
 */
export type SCIMConfiguration = Message<"identities.v1.SCIMConfiguration"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string external_id = 2;
	 */
	externalId: string;

	/**
	 * @generated from field: string org_id = 3;
	 */
	orgId: string;

	/**
	 * @generated from field: string source = 4;
	 */
	source: string;

	/**
	 * @generated from field: string connection_name = 5;
	 */
	connectionName: string;

	/**
	 * @generated from field: bool sync_to_user_management = 6;
	 */
	syncToUserManagement: boolean;

	/**
	 * @generated from field: string metadata = 7;
	 */
	metadata: string;

	/**
	 * @generated from field: google.protobuf.Timestamp last_synced_at = 8;
	 */
	lastSyncedAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 9;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 10;
	 */
	updatedAt?: Timestamp | undefined;
};

/**
 * @generated from message identities.v1.SCIMConfiguration
 */
export type SCIMConfigurationJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string external_id = 2;
	 */
	externalId?: string;

	/**
	 * @generated from field: string org_id = 3;
	 */
	orgId?: string;

	/**
	 * @generated from field: string source = 4;
	 */
	source?: string;

	/**
	 * @generated from field: string connection_name = 5;
	 */
	connectionName?: string;

	/**
	 * @generated from field: bool sync_to_user_management = 6;
	 */
	syncToUserManagement?: boolean;

	/**
	 * @generated from field: string metadata = 7;
	 */
	metadata?: string;

	/**
	 * @generated from field: google.protobuf.Timestamp last_synced_at = 8;
	 */
	lastSyncedAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 9;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 10;
	 */
	updatedAt?: TimestampJson;
};

/**
 * Describes the message identities.v1.SCIMConfiguration.
 * Use `create(SCIMConfigurationSchema)` to create a new message.
 */
export const SCIMConfigurationSchema: GenMessage<SCIMConfiguration, { jsonType: SCIMConfigurationJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 287);

/**
 * @generated from message identities.v1.CreateSCIMConfigurationResponse
 */
export type CreateSCIMConfigurationResponse = Message<"identities.v1.CreateSCIMConfigurationResponse"> & {
	/**
	 * @generated from field: identities.v1.SCIMConfiguration configuration = 1;
	 */
	configuration?: SCIMConfiguration | undefined;

	/**
	 * @generated from field: string token = 2;
	 */
	token: string;

	/**
	 * @generated from field: string provisioning_url = 3;
	 */
	provisioningUrl: string;
};

/**
 * @generated from message identities.v1.CreateSCIMConfigurationResponse
 */
export type CreateSCIMConfigurationResponseJson = {
	/**
	 * @generated from field: identities.v1.SCIMConfiguration configuration = 1;
	 */
	configuration?: SCIMConfigurationJson;

	/**
	 * @generated from field: string token = 2;
	 */
	token?: string;

	/**
	 * @generated from field: string provisioning_url = 3;
	 */
	provisioningUrl?: string;
};

/**
 * Describes the message identities.v1.CreateSCIMConfigurationResponse.
 * Use `create(CreateSCIMConfigurationResponseSchema)` to create a new message.
 */
export const CreateSCIMConfigurationResponseSchema: GenMessage<CreateSCIMConfigurationResponse, { jsonType: CreateSCIMConfigurationResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 288);

/**
 * @generated from message identities.v1.DeleteSCIMConfigurationRequest
 */
export type DeleteSCIMConfigurationRequest = Message<"identities.v1.DeleteSCIMConfigurationRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;
};

/**
 * @generated from message identities.v1.DeleteSCIMConfigurationRequest
 */
export type DeleteSCIMConfigurationRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;
};

/**
 * Describes the message identities.v1.DeleteSCIMConfigurationRequest.
 * Use `create(DeleteSCIMConfigurationRequestSchema)` to create a new message.
 */
export const DeleteSCIMConfigurationRequestSchema: GenMessage<DeleteSCIMConfigurationRequest, { jsonType: DeleteSCIMConfigurationRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 289);

/**
 * @generated from message identities.v1.DeleteSCIMConfigurationResponse
 */
export type DeleteSCIMConfigurationResponse = Message<"identities.v1.DeleteSCIMConfigurationResponse"> & {};

/**
 * @generated from message identities.v1.DeleteSCIMConfigurationResponse
 */
export type DeleteSCIMConfigurationResponseJson = {};

/**
 * Describes the message identities.v1.DeleteSCIMConfigurationResponse.
 * Use `create(DeleteSCIMConfigurationResponseSchema)` to create a new message.
 */
export const DeleteSCIMConfigurationResponseSchema: GenMessage<DeleteSCIMConfigurationResponse, { jsonType: DeleteSCIMConfigurationResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 290);

/**
 * @generated from message identities.v1.ListSCIMConfigurationsRequest
 */
export type ListSCIMConfigurationsRequest = Message<"identities.v1.ListSCIMConfigurationsRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: common.v1.PaginationArguments paginate = 2;
	 */
	paginate?: PaginationArguments | undefined;
};

/**
 * @generated from message identities.v1.ListSCIMConfigurationsRequest
 */
export type ListSCIMConfigurationsRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: common.v1.PaginationArguments paginate = 2;
	 */
	paginate?: PaginationArgumentsJson;
};

/**
 * Describes the message identities.v1.ListSCIMConfigurationsRequest.
 * Use `create(ListSCIMConfigurationsRequestSchema)` to create a new message.
 */
export const ListSCIMConfigurationsRequestSchema: GenMessage<ListSCIMConfigurationsRequest, { jsonType: ListSCIMConfigurationsRequestJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 291);

/**
 * @generated from message identities.v1.ListSCIMConfigurationsResponse
 */
export type ListSCIMConfigurationsResponse = Message<"identities.v1.ListSCIMConfigurationsResponse"> & {
	/**
	 * @generated from field: repeated identities.v1.SCIMConfiguration configurations = 1;
	 */
	configurations: SCIMConfiguration[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message identities.v1.ListSCIMConfigurationsResponse
 */
export type ListSCIMConfigurationsResponseJson = {
	/**
	 * @generated from field: repeated identities.v1.SCIMConfiguration configurations = 1;
	 */
	configurations?: SCIMConfigurationJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message identities.v1.ListSCIMConfigurationsResponse.
 * Use `create(ListSCIMConfigurationsResponseSchema)` to create a new message.
 */
export const ListSCIMConfigurationsResponseSchema: GenMessage<ListSCIMConfigurationsResponse, { jsonType: ListSCIMConfigurationsResponseJson }> = /*@__PURE__*/ messageDesc(file_identities_v1_identities, 292);

/**
 * @generated from enum identities.v1.RoleType
 */
export enum RoleType {
	/**
	 * @generated from enum value: ROLE_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: ROLE_TYPE_VENDOR = 1;
	 */
	VENDOR = 1,

	/**
	 * @generated from enum value: ROLE_TYPE_CONSUMER = 2;
	 */
	CONSUMER = 2,

	/**
	 * @generated from enum value: ROLE_TYPE_ORG = 3;
	 */
	ORG = 3,

	/**
	 * @generated from enum value: ROLE_TYPE_WORKSPACE = 4;
	 */
	WORKSPACE = 4,

	/**
	 * @generated from enum value: ROLE_TYPE_TEAM = 5;
	 */
	TEAM = 5,
}

/**
 * @generated from enum identities.v1.RoleType
 */
export type RoleTypeJson = "ROLE_TYPE_UNSPECIFIED" | "ROLE_TYPE_VENDOR" | "ROLE_TYPE_CONSUMER" | "ROLE_TYPE_ORG" | "ROLE_TYPE_WORKSPACE" | "ROLE_TYPE_TEAM";

/**
 * Describes the enum identities.v1.RoleType.
 */
export const RoleTypeSchema: GenEnum<RoleType, RoleTypeJson> = /*@__PURE__*/ enumDesc(file_identities_v1_identities, 0);

/**
 * @generated from enum identities.v1.MemberType
 */
export enum MemberType {
	/**
	 * @generated from enum value: MEMBER_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: MEMBER_TYPE_TEAM = 1;
	 */
	TEAM = 1,

	/**
	 * @generated from enum value: MEMBER_TYPE_WORKSPACE = 2;
	 */
	WORKSPACE = 2,

	/**
	 * @generated from enum value: MEMBER_TYPE_ORG = 3;
	 */
	ORG = 3,
}

/**
 * @generated from enum identities.v1.MemberType
 */
export type MemberTypeJson = "MEMBER_TYPE_UNSPECIFIED" | "MEMBER_TYPE_TEAM" | "MEMBER_TYPE_WORKSPACE" | "MEMBER_TYPE_ORG";

/**
 * Describes the enum identities.v1.MemberType.
 */
export const MemberTypeSchema: GenEnum<MemberType, MemberTypeJson> = /*@__PURE__*/ enumDesc(file_identities_v1_identities, 1);

/**
 * @generated from enum identities.v1.SSOType
 */
export enum SSOType {
	/**
	 * @generated from enum value: SSO_TYPE_UNSPECIFIED = 0;
	 */
	SSO_TYPE_UNSPECIFIED = 0,

	/**
	 * @generated from enum value: SSO_TYPE_SAML = 1;
	 */
	SSO_TYPE_SAML = 1,

	/**
	 * @generated from enum value: SSO_TYPE_OIDC = 2;
	 */
	SSO_TYPE_OIDC = 2,
}

/**
 * @generated from enum identities.v1.SSOType
 */
export type SSOTypeJson = "SSO_TYPE_UNSPECIFIED" | "SSO_TYPE_SAML" | "SSO_TYPE_OIDC";

/**
 * Describes the enum identities.v1.SSOType.
 */
export const SSOTypeSchema: GenEnum<SSOType, SSOTypeJson> = /*@__PURE__*/ enumDesc(file_identities_v1_identities, 2);

/**
 * @generated from enum identities.v1.AccessRequestType
 */
export enum AccessRequestType {
	/**
	 * @generated from enum value: ACCESS_REQUEST_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: ACCESS_REQUEST_TYPE_CORP = 1;
	 */
	CORP = 1,

	/**
	 * @generated from enum value: ACCESS_REQUEST_TYPE_ORG = 2;
	 */
	ORG = 2,
}

/**
 * @generated from enum identities.v1.AccessRequestType
 */
export type AccessRequestTypeJson = "ACCESS_REQUEST_TYPE_UNSPECIFIED" | "ACCESS_REQUEST_TYPE_CORP" | "ACCESS_REQUEST_TYPE_ORG";

/**
 * Describes the enum identities.v1.AccessRequestType.
 */
export const AccessRequestTypeSchema: GenEnum<AccessRequestType, AccessRequestTypeJson> = /*@__PURE__*/ enumDesc(file_identities_v1_identities, 3);

/**
 * OrgStatus represents the database status an organization can be in
 *
 * @generated from enum identities.v1.OrgStatus
 */
export enum OrgStatus {
	/**
	 * @generated from enum value: ORG_STATUS_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: ORG_STATUS_ACTIVE = 1;
	 */
	ACTIVE = 1,

	/**
	 * @generated from enum value: ORG_STATUS_TRIALING = 2;
	 */
	TRIALING = 2,

	/**
	 * @generated from enum value: ORG_STATUS_CHURNED = 3;
	 */
	CHURNED = 3,

	/**
	 * @generated from enum value: ORG_STATUS_DEMO = 4;
	 */
	DEMO = 4,

	/**
	 * @generated from enum value: ORG_STATUS_INACTIVE = 5;
	 */
	INACTIVE = 5,
}

/**
 * OrgStatus represents the database status an organization can be in
 *
 * @generated from enum identities.v1.OrgStatus
 */
export type OrgStatusJson = "ORG_STATUS_UNSPECIFIED" | "ORG_STATUS_ACTIVE" | "ORG_STATUS_TRIALING" | "ORG_STATUS_CHURNED" | "ORG_STATUS_DEMO" | "ORG_STATUS_INACTIVE";

/**
 * Describes the enum identities.v1.OrgStatus.
 */
export const OrgStatusSchema: GenEnum<OrgStatus, OrgStatusJson> = /*@__PURE__*/ enumDesc(file_identities_v1_identities, 4);

/**
 * OrgSetupStatus represents the state of the org setup process for the org
 *
 * @generated from enum identities.v1.OrgSetupStatus
 */
export enum OrgSetupStatus {
	/**
	 * @generated from enum value: ORG_SETUP_STATUS_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: ORG_SETUP_STATUS_PENDING = 1;
	 */
	PENDING = 1,

	/**
	 * @generated from enum value: ORG_SETUP_STATUS_COMPLETE = 2;
	 */
	COMPLETE = 2,
}

/**
 * OrgSetupStatus represents the state of the org setup process for the org
 *
 * @generated from enum identities.v1.OrgSetupStatus
 */
export type OrgSetupStatusJson = "ORG_SETUP_STATUS_UNSPECIFIED" | "ORG_SETUP_STATUS_PENDING" | "ORG_SETUP_STATUS_COMPLETE";

/**
 * Describes the enum identities.v1.OrgSetupStatus.
 */
export const OrgSetupStatusSchema: GenEnum<OrgSetupStatus, OrgSetupStatusJson> = /*@__PURE__*/ enumDesc(file_identities_v1_identities, 5);

/**
 * @generated from enum identities.v1.OrgInviteStatus
 */
export enum OrgInviteStatus {
	/**
	 * @generated from enum value: ORG_INVITE_STATUS_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: ORG_INVITE_STATUS_ACTIVATED = 1;
	 */
	ACTIVATED = 1,

	/**
	 * @generated from enum value: ORG_INVITE_STATUS_PENDING_ACCEPTANCE = 2;
	 */
	PENDING_ACCEPTANCE = 2,
}

/**
 * @generated from enum identities.v1.OrgInviteStatus
 */
export type OrgInviteStatusJson = "ORG_INVITE_STATUS_UNSPECIFIED" | "ORG_INVITE_STATUS_ACTIVATED" | "ORG_INVITE_STATUS_PENDING_ACCEPTANCE";

/**
 * Describes the enum identities.v1.OrgInviteStatus.
 */
export const OrgInviteStatusSchema: GenEnum<OrgInviteStatus, OrgInviteStatusJson> = /*@__PURE__*/ enumDesc(file_identities_v1_identities, 6);

/**
 * WorkspaceVisiblity represents visibility on a workspace
 *
 * @generated from enum identities.v1.WorkspaceVisibility
 */
export enum WorkspaceVisibility {
	/**
	 * @generated from enum value: WORKSPACE_VISIBILITY_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: WORKSPACE_VISIBILITY_PUBLIC = 1;
	 */
	PUBLIC = 1,

	/**
	 * @generated from enum value: WORKSPACE_VISIBILITY_PERSONAL = 2;
	 */
	PERSONAL = 2,
}

/**
 * WorkspaceVisiblity represents visibility on a workspace
 *
 * @generated from enum identities.v1.WorkspaceVisibility
 */
export type WorkspaceVisibilityJson = "WORKSPACE_VISIBILITY_UNSPECIFIED" | "WORKSPACE_VISIBILITY_PUBLIC" | "WORKSPACE_VISIBILITY_PERSONAL";

/**
 * Describes the enum identities.v1.WorkspaceVisibility.
 */
export const WorkspaceVisibilitySchema: GenEnum<WorkspaceVisibility, WorkspaceVisibilityJson> = /*@__PURE__*/ enumDesc(file_identities_v1_identities, 7);

/**
 * MemberStatus represents the database status an organization can be in
 *
 * @generated from enum identities.v1.MemberStatus
 */
export enum MemberStatus {
	/**
	 * @generated from enum value: MEMBER_STATUS_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: MEMBER_STATUS_INTERNAL = 1;
	 */
	INTERNAL = 1,

	/**
	 * @generated from enum value: MEMBER_STATUS_EXTERNAL = 2;
	 */
	EXTERNAL = 2,
}

/**
 * MemberStatus represents the database status an organization can be in
 *
 * @generated from enum identities.v1.MemberStatus
 */
export type MemberStatusJson = "MEMBER_STATUS_UNSPECIFIED" | "MEMBER_STATUS_INTERNAL" | "MEMBER_STATUS_EXTERNAL";

/**
 * Describes the enum identities.v1.MemberStatus.
 */
export const MemberStatusSchema: GenEnum<MemberStatus, MemberStatusJson> = /*@__PURE__*/ enumDesc(file_identities_v1_identities, 8);

/**
 * OrgPlan represents the changed orgs new plan type
 *
 * @generated from enum identities.v1.OrgPlan
 */
export enum OrgPlan {
	/**
	 * @generated from enum value: ORG_PLAN_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: ORG_PLAN_PERSONAL = 1;
	 */
	PERSONAL = 1,

	/**
	 * @generated from enum value: ORG_PLAN_PRO_PLUS = 2;
	 */
	PRO_PLUS = 2,

	/**
	 * @generated from enum value: ORG_PLAN_PRO_FLEX = 3;
	 */
	PRO_FLEX = 3,

	/**
	 * @generated from enum value: ORG_PLAN_ENTERPRISE = 4;
	 */
	ENTERPRISE = 4,
}

/**
 * OrgPlan represents the changed orgs new plan type
 *
 * @generated from enum identities.v1.OrgPlan
 */
export type OrgPlanJson = "ORG_PLAN_UNSPECIFIED" | "ORG_PLAN_PERSONAL" | "ORG_PLAN_PRO_PLUS" | "ORG_PLAN_PRO_FLEX" | "ORG_PLAN_ENTERPRISE";

/**
 * Describes the enum identities.v1.OrgPlan.
 */
export const OrgPlanSchema: GenEnum<OrgPlan, OrgPlanJson> = /*@__PURE__*/ enumDesc(file_identities_v1_identities, 9);

/**
 * @generated from enum identities.v1.RoleCategory
 */
export enum RoleCategory {
	/**
	 * @generated from enum value: ROLE_CATEGORY_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: ROLE_CATEGORY_GENERAL = 1;
	 */
	GENERAL = 1,

	/**
	 * @generated from enum value: ROLE_CATEGORY_FLOWS = 2;
	 */
	FLOWS = 2,

	/**
	 * @generated from enum value: ROLE_CATEGORY_BRANDING = 3;
	 */
	BRANDING = 3,

	/**
	 * @generated from enum value: ROLE_CATEGORY_AUDIENCE = 4;
	 */
	AUDIENCE = 4,

	/**
	 * @generated from enum value: ROLE_CATEGORY_CONSUMER = 5;
	 */
	CONSUMER = 5,
}

/**
 * @generated from enum identities.v1.RoleCategory
 */
export type RoleCategoryJson = "ROLE_CATEGORY_UNSPECIFIED" | "ROLE_CATEGORY_GENERAL" | "ROLE_CATEGORY_FLOWS" | "ROLE_CATEGORY_BRANDING" | "ROLE_CATEGORY_AUDIENCE" | "ROLE_CATEGORY_CONSUMER";

/**
 * Describes the enum identities.v1.RoleCategory.
 */
export const RoleCategorySchema: GenEnum<RoleCategory, RoleCategoryJson> = /*@__PURE__*/ enumDesc(file_identities_v1_identities, 10);

/**
 * InvitationType represents the method at which the inviation was sent
 *
 * @generated from enum identities.v1.InvitationType
 */
export enum InvitationType {
	/**
	 * @generated from enum value: INVITATION_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: INVITATION_TYPE_ORG = 1;
	 */
	ORG = 1,

	/**
	 * @generated from enum value: INVITATION_TYPE_WORKSPACE = 2;
	 */
	WORKSPACE = 2,

	/**
	 * @generated from enum value: INVITATION_TYPE_TEAM = 3;
	 */
	TEAM = 3,
}

/**
 * InvitationType represents the method at which the inviation was sent
 *
 * @generated from enum identities.v1.InvitationType
 */
export type InvitationTypeJson = "INVITATION_TYPE_UNSPECIFIED" | "INVITATION_TYPE_ORG" | "INVITATION_TYPE_WORKSPACE" | "INVITATION_TYPE_TEAM";

/**
 * Describes the enum identities.v1.InvitationType.
 */
export const InvitationTypeSchema: GenEnum<InvitationType, InvitationTypeJson> = /*@__PURE__*/ enumDesc(file_identities_v1_identities, 11);

/**
 * InvitationStatus represents the state an inviation can be in
 *
 * @generated from enum identities.v1.InvitationStatus
 */
export enum InvitationStatus {
	/**
	 * @generated from enum value: INVITATION_STATUS_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: INVITATION_STATUS_PENDING = 1;
	 */
	PENDING = 1,

	/**
	 * @generated from enum value: INVITATION_STATUS_ACCEPTED = 2;
	 */
	ACCEPTED = 2,

	/**
	 * @generated from enum value: INVITATION_STATUS_EXPIRED = 3;
	 */
	EXPIRED = 3,

	/**
	 * @generated from enum value: INVITATION_STATUS_RUNNING = 4;
	 */
	RUNNING = 4,

	/**
	 * @generated from enum value: INVITATION_STATUS_FAILED = 5;
	 */
	FAILED = 5,

	/**
	 * @generated from enum value: INVITATION_STATUS_COMPLETED = 6;
	 */
	COMPLETED = 6,
}

/**
 * InvitationStatus represents the state an inviation can be in
 *
 * @generated from enum identities.v1.InvitationStatus
 */
export type InvitationStatusJson = "INVITATION_STATUS_UNSPECIFIED" | "INVITATION_STATUS_PENDING" | "INVITATION_STATUS_ACCEPTED" | "INVITATION_STATUS_EXPIRED" | "INVITATION_STATUS_RUNNING" | "INVITATION_STATUS_FAILED" | "INVITATION_STATUS_COMPLETED";

/**
 * Describes the enum identities.v1.InvitationStatus.
 */
export const InvitationStatusSchema: GenEnum<InvitationStatus, InvitationStatusJson> = /*@__PURE__*/ enumDesc(file_identities_v1_identities, 12);

/**
 * ExpirationChoices configure how long the invitation is valid for
 *
 * @generated from enum identities.v1.ExpirationChoices
 */
export enum ExpirationChoices {
	/**
	 * @generated from enum value: EXPIRATION_CHOICES_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: EXPIRATION_CHOICES_ONE_DAY = 1;
	 */
	ONE_DAY = 1,

	/**
	 * @generated from enum value: EXPIRATION_CHOICES_FIVE_DAY = 2;
	 */
	FIVE_DAY = 2,

	/**
	 * @generated from enum value: EXPIRATION_CHOICES_THIRTY_DAY = 3;
	 */
	THIRTY_DAY = 3,
}

/**
 * ExpirationChoices configure how long the invitation is valid for
 *
 * @generated from enum identities.v1.ExpirationChoices
 */
export type ExpirationChoicesJson = "EXPIRATION_CHOICES_UNSPECIFIED" | "EXPIRATION_CHOICES_ONE_DAY" | "EXPIRATION_CHOICES_FIVE_DAY" | "EXPIRATION_CHOICES_THIRTY_DAY";

/**
 * Describes the enum identities.v1.ExpirationChoices.
 */
export const ExpirationChoicesSchema: GenEnum<ExpirationChoices, ExpirationChoicesJson> = /*@__PURE__*/ enumDesc(file_identities_v1_identities, 13);

/**
 * @generated from enum identities.v1.TeamManagedBy
 */
export enum TeamManagedBy {
	/**
	 * @generated from enum value: TEAM_MANAGED_BY_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: TEAM_MANAGED_BY_FLOWCODE = 1;
	 */
	FLOWCODE = 1,

	/**
	 * @generated from enum value: TEAM_MANAGED_BY_SCIM = 2;
	 */
	SCIM = 2,
}

/**
 * @generated from enum identities.v1.TeamManagedBy
 */
export type TeamManagedByJson = "TEAM_MANAGED_BY_UNSPECIFIED" | "TEAM_MANAGED_BY_FLOWCODE" | "TEAM_MANAGED_BY_SCIM";

/**
 * Describes the enum identities.v1.TeamManagedBy.
 */
export const TeamManagedBySchema: GenEnum<TeamManagedBy, TeamManagedByJson> = /*@__PURE__*/ enumDesc(file_identities_v1_identities, 14);

/**
 * @generated from enum identities.v1.SharedWorkspaceSetupStatus
 */
export enum SharedWorkspaceSetupStatus {
	/**
	 * @generated from enum value: SHARED_WORKSPACE_SETUP_STATUS_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * The setup has been initiated by the sharer and is awaiting the recipient
	 * to choose their target org and submit their configuration.
	 *
	 * @generated from enum value: SHARED_WORKSPACE_SETUP_STATUS_PENDING_RECIPIENT_CONFIGURATION = 1;
	 */
	PENDING_RECIPIENT_CONFIGURATION = 1,

	/**
	 * The recipient has submitted their configuration and the sharer must
	 * review and confirm before the connection is created.
	 *
	 * @generated from enum value: SHARED_WORKSPACE_SETUP_STATUS_PENDING_SHARER_CONFIRMATION = 2;
	 */
	PENDING_SHARER_CONFIRMATION = 2,

	/**
	 * The sharer has confirmed and a SharedWorkspaceConnection has been created.
	 *
	 * @generated from enum value: SHARED_WORKSPACE_SETUP_STATUS_COMPLETED = 3;
	 */
	COMPLETED = 3,

	/**
	 * The setup was cancelled by either party before completion.
	 *
	 * @generated from enum value: SHARED_WORKSPACE_SETUP_STATUS_CANCELLED = 4;
	 */
	CANCELLED = 4,
}

/**
 * @generated from enum identities.v1.SharedWorkspaceSetupStatus
 */
export type SharedWorkspaceSetupStatusJson = "SHARED_WORKSPACE_SETUP_STATUS_UNSPECIFIED" | "SHARED_WORKSPACE_SETUP_STATUS_PENDING_RECIPIENT_CONFIGURATION" | "SHARED_WORKSPACE_SETUP_STATUS_PENDING_SHARER_CONFIRMATION" | "SHARED_WORKSPACE_SETUP_STATUS_COMPLETED" | "SHARED_WORKSPACE_SETUP_STATUS_CANCELLED";

/**
 * Describes the enum identities.v1.SharedWorkspaceSetupStatus.
 */
export const SharedWorkspaceSetupStatusSchema: GenEnum<SharedWorkspaceSetupStatus, SharedWorkspaceSetupStatusJson> = /*@__PURE__*/ enumDesc(file_identities_v1_identities, 15);

/**
 * @generated from enum identities.v1.SharedWorkspaceConnectionStatus
 */
export enum SharedWorkspaceConnectionStatus {
	/**
	 * @generated from enum value: SHARED_WORKSPACE_CONNECTION_STATUS_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * The connection is live and sharing data between the workspaces.
	 *
	 * @generated from enum value: SHARED_WORKSPACE_CONNECTION_STATUS_ACTIVE = 1;
	 */
	ACTIVE = 1,

	/**
	 * The connection has been torn down by either party and no longer shares data.
	 *
	 * @generated from enum value: SHARED_WORKSPACE_CONNECTION_STATUS_TERMINATED = 2;
	 */
	TERMINATED = 2,
}

/**
 * @generated from enum identities.v1.SharedWorkspaceConnectionStatus
 */
export type SharedWorkspaceConnectionStatusJson = "SHARED_WORKSPACE_CONNECTION_STATUS_UNSPECIFIED" | "SHARED_WORKSPACE_CONNECTION_STATUS_ACTIVE" | "SHARED_WORKSPACE_CONNECTION_STATUS_TERMINATED";

/**
 * Describes the enum identities.v1.SharedWorkspaceConnectionStatus.
 */
export const SharedWorkspaceConnectionStatusSchema: GenEnum<SharedWorkspaceConnectionStatus, SharedWorkspaceConnectionStatusJson> = /*@__PURE__*/ enumDesc(file_identities_v1_identities, 16);

/**
 * IdentityService
 *
 * @generated from service identities.v1.IdentitiesService
 */
export const IdentitiesService: GenService<{
	/**
	 * User RPCS
	 *
	 * @generated from rpc identities.v1.IdentitiesService.GetUser
	 */
	getUser: {
		methodKind: "unary";
		input: typeof GetUserRequestSchema;
		output: typeof GetUserResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.GetUsersByIds
	 */
	getUsersByIds: {
		methodKind: "unary";
		input: typeof GetUsersByIdsRequestSchema;
		output: typeof GetUsersByIdsResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.GetUserExists
	 */
	getUserExists: {
		methodKind: "unary";
		input: typeof GetUserExistsRequestSchema;
		output: typeof GetUserExistsResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.ListUsers
	 */
	listUsers: {
		methodKind: "unary";
		input: typeof ListUsersRequestSchema;
		output: typeof ListUsersResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.ListAdminUsers
	 */
	listAdminUsers: {
		methodKind: "unary";
		input: typeof ListAdminUsersRequestSchema;
		output: typeof ListAdminUsersResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.ListUserCandidates
	 */
	listUserCandidates: {
		methodKind: "unary";
		input: typeof ListUserCandidatesRequestSchema;
		output: typeof ListUserCandidatesResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.ListUsersWithAccess
	 */
	listUsersWithAccess: {
		methodKind: "unary";
		input: typeof ListUsersWithAccessRequestSchema;
		output: typeof ListUsersWithAccessResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.CreateUser
	 */
	createUser: {
		methodKind: "unary";
		input: typeof CreateUserRequestSchema;
		output: typeof CreateUserResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.CreateOrUpdateUser
	 */
	createOrUpdateUser: {
		methodKind: "unary";
		input: typeof CreateOrUpdateUserRequestSchema;
		output: typeof CreateOrUpdateUserResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.DeleteUser
	 */
	deleteUser: {
		methodKind: "unary";
		input: typeof DeleteUserRequestSchema;
		output: typeof DeleteUserResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.UpdateUser
	 */
	updateUser: {
		methodKind: "unary";
		input: typeof UpdateUserRequestSchema;
		output: typeof UpdateUserResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.GetOrg
	 */
	getOrg: {
		methodKind: "unary";
		input: typeof GetOrgRequestSchema;
		output: typeof GetOrgResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.GetAdminOrg
	 */
	getAdminOrg: {
		methodKind: "unary";
		input: typeof GetAdminOrgRequestSchema;
		output: typeof GetAdminOrgResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.ListOrgs
	 */
	listOrgs: {
		methodKind: "unary";
		input: typeof ListOrgsRequestSchema;
		output: typeof ListOrgsResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.ListAdminOrgs
	 */
	listAdminOrgs: {
		methodKind: "unary";
		input: typeof ListAdminOrgsRequestSchema;
		output: typeof ListAdminOrgsResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.CreateOrg
	 */
	createOrg: {
		methodKind: "unary";
		input: typeof CreateOrgRequestSchema;
		output: typeof CreateOrgResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.DeleteOrg
	 */
	deleteOrg: {
		methodKind: "unary";
		input: typeof DeleteOrgRequestSchema;
		output: typeof DeleteOrgResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.RemoveOrgMember
	 */
	removeOrgMember: {
		methodKind: "unary";
		input: typeof RemoveOrgMemberRequestSchema;
		output: typeof RemoveOrgMemberResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.UpdateOrg
	 */
	updateOrg: {
		methodKind: "unary";
		input: typeof UpdateOrgRequestSchema;
		output: typeof UpdateOrgResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.AddOrgMember
	 */
	addOrgMember: {
		methodKind: "unary";
		input: typeof AddOrgMemberRequestSchema;
		output: typeof AddOrgMemberResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.ListWorkspaces
	 */
	listWorkspaces: {
		methodKind: "unary";
		input: typeof ListWorkspacesRequestSchema;
		output: typeof ListWorkspacesResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.ListWorkspacesByOrg
	 */
	listWorkspacesByOrg: {
		methodKind: "unary";
		input: typeof ListWorkspacesByOrgRequestSchema;
		output: typeof ListWorkspacesByOrgResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.ListWorkspaceTeams
	 */
	listWorkspaceTeams: {
		methodKind: "unary";
		input: typeof ListWorkspaceTeamsRequestSchema;
		output: typeof ListWorkspaceTeamsResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.ListWorkspaceTeamAssignments
	 */
	listWorkspaceTeamAssignments: {
		methodKind: "unary";
		input: typeof ListWorkspaceTeamAssignmentsRequestSchema;
		output: typeof ListWorkspaceTeamAssignmentsResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.ListTeamCandidates
	 */
	listTeamCandidates: {
		methodKind: "unary";
		input: typeof ListTeamCandidatesRequestSchema;
		output: typeof ListTeamCandidatesResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.GetWorkspace
	 */
	getWorkspace: {
		methodKind: "unary";
		input: typeof GetWorkspaceRequestSchema;
		output: typeof GetWorkspaceResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.GetWorkspacesByIds
	 */
	getWorkspacesByIds: {
		methodKind: "unary";
		input: typeof GetWorkspacesByIdsRequestSchema;
		output: typeof GetWorkspacesByIdsResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.GetDefaultWorkspace
	 */
	getDefaultWorkspace: {
		methodKind: "unary";
		input: typeof GetDefaultWorkspaceRequestSchema;
		output: typeof GetDefaultWorkspaceResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.CreateWorkspace
	 */
	createWorkspace: {
		methodKind: "unary";
		input: typeof CreateWorkspaceRequestSchema;
		output: typeof CreateWorkspaceResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.DeleteWorkspace
	 */
	deleteWorkspace: {
		methodKind: "unary";
		input: typeof DeleteWorkspaceRequestSchema;
		output: typeof DeleteWorkspaceResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.UpdateWorkspace
	 */
	updateWorkspace: {
		methodKind: "unary";
		input: typeof UpdateWorkspaceRequestSchema;
		output: typeof UpdateWorkspaceResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.RemoveWorkspaceMember
	 */
	removeWorkspaceMember: {
		methodKind: "unary";
		input: typeof RemoveWorkspaceMemberRequestSchema;
		output: typeof RemoveWorkspaceMemberResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.RemoveUserFromWorkspaces
	 */
	removeUserFromWorkspaces: {
		methodKind: "unary";
		input: typeof RemoveUserFromWorkspacesRequestSchema;
		output: typeof RemoveUserFromWorkspacesResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.AddWorkspaceMember
	 */
	addWorkspaceMember: {
		methodKind: "unary";
		input: typeof AddWorkspaceMemberRequestSchema;
		output: typeof AddWorkspaceMemberResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.AssignTeam
	 */
	assignTeam: {
		methodKind: "unary";
		input: typeof AssignTeamRequestSchema;
		output: typeof AssignTeamResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.UnassignTeam
	 */
	unassignTeam: {
		methodKind: "unary";
		input: typeof UnassignTeamRequestSchema;
		output: typeof UnassignTeamResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.UpdateAssignTeam
	 */
	updateAssignTeam: {
		methodKind: "unary";
		input: typeof UpdateAssignTeamRequestSchema;
		output: typeof UpdateAssignTeamResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.ListMembers
	 */
	listMembers: {
		methodKind: "unary";
		input: typeof ListMembersRequestSchema;
		output: typeof ListMembersResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.DeleteMember
	 */
	deleteMember: {
		methodKind: "unary";
		input: typeof DeleteMemberRequestSchema;
		output: typeof DeleteMemberResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.CreateInvitation
	 * @deprecated
	 */
	createInvitation: {
		methodKind: "unary";
		input: typeof CreateInvitationRequestSchema;
		output: typeof CreateInvitationResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.CreateInvitationV2Org
	 */
	createInvitationV2Org: {
		methodKind: "unary";
		input: typeof CreateInvitationV2OrgRequestSchema;
		output: typeof CreateInvitationV2OrgResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.CreateInvitationV2Workspace
	 */
	createInvitationV2Workspace: {
		methodKind: "unary";
		input: typeof CreateInvitationV2WorkspaceRequestSchema;
		output: typeof CreateInvitationV2WorkspaceResponseSchema;
	};
	/**
	 * This is just to keep paridy with what ithaca does, in most systems the way invitations
	 * work is an inviation is generated with an inviteToken and then is used as a queryParam
	 * to the signup endpoint
	 *
	 * @generated from rpc identities.v1.IdentitiesService.AcceptInvitation
	 */
	acceptInvitation: {
		methodKind: "unary";
		input: typeof AcceptInvitationRequestSchema;
		output: typeof AcceptInvitationResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.GetInvitation
	 */
	getInvitation: {
		methodKind: "unary";
		input: typeof GetInvitationRequestSchema;
		output: typeof GetInvitationResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.ListInvitations
	 */
	listInvitations: {
		methodKind: "unary";
		input: typeof ListInvitationsRequestSchema;
		output: typeof ListInvitationsResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.CreateRole
	 */
	createRole: {
		methodKind: "unary";
		input: typeof CreateRoleRequestSchema;
		output: typeof CreateRoleResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.UpdateRole
	 */
	updateRole: {
		methodKind: "unary";
		input: typeof UpdateRoleRequestSchema;
		output: typeof UpdateRoleResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.ListRoles
	 */
	listRoles: {
		methodKind: "unary";
		input: typeof ListRolesRequestSchema;
		output: typeof ListRolesResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.CreateTeam
	 */
	createTeam: {
		methodKind: "unary";
		input: typeof CreateTeamRequestSchema;
		output: typeof CreateTeamResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.GetTeam
	 */
	getTeam: {
		methodKind: "unary";
		input: typeof GetTeamRequestSchema;
		output: typeof GetTeamResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.ListTeams
	 */
	listTeams: {
		methodKind: "unary";
		input: typeof ListTeamsRequestSchema;
		output: typeof ListTeamsResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.UpdateTeam
	 */
	updateTeam: {
		methodKind: "unary";
		input: typeof UpdateTeamRequestSchema;
		output: typeof UpdateTeamResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.DeleteTeam
	 */
	deleteTeam: {
		methodKind: "unary";
		input: typeof DeleteTeamRequestSchema;
		output: typeof DeleteTeamResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.RemoveTeamMember
	 */
	removeTeamMember: {
		methodKind: "unary";
		input: typeof RemoveTeamMemberRequestSchema;
		output: typeof RemoveTeamMemberResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.UpdateMember
	 */
	updateMember: {
		methodKind: "unary";
		input: typeof UpdateMemberRequestSchema;
		output: typeof UpdateMemberResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.AddTeamMember
	 */
	addTeamMember: {
		methodKind: "unary";
		input: typeof AddTeamMemberRequestSchema;
		output: typeof AddTeamMemberResponseSchema;
	};
	/**
	 * External User RPC
	 *
	 * @generated from rpc identities.v1.IdentitiesService.GetExternalUser
	 */
	getExternalUser: {
		methodKind: "unary";
		input: typeof GetExternalUserRequestSchema;
		output: typeof GetExternalUserResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.ListExternalUsers
	 */
	listExternalUsers: {
		methodKind: "unary";
		input: typeof ListExternalUsersRequestSchema;
		output: typeof ListExternalUsersResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.CreateExternalUser
	 */
	createExternalUser: {
		methodKind: "unary";
		input: typeof CreateExternalUserRequestSchema;
		output: typeof CreateExternalUserResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.DeleteExternalUser
	 */
	deleteExternalUser: {
		methodKind: "unary";
		input: typeof DeleteExternalUserRequestSchema;
		output: typeof DeleteExternalUserResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.CreateTempAccess
	 */
	createTempAccess: {
		methodKind: "unary";
		input: typeof CreateTempAccessRequestSchema;
		output: typeof CreateTempAccessResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.GetTempAccess
	 */
	getTempAccess: {
		methodKind: "unary";
		input: typeof GetTempAccessRequestSchema;
		output: typeof GetTempAccessResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.ListTempAccess
	 */
	listTempAccess: {
		methodKind: "unary";
		input: typeof ListTempAccessRequestSchema;
		output: typeof ListTempAccessResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.DeleteTempAccess
	 */
	deleteTempAccess: {
		methodKind: "unary";
		input: typeof DeleteTempAccessRequestSchema;
		output: typeof DeleteTempAccessResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.CreateSSOConfiguration
	 */
	createSSOConfiguration: {
		methodKind: "unary";
		input: typeof CreateSSOConfigurationRequestSchema;
		output: typeof CreateSSOConfigurationResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.CreateSCIMConfiguration
	 */
	createSCIMConfiguration: {
		methodKind: "unary";
		input: typeof CreateSCIMConfigurationRequestSchema;
		output: typeof CreateSCIMConfigurationResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.ListSCIMConfigurations
	 */
	listSCIMConfigurations: {
		methodKind: "unary";
		input: typeof ListSCIMConfigurationsRequestSchema;
		output: typeof ListSCIMConfigurationsResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.DeleteSCIMConfiguration
	 */
	deleteSCIMConfiguration: {
		methodKind: "unary";
		input: typeof DeleteSCIMConfigurationRequestSchema;
		output: typeof DeleteSCIMConfigurationResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.CreateSSOGroup
	 */
	createSSOGroup: {
		methodKind: "unary";
		input: typeof CreateSSOGroupRequestSchema;
		output: typeof CreateSSOGroupResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.SetSSODefaultRole
	 */
	setSSODefaultRole: {
		methodKind: "unary";
		input: typeof SetSSODefaultRoleRequestSchema;
		output: typeof SetSSODefaultRoleResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.CreateSSODomain
	 */
	createSSODomain: {
		methodKind: "unary";
		input: typeof CreateSSODomainRequestSchema;
		output: typeof CreateSSODomainResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.DeleteSSOGroup
	 */
	deleteSSOGroup: {
		methodKind: "unary";
		input: typeof DeleteSSOGroupRequestSchema;
		output: typeof DeleteSSOGroupResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.DeleteSSOConfiguration
	 */
	deleteSSOConfiguration: {
		methodKind: "unary";
		input: typeof DeleteSSOConfigurationRequestSchema;
		output: typeof DeleteSSOConfigurationResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.DeleteSSODomain
	 */
	deleteSSODomain: {
		methodKind: "unary";
		input: typeof DeleteSSODomainRequestSchema;
		output: typeof DeleteSSODomainResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.UpdateSSOConfiguration
	 */
	updateSSOConfiguration: {
		methodKind: "unary";
		input: typeof UpdateSSOConfigurationRequestSchema;
		output: typeof UpdateSSOConfigurationResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.ListSSOConfigurations
	 */
	listSSOConfigurations: {
		methodKind: "unary";
		input: typeof ListSSOConfigurationsRequestSchema;
		output: typeof ListSSOConfigurationsResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.UpdateSSOGroup
	 */
	updateSSOGroup: {
		methodKind: "unary";
		input: typeof UpdateSSOGroupRequestSchema;
		output: typeof UpdateSSOGroupResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.ValidateSSODomain
	 */
	validateSSODomain: {
		methodKind: "unary";
		input: typeof ValidateSSODomainRequestSchema;
		output: typeof ValidateSSODomainResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.GetSSOGroup
	 */
	getSSOGroup: {
		methodKind: "unary";
		input: typeof GetSSOGroupRequestSchema;
		output: typeof GetSSOGroupResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.GetSSOConfiguration
	 */
	getSSOConfiguration: {
		methodKind: "unary";
		input: typeof GetSSOConfigurationRequestSchema;
		output: typeof GetSSOConfigurationResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.CreateActivationLink
	 */
	createActivationLink: {
		methodKind: "unary";
		input: typeof CreateActivationLinkRequestSchema;
		output: typeof CreateActivationLinkResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.GetAllowedRoles
	 */
	getAllowedRoles: {
		methodKind: "unary";
		input: typeof GetAllowedRolesRequestSchema;
		output: typeof GetAllowedRolesResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.CreateResendInvitation
	 */
	createResendInvitation: {
		methodKind: "unary";
		input: typeof CreateResendInvitationRequestSchema;
		output: typeof CreateResendInvitationResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.GetIndustryVertical
	 */
	getIndustryVertical: {
		methodKind: "unary";
		input: typeof GetIndustryVerticalRequestSchema;
		output: typeof GetIndustryVerticalResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.ListIndustryVerticals
	 */
	listIndustryVerticals: {
		methodKind: "unary";
		input: typeof ListIndustryVerticalsRequestSchema;
		output: typeof ListIndustryVerticalsResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.CreateCorp
	 */
	createCorp: {
		methodKind: "unary";
		input: typeof CreateCorpRequestSchema;
		output: typeof CreateCorpResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.GetCorp
	 */
	getCorp: {
		methodKind: "unary";
		input: typeof GetCorpRequestSchema;
		output: typeof GetCorpResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.DeleteCorp
	 */
	deleteCorp: {
		methodKind: "unary";
		input: typeof DeleteCorpRequestSchema;
		output: typeof DeleteCorpResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.ListCorpOrgs
	 */
	listCorpOrgs: {
		methodKind: "unary";
		input: typeof ListCorpOrgsRequestSchema;
		output: typeof ListCorpOrgsResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.ListCorps
	 */
	listCorps: {
		methodKind: "unary";
		input: typeof ListCorpsRequestSchema;
		output: typeof ListCorpsResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.ListMyCorps
	 */
	listMyCorps: {
		methodKind: "unary";
		input: typeof ListMyCorpsRequestSchema;
		output: typeof ListMyCorpsResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.IsCorp
	 */
	isCorp: {
		methodKind: "unary";
		input: typeof IsCorpRequestSchema;
		output: typeof IsCorpResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.UpdateCorp
	 */
	updateCorp: {
		methodKind: "unary";
		input: typeof UpdateCorpRequestSchema;
		output: typeof UpdateCorpResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.AssignOrgToCorp
	 */
	assignOrgToCorp: {
		methodKind: "unary";
		input: typeof AssignOrgToCorpRequestSchema;
		output: typeof AssignOrgToCorpResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.RemoveOrgToCorp
	 */
	removeOrgToCorp: {
		methodKind: "unary";
		input: typeof RemoveOrgToCorpRequestSchema;
		output: typeof RemoveOrgToCorpResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.AddCorpMember
	 */
	addCorpMember: {
		methodKind: "unary";
		input: typeof AddCorpMemberRequestSchema;
		output: typeof AddCorpMemberResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.RemoveCorpMember
	 */
	removeCorpMember: {
		methodKind: "unary";
		input: typeof RemoveCorpMemberRequestSchema;
		output: typeof RemoveCorpMemberResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.ListCorpUsers
	 */
	listCorpUsers: {
		methodKind: "unary";
		input: typeof ListCorpUsersRequestSchema;
		output: typeof ListCorpUsersResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.UpdateInvitationHook
	 */
	updateInvitationHook: {
		methodKind: "unary";
		input: typeof UpdateInvitationHookRequestSchema;
		output: typeof UpdateInvitationHookResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.InviteCreatedPrehook
	 */
	inviteCreatedPrehook: {
		methodKind: "unary";
		input: typeof InviteCreatedPrehookRequestSchema;
		output: typeof InviteCreatedPrehookResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.ListPendingOrProvisioningInvitations
	 */
	listPendingOrProvisioningInvitations: {
		methodKind: "unary";
		input: typeof ListPendingOrProvisioningInvitationsRequestSchema;
		output: typeof ListPendingOrProvisioningInvitationsResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.ListUserPreferences
	 */
	listUserPreferences: {
		methodKind: "unary";
		input: typeof ListUserPreferencesRequestSchema;
		output: typeof ListUserPreferencesResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.SetUserPreference
	 */
	setUserPreference: {
		methodKind: "unary";
		input: typeof SetUserPreferenceRequestSchema;
		output: typeof SetUserPreferenceResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.SCIMHook
	 */
	sCIMHook: {
		methodKind: "unary";
		input: typeof SCIMHookRequestSchema;
		output: typeof SCIMHookResponseSchema;
	};
	/**
	 * Step 1: sharer admin initiates the setup and invites the recipient.
	 *
	 * @generated from rpc identities.v1.IdentitiesService.CreateSharedWorkspaceSetup
	 */
	createSharedWorkspaceSetup: {
		methodKind: "unary";
		input: typeof CreateSharedWorkspaceSetupRequestSchema;
		output: typeof CreateSharedWorkspaceSetupResponseSchema;
	};
	/**
	 * Step 2: recipient chooses target org and submits configuration.
	 *
	 * @generated from rpc identities.v1.IdentitiesService.SubmitSharedWorkspaceSetupConfiguration
	 */
	submitSharedWorkspaceSetupConfiguration: {
		methodKind: "unary";
		input: typeof SubmitSharedWorkspaceSetupConfigurationRequestSchema;
		output: typeof SubmitSharedWorkspaceSetupConfigurationResponseSchema;
	};
	/**
	 * Step 3: sharer reviews and confirms, creating the connection.
	 *
	 * @generated from rpc identities.v1.IdentitiesService.CompleteSharedWorkspaceSetup
	 */
	completeSharedWorkspaceSetup: {
		methodKind: "unary";
		input: typeof CompleteSharedWorkspaceSetupRequestSchema;
		output: typeof CompleteSharedWorkspaceSetupResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.GetSharedWorkspaceSetup
	 */
	getSharedWorkspaceSetup: {
		methodKind: "unary";
		input: typeof GetSharedWorkspaceSetupRequestSchema;
		output: typeof GetSharedWorkspaceSetupResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.CancelSharedWorkspaceSetup
	 */
	cancelSharedWorkspaceSetup: {
		methodKind: "unary";
		input: typeof CancelSharedWorkspaceSetupRequestSchema;
		output: typeof CancelSharedWorkspaceSetupResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.ListSharedWorkspaceSetups
	 */
	listSharedWorkspaceSetups: {
		methodKind: "unary";
		input: typeof ListSharedWorkspaceSetupsRequestSchema;
		output: typeof ListSharedWorkspaceSetupsResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.GetSharedWorkspaceConnection
	 */
	getSharedWorkspaceConnection: {
		methodKind: "unary";
		input: typeof GetSharedWorkspaceConnectionRequestSchema;
		output: typeof GetSharedWorkspaceConnectionResponseSchema;
	};
	/**
	 * @generated from rpc identities.v1.IdentitiesService.ListSharedWorkspaceConnections
	 */
	listSharedWorkspaceConnections: {
		methodKind: "unary";
		input: typeof ListSharedWorkspaceConnectionsRequestSchema;
		output: typeof ListSharedWorkspaceConnectionsResponseSchema;
	};
	/**
	 * Terminates an established connection.
	 *
	 * @generated from rpc identities.v1.IdentitiesService.TerminateSharedWorkspaceConnection
	 */
	terminateSharedWorkspaceConnection: {
		methodKind: "unary";
		input: typeof TerminateSharedWorkspaceConnectionRequestSchema;
		output: typeof TerminateSharedWorkspaceConnectionResponseSchema;
	};
}> = /*@__PURE__*/ serviceDesc(file_identities_v1_identities, 0);
